const messages = {
  pt: {
    translations: {
			contactWhatsappStatus: {
				online: "online",
				typing: "digitando...",
				recording: "gravando áudio...",
				lastSeen: "visto por último {{when}}",
				todayAt: "hoje às {{time}}",
				yesterdayAt: "ontem às {{time}}",
				dateAt: "em {{date}} às {{time}}",
				stories: {
					open: "Ver status",
					close: "Fechar",
					previous: "Status anterior",
					next: "Próximo status",
					loadError: "Não foi possível carregar este status.",
					retry: "Tentar de novo",
				},
			},
			ticketRatings: {
				title: "Avaliações de atendimento",
				subtitle: "Ao finalizar um atendimento, o cliente dá uma nota de 0 a 10. Aqui você acompanha a satisfação da empresa e de cada atendente.",
				disabledNotice: {
					admin: "As avaliações estão desligadas: nenhum pedido de nota está sendo enviado. Ligue na aba Configuração.",
					user: "As avaliações estão desligadas: nenhum pedido de nota está sendo enviado. Peça a um administrador para ligar.",
				},
				tabs: {
					overview: "Painel",
					responses: "Respostas",
					settings: "Configuração",
				},
				filters: {
					from: "Data inicial",
					to: "Data final",
					user: "Atendente",
					connection: "Conexão",
					status: "Situação",
					all: "Todos",
					submit: "Atualizar",
				},
				status: {
					answered: "Respondida",
					no_answer: "Sem resposta",
					waiting: "Aguardando",
				},
				cards: {
					nps: "NPS",
					average: "Nota média",
					averageHint: "numa escala de 0 a {{max}}",
					responseRate: "Taxa de resposta",
					responseRateHint: "{{answered}} de {{sent}} clientes responderam",
					noAnswer: "Sem resposta",
					waitingHint: "{{total}} ainda dentro do prazo",
					noAnswers: "Ainda não há notas neste período.",
				},
				zones: {
					critical: "Crítico",
					improvement: "Aperfeiçoamento",
					quality: "Qualidade",
					excellence: "Excelência",
				},
				groups: {
					promoter: {
						name: "Promotor",
						label: "Promotores (9 e 10)",
						description: "Clientes encantados, que indicariam a empresa.",
					},
					passive: {
						name: "Neutro",
						label: "Neutros (7 e 8)",
						description: "Satisfeitos, mas sem entusiasmo. Não entram na conta do NPS.",
					},
					detractor: {
						name: "Detrator",
						label: "Detratores (0 a 6)",
						description: "Clientes insatisfeitos. Vale abrir a conversa e entender o motivo.",
					},
				},
				howToRead: {
					title: "Como ler as notas",
					subtitle: "Cada resposta de 0 a {{max}} entra em um de três grupos:",
					formula: "NPS = % de promotores − % de detratores. Vai de −100 (todos insatisfeitos) a +100 (todos encantados).",
				},
				npsBlock: {
					title: "Termômetro do NPS",
					subtitle: "NPS {{nps}} — faixa {{zone}}, com base em {{total}} respostas.",
					split: "Como as respostas se dividem",
				},
				charts: {
					distributionTitle: "Quantas vezes cada nota apareceu",
					distributionSubtitle: "Barras à direita (verde) são clientes encantados; à esquerda (vermelho), insatisfeitos.",
					rateAxis: "Nota",
					rateTooltip: "Nota {{rate}}",
					responses: "{{count}} resposta",
					responses_plural: "{{count}} respostas",
					average: "Média",
					timelineTitle: "Nota média por dia",
					timelineSubtitle: "Dias sem resposta ficam sem ponto. Passe o mouse para ver quantas notas houve no dia.",
				},
				ranking: {
					title: "Desempenho por atendente",
					subtitle: "Ordenado pelo NPS. A barra mostra a mistura de promotores, neutros e detratores de cada um.",
					sent: "Pedidos",
					answered: "Respondidas",
					split: "Composição",
				},
				table: {
					user: "Atendente",
					sentAt: "Enviado em",
					contact: "Contato",
					connection: "Conexão",
					rating: "Nota",
					answeredAt: "Respondido em",
					ticket: "Ticket",
					empty: "Nenhuma avaliação neste período.",
				},
				responses: {
					title: "Todas as respostas",
					subtitle: "Cada pedido enviado no período. \"Sem resposta\": o cliente não respondeu com um número dentro do prazo.",
				},
				settings: {
					title: "Pergunta enviada ao cliente",
					enabled: "Enviar a pergunta de avaliação ao finalizar o atendimento",
					message: "Pergunta de avaliação",
					messageHelp: "Peça ao cliente para responder com um número de {{min}} a {{max}}. Use {{firstName}} ou {{name}} para o nome do contato.",
					thanksMessage: "Mensagem de agradecimento",
					thanksMessageHelp: "Enviada depois que o cliente responde com a nota. Deixe em branco para não enviar.",
					windowHours: "Prazo para responder (horas)",
					windowHoursHelp: "De 1 a 168 horas. Depois disso o pedido fica como \"Sem resposta\".",
					save: "Salvar",
					saving: "Salvando...",
					saved: "Configuração de avaliação salva.",
					howItWorks: "Como funciona",
					steps: {
						close: "O atendente finaliza o atendimento no WhatsApp (QR ou API oficial) e o cliente recebe a pergunta pedindo uma nota de {{min}} a {{max}}.",
						reply: "Se ele responder só com o número em até {{hours}} h, a nota fica gravada para o atendente e ele recebe o agradecimento.",
						noReply: "Se não responder, ou escrever outra coisa, nada é gravado: o atendimento aparece como \"Sem resposta\" e a conversa segue normalmente.",
					},
					preview: "Prévia no WhatsApp",
				},
				dashboardColumn: {
					title: "Nota média (0 a 10)",
					hint: "Média das notas de 0 a 10 recebidas no período. Detalhes na tela Avaliações.",
					count: "({{total}})",
				},
			},
			connectionLogs: {
				title: "Logs de conexão — {{name}}",
				subtitle: "Auditoria de eventos da sessão registrados pelo servidor (visível apenas para o suporte)",
				currentState: "Estado atual:",
				chips: {
					database: "banco: {{value}}",
					memory: "memória: {{value}}",
					reconnections: "reconexões: {{value}}",
					code: "cod: {{value}}",
				},
				timeline: "última reconexão: {{lastReconnect}} | próxima tentativa: {{nextRetry}} | último health check: {{lastHealthCheck}}",
				scheduler: "agendador de reconexão (global): fila {{queued}} | snapshot em {{generatedAt}}",
				hideQr: "Ocultar eventos de QR Code",
				totalEvents: "{{count}} evento no total",
				totalEvents_plural: "{{count}} eventos no total",
				empty: "Nenhum evento registrado para esta conexão.",
				user: "usuário: {{name}}",
				reload: "Recarregar",
			},
			contactChat: {
				otherUsers: {
					intro: "Este contato possui {{count}} chamado(s) aberto(s) por outros atendentes:",
					noQueue: "Sem fila",
					attendant: "Atendente",
					assumeThis: "Assumir este chamado",
					assume: "Assumir chamado",
					anotherAttendant: "outro atendente",
					belongsTo: "Chamado pertence a outro atendente ({{name}}).",
					dialogTitle: "Chamados existentes para este contato",
					dialogIntro: "Este contato possui chamado(s) aberto(s) com outro(s) atendente(s). Assuma um chamado para continuar o atendimento.",
					dialogIntroWithNew: "Este contato tem chamado aberto com outro atendente. Assuma o chamado ou abra um novo seu para enviar a mensagem.",
					createNew: "Abrir novo chamado",
				},
				agent: {
					typing: "Agente \"{{name}}\" está digitando...",
					handling: "Chamado está sendo atendido por agente ({{name}}).",
					fallbackName: "Agente #{{id}}",
				},
				connection: "Conexão: {{name}}",
				autoConnection: "Conexão automática (padrão do sistema)",
				errors: {
					connectionNotAssigned: "Este chamado pertence a uma conexão que não está atribuída ao seu usuário.",
					conversationConnectionNotAssigned: "Esta conversa pertence a uma conexão que não está atribuída ao seu usuário.",
					noQueueAccess: "Você não tem acesso à fila deste chamado",
					noQueuelessPermission: "Você não tem permissão para assumir chamados sem fila (allTicket desabilitado).",
				},
				toasts: {
					ticketAssumed: "Chamado assumido com sucesso!",
				},
				connectionTooltip: "Conexão: {{name}} — clique para trocar",
				chooseConnectionTooltip: "Clique para escolher a conexão",
				selectConnection: "Selecionar conexão",
				callConnectionTitle: "Ligar por qual conexão?",
				thisConnection: "esta conexão",
				groupElsewhere: "Grupo em atendimento na conexão {{connection}} (#{{id}}) — ao enviar por {{target}} o chamado será movido.",
				history: {
					viewAll: "Ver todas as mensagens",
					selectTicket: "Selecione um ticket",
					ticketOption: "Ticket #{{id}} • {{status}}",
					status: {
						open: "Atendendo",
						pending: "Aguardando",
						closed: "Resolvido",
					},
				},
				templatePicker: {
					title: "Enviar Template de Mensagem",
					description: "Conexão via API Oficial (Cloud API). Envie um template de mensagem aprovado para iniciar a conversa.",
					noTemplates: "Nenhum modelo de mensagem aprovado encontrado. Crie e submeta templates para aprovação na página de Templates.",
					selectTemplate: "Selecione um modelo",
					preview: "Pré-visualização:",
					emptyBody: "(Sem texto no corpo)",
					variables: "Variáveis:",
					variable: "Variável",
					send: "Enviar",
					sending: "Enviando...",
					sent: "Template enviado com sucesso!",
				},
			},
			tagsContainer: {
				placeholder: "Tags do Ticket",
			},
			connectionDisconnectedBanner: {
				message: "A conexão \"{{name}}\" deste chamado está desconectada. As respostas não serão enviadas até ela reconectar ou o chamado ser transferido para outra conexão.",
			},
			sentMessageOrigin: {
				labels: {
					campaign: "Campanha",
					schedule: "Agendamento",
					external: "Envio externo",
				},
				noTicket: {
					campaign: "Mensagem de campanha enviada em {{date}} (sem chamado)",
					schedule: "Mensagem agendada enviada em {{date}} (sem chamado)",
					external: "Envio externo em {{date}} (sem chamado)",
				},
			},
			messagePreview: {
				received: "Recebido",
				image: "Imagem",
				video: "Vídeo",
				audio: "Áudio",
				file: "Arquivo",
				sticker: "Figurinha",
				location: "Localização",
				contacts: "Vários contatos",
				contactSent: "Contato enviado: {{name}}",
				catalogProduct: "🛍️ Produto do catálogo",
				orderReceived: "🛒 Pedido recebido",
				externalMessage: "Mensagem enviada externamente",
				reaction: "Reação",
				deleted: "Mensagem apagada",
				withoutContent: "Mensagem sem conteúdo",
				noMessages: "Sem mensagens",
			},
			sessionStatusIndicator: {
				extended: "Sessão Prolongada",
				minutes: "{{minutes}}min",
				expiresIn: "Sessão expira em {{minutes}} minutos",
				noExpiry: "Sessões configuradas para não expirar automaticamente",
			},
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          acceptTermsPrefix: "Li e aceito os",
          acceptTermsLink: "Termos e Condições de Uso",
          acceptTermsRequired: "É preciso aceitar os Termos para se cadastrar",
          phone: "Telefone com (DDD)",
          planOption: "{{name}} - Atendentes: {{users}} - WhatsApp: {{connections}} - Filas: {{queues}} - R$ {{value}}",
          freeTrial: "1º mês grátis! A cobrança do plano escolhido começa apenas no segundo mês.",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
        validation: {
          planRequired: "Selecione um plano",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
          showHidePassword: "Mostrar/ocultar senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Registre-se, agora mesmo!",
        },
        licenseBlocked: {
          title: "Acesso bloqueado: a licença de uso desta empresa não é válida.",
          reason: "Motivo: {{reason}}",
          contact: "Entre em contato com a Empsis para regularizar a licença.",
        },
        sessionExpired: "Sua sessão expirou. Por favor, faça login novamente.",
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          queues: "Filas",
          value: "Valor",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          integrations: "Integrações",
          whatsappQr: "WhatsApp via QR Code",
        },
        newPlan: "Novo Plano",
        restricted: {
          message: "Apenas o usuário administrador principal pode gerenciar planos.",
        },
        toasts: {
          saveError: "Não foi possível realizar a operação. Verifique se já existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
          subscriptionBlocked: "Opss! Sua assinatura venceu {{date}}. Regularize o pagamento para voltar a usar o sistema.",
          subscriptionExpiresInOneDay: "Sua assinatura vence em {{days}} dia",
          subscriptionExpiresInDays: "Sua assinatura vence em {{days}} dias",
          subscriptionExpired: "Sua assinatura venceu {{date}}. Regularize para evitar o bloqueio.",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
          createdTickets: "Atendimentos Criados: {{total}}",
          ticketsAxis: "Tickets",
          conversations: {
            chartTitle: "Gráfico de Conversas",
            total: "Total ({{total}})",
            start: "Início",
            end: "Fim",
            hourRange: "Das {{hour}}:00 às {{hour}}:59",
            loadError: "Erro ao buscar informações dos tickets",
          },
          conversationsByUser: {
            title: "Total de Conversas por Usuários",
            chartTitle: "Gráfico de Conversas",
            dataset: "Conversas",
            loadError: "Erro ao obter informações da conversa",
          },
          messagesByUser: {
            title: "Mensagens por Usuário",
            chartTitle: "Mensagens por Usuário (Recebidas × Enviadas)",
            received: "Recebidas",
            sent: "Enviadas",
            loadError: "Erro ao obter informações de mensagens por usuário",
          },
          messagesPerDay: {
            title: "Mensagens por Dia",
            chartTitle: "Gráfico de Mensagens por Dia",
            loadError: "Erro ao obter informações de mensagens por dia",
          },
          ticketsPerDay: {
            title: "Dias de Atendimentos",
            chartTitle: "Gráfico de Dias de Atendimentos",
            loadError: "Erro ao obter informações dos dias de atendimentos",
          },
          ticketsPerHour: {
            title: "Horários de Atendimentos",
            chartTitle: "Gráfico de Horários de Atendimentos",
            loadError: "Erro ao obter informações dos horários de atendimentos",
          },
          ticketsPerWeekDay: {
            title: "Atendimentos por Dia da Semana",
            chartTitle: "Gráfico de Atendimentos por Dia da Semana",
            loadError: "Erro ao obter informações dos atendimentos por dia da semana",
          },
          volume: {
            low: "Menor volume",
            mid: "Volume médio",
            high: "Maior volume",
          },
          weekDayShort: {
            sun: "Dom",
            mon: "Seg",
            tue: "Ter",
            wed: "Qua",
            thu: "Qui",
            fri: "Sex",
            sat: "Sáb",
          },
        },
        conversions: {
          title: "Conversões",
          chartTitle: "Conversões (Sim × Não)",
          yes: "Sim",
          no: "Não",
          totalTickets: "Total de Tickets",
          totalConversions: "Total de Conversões",
          conversionRate: "Percentual de Conversão",
          notApplicable: "Não aplicável",
          dialog: {
            title: "Convertido?",
            message: "Este atendimento resultou em conversão?",
            yes: "Sim",
            no: "Não",
            notApplicable: "Não aplicável",
            cancel: "Cancelar",
          },
          loadError: "Erro ao obter informações de conversões",
        },
        noInteraction: {
          cardTitle: "Finalizados sem interação",
          chartTitle: "Finalizados sem interação por atendente",
          subtitle: "Chamados finalizados pelo atendente sem nenhuma mensagem enviada ao contato.",
          empty: "Nenhum chamado finalizado sem interação no período.",
          total: "Total no período",
          user: "Atendente",
          quantity: "Quantidade",
          detailsTitle: "Chamados finalizados sem interação",
          view: "Ver",
          close: "Fechar",
          table: {
            ticket: "Chamado",
            contact: "Contato",
            queue: "Fila",
            connection: "Conexão",
            user: "Atendente",
            closedAt: "Finalizado em",
            open: "Abrir",
          },
        },
        ticketsByContactTag: {
          title: "Chamados por tag do contato",
          chartTitle: "Chamados abertos por tag do contato",
          subtitle: "{{total}} chamados abertos no período · {{untagged}} sem tag",
          multiTagNote: "Um chamado conta em todas as tags do contato, então a soma das tags pode passar do total.",
          topNote: "O gráfico mostra as {{count}} tags com mais chamados; a tabela lista todas.",
          loadError: "Erro ao obter os chamados por tag do contato",
          tag: "Tag",
          quantity: "Quantidade",
          percent: "% do total",
          untagged: "Sem tag",
          view: "Ver",
          close: "Fechar",
          detailsTitle: "Chamados da tag",
          detailsTitleUntagged: "Chamados de contatos sem tag",
          detailsEmpty: "Nenhum chamado encontrado.",
          showingLimit: "Exibindo os {{shown}} mais recentes de {{total}}.",
          status: {
            open: "Atendendo",
            pending: "Aguardando",
            closed: "Finalizado",
            group: "Grupo",
          },
          table: {
            ticket: "Chamado",
            contact: "Contato",
            queue: "Fila",
            connection: "Conexão",
            user: "Atendente",
            status: "Status",
            openedAt: "Aberto em",
            open: "Abrir",
          },
        },
        filters: {
          title: "Filtros",
          invalid: "Parametrize o filtro",
        },
        cards: {
          inConversation: "Em Conversa",
          waiting: "Aguardando",
          finished: "Finalizados",
          newContacts: "Novos Contatos",
          medianConversation: "Mediana de Conversa",
          medianWait: "Mediana de Espera",
        },
        attendantsTable: {
          avgSupportTime: "T.M. de Atendimento",
          currentStatus: "Status (Atual)",
        },
      },
      connections: {
				subscription: {
					subscribed: "Inscrito",
					pending: "Pendente",
				},
				typeTooltips: {
					cloudapi: "API Oficial Meta",
					email: "Canal Email (POP3/IMAP + SMTP)",
					sms: "Canal SMS",
					baileys: "Baileys (Não-Oficial)",
					publicLink: "Link público / apelido personalizado",
				},
				publicLink: {
					title: "Link público",
					titleWithName: "Link público — {{name}}",
					defaultLink: "Link público padrão desta conexão:",
					nicknameHelp: "Apelido personalizado (link curto). Deixe em branco para remover.",
					nicknamePlaceholder: "ex.: sniperCMS",
					nicknameRules: "3 a 50 caracteres: letras, números, '-' ou '_'.",
					activeLink: "Link personalizado ativo:",
					copy: "Copiar",
					saveNickname: "Salvar apelido",
				},
        title: "Conexões",
        toasts: {
					instagramConnected: "Instagram conectado com sucesso!",
					instagramConnectedAs: "Instagram conectado (@{{username}}) com sucesso!",
					instagramFailed: "Falha ao conectar o Instagram: {{reason}}",
					instagramSubscribed: "Webhooks do Instagram assinados com sucesso!",
					instagramSubscribeFailed: "A Meta recusou a assinatura dos webhooks. Tente reconectar o Instagram.",
					unknownError: "erro desconhecido",
					subscribed: "Conexão inscrita com sucesso!",
					linkCopied: "Link copiado!",
					publicLinkCopied: "Link público copiado!",
					customLinkCopied: "Link personalizado copiado!",
					nicknameSaved: "Apelido salvo!",
					nicknameRemoved: "Apelido removido.",
					instagramAuthUrlMissing: "URL de autorização do Instagram não recebida.",
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
          deletedByType: {
            cloudapi: "Conexão com o WhatsApp (API Oficial) excluída com sucesso!",
            email: "Conexão de e-mail excluída com sucesso!",
            sms: "Conexão de SMS excluída com sucesso!",
            instagram: "Conexão com o Instagram excluída com sucesso!",
          },
        },
        alerts: {
          offline:
            "A conexão {{name}} está fora do ar. Suas mensagens podem não ser enviadas nem recebidas — avise o administrador do sistema.",
          offlineManager:
            "A conexão {{name}} está fora do ar. Abra o menu Conexões para reconectar.",
          offlineMultiple:
            "{{total}} conexões estão fora do ar ({{names}}). Suas mensagens podem não ser enviadas nem recebidas — avise o administrador do sistema.",
          offlineMultipleManager:
            "{{total}} conexões estão fora do ar ({{names}}). Abra o menu Conexões para reconectar.",
          recovered: "A conexão {{name}} voltou a funcionar.",
          ack: "OK",
          dismiss: "Fechar aviso",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
					emailChannel: "Canal Email",
					smsChannel: "Canal SMS",
					reconnectInstagram: "Reconectar Instagram",
					instagramSubscribe: "Assinar webhooks",
					instagramConnected: "Conectado",
					subscribe: "Inscrever",
					subscribing: "Inscrevendo...",
					subscribed: "Inscrito",
          add: "Adicionar Conta",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          DISCONNECTED: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          CONNECTED: {
            title: "Conexão estabelecida!",
          },
          instagramReconnect: {
            title: "Token do Instagram expirado ou revogado",
            content: "Clique em 'Reconectar Instagram' e faça o login na conta para voltar a enviar e receber mensagens",
          },
          instagramSubscribe: {
            title: "Webhooks do Instagram não assinados",
            content: "As mensagens podem não chegar. Clique em 'Assinar webhooks' para corrigir",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
					number: "Número",
					type: "Tipo",
					subscription: "Inscrição",
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
				connectionType: {
					title: "Tipo de Conexão",
					fixed: "Tipo de Conexão: {{type}}",
					baileys: "API Não-Oficial (Baileys)",
					cloudapi: "API Oficial (Meta)",
					email: "Canal Email (POP3/IMAP + SMTP)",
					desc: {
						baileys: "Conexão via QR Code usando a biblioteca Baileys. Não requer conta Business.",
						cloudapi: "API oficial da Meta/WhatsApp Business. Requer credenciais da Meta Business Platform.",
						email: "Canal de envio e recebimento de emails via POP3 ou IMAP (recebimento) e SMTP (envio) para abertura e resposta de chamados.",
						instagram: "Direct e comentários do Instagram via API oficial. Conecte sua conta profissional pelo login facilitado abaixo.",
						sms: "Disparo de SMS via gateway (Witi.me, SMS Barato ou SMSDev). Canal somente de envio (campanhas) — não recebe respostas.",
					},
				},
				instagram: {
					title: "Conexão do Instagram",
					connectedAccount: "Conta conectada:",
					description: "Conecte sua conta profissional do Instagram para receber e responder Direct e comentários. Clique no botão abaixo, faça login e autorize — a conexão é criada automaticamente.",
					notConfigured: "O aplicativo da Meta não está configurado neste servidor. Contate o suporte.",
					connect: "Conectar Instagram",
					reconnect: "Reconectar Instagram",
					redirecting: "Redirecionando...",
				},
				kanban: {
					title: "Criação Automática de Cards no Kanban",
					description: "Configure se esta conexão deve criar automaticamente cards no Kanban quando novos atendimentos forem iniciados.",
					enable: "Habilitar criação automática de cards",
					board: "Board de Destino",
					boardPlaceholder: "Selecione um board",
					boardHelp: "Board onde os cards serão criados",
					column: "Coluna de Destino",
					columnPlaceholder: "Selecione uma coluna",
					columnHelp: "Coluna onde os cards serão criados",
					user: "Usuário Responsável (opcional)",
					userHelp: "Usuário que será vinculado aos cards criados automaticamente",
					prerequisiteLabel: "Pré-requisito:",
					prerequisiteText: "O board selecionado precisa ter o campo personalizado \"ticketId\" configurado para que a criação automática funcione.",
					loadColumnsError: "Erro ao carregar colunas do board",
				},
				cloudApi: {
					title: "Configuração da API Oficial (Meta Cloud API)",
					appNotConfigured: "O aplicativo da Meta não está configurado neste servidor, então o login facilitado está indisponível. Contate o suporte ou preencha os dados manualmente abaixo.",
					quickTitle: "Conexão Rápida",
					quickDescription: "Cadastre um número novo na API oficial: faça login no Facebook e autorize o acesso. O número deixa de funcionar no app do celular; para manter o app, use a opção acima.",
					connect: "Conectar WhatsApp",
					connecting: "Conectando...",
					coexistence: {
						title: "WhatsApp Business do celular",
						description: "Use na API oficial o número que já está no app WhatsApp Business do celular. O app continua funcionando e as mensagens aparecem nos dois lugares.",
						connect: "Conectar WhatsApp Business do celular",
						limits: {
							groups: "Grupos não passam pela API: só conversas individuais.",
							calls: "Sem ligações pela API neste número.",
							inactivity: "Abra o app no celular pelo menos a cada 14 dias, ou a Meta desconecta o número.",
							pricing: "O que for enviado pelo app continua grátis; pela API é cobrado pela Meta.",
							history: "A agenda e até 180 dias de conversas do celular são importados uma vez; as conversas antigas entram como chamados finalizados.",
							appVersion: "Precisa do app WhatsApp Business 2.24.17 ou mais novo (o WhatsApp comum não serve).",
						},
						status: {
							title: "Número também no app WhatsApp Business do celular",
							inactivityReminder: "Abra o app no celular pelo menos a cada 14 dias, ou a Meta desconecta o número.",
							contactsLabel: "Agenda do celular:",
							historyLabel: "Histórico do celular:",
							disconnectedLabel: "Desconectado:",
							contactsReceived: "{{count}} contato(s) importado(s).",
							historyImporting: "importando, {{percent}}% ({{count}} mensagens até agora).",
							historyDone: "importado ({{count}} mensagens, em chamados finalizados).",
							historyDeclined: "o dono recusou compartilhar o histórico no app do celular.",
							waiting: "pedido à Meta, aguardando o envio.",
							notRequested: "será pedido à Meta ao salvar a conexão.",
							failed: "a Meta recusou o pedido ({{error}}). Salve a conexão para tentar de novo.",
							expired: "o prazo de 24h da Meta para importar passou.",
						},
					},
					selectNumber: "Selecione o número que deseja conectar:",
					wabaConflictTitle: "Este número está em {{count}} contas do WhatsApp Business na Meta",
					wabaConflictHelp: "A Meta informa uma conta no login, mas o número pode enviar (e cobrar) por outra. Escolha abaixo a conta por onde ele envia: normalmente a que já tem conexão no CRM ou templates aprovados. Na conta errada, os templates criados aqui não são encontrados no envio (erro 132001 da Meta).",
					wabaSuggested: "conta sugerida",
					wabaHasConnection: "já usada em outra conexão",
					wabaApprovedTemplates: "{{count}} template(s) aprovado(s)",
					orManual: "ou configure manualmente",
					hideManual: "Ocultar campos manuais",
					showManual: "Mostrar campos manuais",
					phoneNumberIdHelp: "ID do número no Meta Business (ex: 123456789012345)",
					wabaIdHelp: "ID da conta WhatsApp Business",
					validate: "Validar Credenciais",
					valid: "Válido",
					invalid: "Inválido",
					result: {
						number: "Número:",
						verifiedName: "Nome Verificado:",
						quality: "Qualidade:",
						account: "Conta:",
					},
					credentialsSet: "Credenciais configuradas",
					appCredentialsLabel: "Credenciais do app da Meta:",
					appCredentialsText: "são configuradas uma única vez no servidor. Enquanto isso não é feito, dá para preenchê-las na aba \"Cloud API\" em \"Configurações\".",
					toasts: {
						valid: "Conexão válida! Número: {{phone}} - {{name}}",
						invalid: "Credenciais inválidas: {{error}}",
						validateError: "Erro ao validar credenciais",
						communicationError: "Erro de comunicação",
						signupUnavailable: "Login facilitado indisponível: o aplicativo da Meta não está configurado no servidor. Contate o suporte.",
						processing: "Processando autorização... Aguarde.",
						signupError: "Erro no Embedded Signup",
						connectedReview: "WhatsApp conectado com sucesso! Revise os dados e clique em Salvar.",
						connectedNumber: "WhatsApp conectado! Número: {{phone}} ({{name}}). Clique em Salvar.",
						authorizedSelect: "Autorização concluída! Selecione o número que deseja conectar.",
						authorizedNoNumber: "Autorização concluída, mas nenhum número foi encontrado.",
						wabaConflict: "Este número está em {{count}} contas da Meta. Confira a conta sugerida antes de salvar.",
						timeout: "A Meta demorou demais para responder. A conta pode ter sido criada — feche e reabra esta tela antes de tentar de novo.",
						processError: "Erro ao processar Embedded Signup",
						cancelled: "Embedded Signup cancelado",
						numberSelected: "Número selecionado: {{phone}} ({{name}})",
					},
				},
				sms: {
					title: "Configuração do Gateway de SMS ({{provider}})",
					provider: "Provedor de SMS",
					providers: {
						witime: "Witi.me — ideal para grandes volumes",
						smsbarato: "SMS Barato — ideal para volumes menores",
						smsdev: "SMSDev — ideal para volumes menores",
					},
					apiKey: "Chave da API (chave)",
					apiKeyCurrent: "Chave atual: {{hint}}. Deixe em branco para manter a chave atual.",
					apiKeyHelpWitime: "Disponível no painel do Witi.me em SMS > Configurações de SMS.",
					apiKeyHelp: "Disponível no painel do {{provider}}.",
					apiKeyMissing: "Informe a chave da API do gateway de SMS.",
					showHideApiKey: "Mostrar/ocultar chave da API",
					route: "Rota",
					routeHelp: "Opcional. Vazio usa a rota padrão da conta.",
					sendType: "Tipo de Envio",
					sendTypes: {
						common: "Comum (marketing / P2P)",
						token: "Token (OTP)",
						debug: "Debug (simulação, não cobra)",
					},
					reference: "Referência",
					referenceHelp: "Identificação dos envios no painel do {{provider}}.",
					webhookUrl: "URL de Webhook (DLR)",
					showHideWebhook: "Mostrar/ocultar URL de webhook",
					copyWebhook: "Copiar URL de webhook",
					webhookCopied: "URL de webhook copiada.",
					webhookCopyError: "Não foi possível copiar a URL.",
					webhookHelp: "Cadastre esta URL no painel do Witi.me para receber a confirmação de entrega das campanhas. Ela contém um token secreto — use o botão de copiar.",
					webhookAfterSave: "A URL de webhook para confirmação de entrega será exibida aqui após salvar a conexão.",
					baseUrl: "URL do sistema",
					baseUrlHelp: "Opcional. Cada conta usa um endereço próprio (sistemaNN) — confirme o seu com o suporte do SMS Barato.",
					smsbaratoNote: "O SMS Barato não aceita acentos nem quebras de linha (convertidos automaticamente no envio) e limita cada mensagem a 160 caracteres. A confirmação de entrega é consultada automaticamente — não há webhook para cadastrar.",
					smsdevNote: "O SMSDev não entrega acentuação, então os acentos são convertidos automaticamente no envio (ação → acao); quebras de linha são mantidas. Mensagens longas consomem 1 crédito a cada 160 caracteres. A confirmação de entrega é consultada automaticamente — não há webhook para cadastrar.",
				},
				email: {
					title: "Configuração do Canal de Email",
					user: "Usuário Email",
					password: "Senha Email",
					passwordKeep: "Deixe em branco para manter a senha atual.",
					showHidePassword: "Mostrar/ocultar senha do email",
					fromName: "Nome do Remetente",
					inboundProtocol: "Protocolo de recebimento",
					pop3Suggested: "POP3 (sugerido)",
					host: "Servidor {{protocol}}",
					port: "Porta {{protocol}}",
					deleteAfterFetch: "Apagar do servidor após baixar",
					deleteAfterFetchHelp: "Desligado: as mensagens permanecem no servidor e continuam visíveis no seu cliente de email; o CRM controla o que já foi importado. Ligado: cada email importado é apagado da caixa.",
					mailbox: "Caixa Postal",
					test: "Testar conexão {{protocol}}/SMTP",
					result: {
						ok: "Conexão validada",
						partial: "Validação parcial",
						failed: "Falha na validação",
						statusFailed: "Falhou",
						noDetails: "Sem detalhes",
					},
					toasts: {
						missingFields: "Preencha usuário/senha de email e servidores {{protocol}}/SMTP.",
						missingFieldsTest: "Preencha usuário/senha de email e servidores {{protocol}}/SMTP antes de testar.",
						missingServer: "Preencha usuário, senha e servidor {{protocol}}",
						validated: "Conexão {{protocol}}/SMTP validada com sucesso.",
						partialDetail: "Validação parcial: {{protocol}}: {{inbound}} | SMTP: {{smtp}}",
						failedShort: "falhou",
						partial: "Validação parcial da conexão de email.",
						failed: "Falha ao validar conexão de email.",
						testFailed: "Falha ao testar {{protocol}}",
					},
				},
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
		 tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "Avaliações",
          integrations: "Integrações",
          schedules: "Horário de expediente",
		 },
        form: {
					timeToTransfer: "Transferir após x (minutos)",
					transferQueue: "Fila de Transferência",
					showHideToken: "Mostrar/ocultar token",
					tokenCurrent: "Token atual: {{hint}}. Deixe em branco para manter o token atual.",
					removeToken: "Remover token",
					undoRemoveToken: "Desfazer remoção",
					tokenWillBeRemoved: "O token será removido ao salvar; integrações que usam este token deixarão de funcionar.",
          name: "Nome",
          default: "Padrão",
          onlineWhileViewing: "Mostrar \"digitando\" e \"online\" do contato",
          onlineWhileViewingHelp: "O número aparece online enquanto houver atendente com o FaleCRM aberto. Nesse período o celular não notifica as mensagens.",
          sendIdQueue: "Fila",
          timeSendQueue: "Redirecionar para fila em X minutos",
          queueRedirection: "Redirecionamento de Fila",
		  outOfHoursMessage: "Mensagem de fora de expediente",
          queueRedirectionDesc: "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          prompt: "Prompt",
          //maxUseBotQueues: "Enviar bot x vezes",
          //timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
		  greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
        successByType: {
          cloudapi: "Conexão com o WhatsApp (API Oficial) salva com sucesso.",
          email: "Conexão de e-mail salva com sucesso.",
          sms: "Conexão de SMS salva com sucesso.",
          instagram: "Conexão com o Instagram salva com sucesso.",
        },
      },
      qrCode: {
				title: "Utilize o seu WhatsApp:",
				methodPhone: "Número de telefone",
				generatingQr: "Gerando QR Code...",
				qrSteps: {
					one: "1 - Abra o WhatsApp no seu celular",
					two: "2 - Toque em Mais opções no Android ou em Configurações no iPhone",
					three: "3 - Toque em Dispositivos conectados e, em seguida, em Conectar um dispositivo",
					four: "4 - Aponte seu celular para essa tela para capturar o QR Code",
					hint: "Se o QR Code expirar, clique em \"Gerar Novo QR-Code\".",
				},
				phoneSteps: {
					one: "1 - Informe o número (DDI + DDD + número) e clique em \"Gerar código\".",
					two: "2 - No celular, abra WhatsApp → Dispositivos conectados → Conectar um dispositivo",
					three: "3 - Toque em \"Conectar com número de telefone\"",
					four: "4 - Digite o código de 8 dígitos exibido ao lado",
					hint: "Use apenas dígitos no número, com DDI. Ex.: 5511999998888.",
				},
				error: {
					title: "Falha ao conectar",
					message: "Não foi possível estabelecer conexão com o WhatsApp.",
					retry: "Tentar Novamente",
				},
				cooldown: {
					title: "Muitas tentativas de conexão",
					message: "Para proteger seu número contra bloqueio do WhatsApp, a geração de QR Code foi pausada. Ela volta sozinha em aproximadamente",
					at: "(às {{time}}).",
					hint: "Se preferir, tente agora — mas evite gerar muitos QR Codes seguidos sem escanear.",
					retry: "Tentar agora",
				},
				expired: {
					title: "QR Code expirado.",
					message: "Clique abaixo para gerar um novo QR Code.",
					retry: "Gerar Novo QR-Code",
				},
				pairing: {
					enterCode: "Digite este código no seu WhatsApp:",
					number: "Número:",
					newCode: "Gerar novo código",
					phoneLabel: "Número com DDI",
					generate: "Gerar código",
					generating: "Gerando...",
					invalidNumber: "Informe o número com DDI + DDD + número (ex.: 5511999998888).",
				},
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
		  deletedAll: "Todos contatos excluídos com sucesso!",
          exportEmpty: "Nenhum contato para exportar com a busca atual.",
          exportLimited: "Exportação limitada a 5.000 contatos. Refine a busca para exportar o restante.",
        },
        exportMenu: {
          xlsx: "Exportar XLSX",
          csv: "Exportar CSV",
        },
		  searchPlaceholder: "Pesquisar...",
          confirmationModal: {
          deleteTitle: "Deletar ",
          deleteAllTitle: "Deletar Todos",
          importTitle: "Importar contatos",
          deleteMessage: "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          deleteAllMessage: "Tem certeza que deseja deletar todos os contatos? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importar todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contatos",
          delete: "Excluir Todos Contatos"
        },
        importModal: {
          title: "Importar contatos",
          optionConnection: "Da conexão WhatsApp",
          optionFile: "De arquivo (CSV/XLS/XLSX)",
          message: "Escolha de qual conexão WhatsApp conectada importar os contatos. Os contatos serão criados com os nomes salvos no celular.",
          selectLabel: "Conexão WhatsApp",
          importing: "Importando contatos... isso pode demorar um pouco se houver muitos contatos.",
          noConnection: "Nenhuma conexão de WhatsApp está conectada no momento. Conecte um número na página de conexões primeiro.",
          success: "Importação concluída: {{total}} contatos lidos do celular — {{imported}} novos, {{updated}} atualizados.",
          partialWarning: "Não foi possível baixar a agenda completa do celular agora. Foram processados só os {{total}} contatos recebidos desde o último reinício do servidor ({{imported}} novos, {{updated}} atualizados) — contatos podem ter ficado de fora. Tente de novo em alguns minutos ou importe por planilha.",
          fileMessage: "Envie uma planilha CSV, XLS ou XLSX com as colunas do modelo abaixo. Preencha \"numero\" ou \"email\" — as demais colunas são opcionais e podem ficar em branco.",
          downloadTemplateXlsx: "Baixar modelo XLSX",
          downloadTemplateCsv: "Baixar modelo CSV",
          selectFile: "Selecionar arquivo",
          noFileSelected: "Nenhum arquivo selecionado",
          uploading: "Importando planilha... isso pode demorar um pouco se houver muitos contatos.",
          fileSuccess: "Importação concluída: {{imported}} novos, {{updated}} atualizados, {{skipped}} ignorados, {{errors}} erros.",
          notValidatedWarning: "Os números foram importados sem verificação no WhatsApp (nenhuma conexão ativa disponível).",
          invalidNumbersInfo: "{{count}} números não foram encontrados no WhatsApp, mas foram importados mesmo assim.",
          closeAfterImport: "Fechar",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
        linkedCliente: "Vinculado ao cliente: {{name}}",
        connectionTooltip: {
          selected: "Conexão: {{name}}",
          selectedFallback: "Selecionada",
          select: "Selecionar conexão para novos tickets",
        },
        linkModal: {
          contactLabel: "Contato: {{name}}",
          linkType: "Tipo de vínculo",
          existingCliente: "Cliente existente",
          newCliente: "Novo cliente",
          searchHelper: "Digite nome, e-mail, CPF ou CNPJ",
          newClienteInfo: "Ao continuar, a tela de novo cliente será aberta com nome, celular e e-mail do contato já preenchidos.",
          selectCliente: "Selecione um cliente para vincular",
          invalidContact: "Contato inválido para vinculação",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",   
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
        languages: {
          ptBR: "Português",
          en: "Inglês",
          es: "Espanhol",
        },
      },
	  sideMenu: {
            name: "Menu Lateral Inicial",
            note: "Se habilitado, o menu lateral irá iniciar fechado",
            options: {
              enabled: "Aberto",
              disabled: "Fechado",
            },
          },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
          aiHubAgentId: "AI Hub Agent ID",
          aiHubBaseUrl: "AI Hub Base URL",
          aiHubWebhookUrl: "AI Hub Webhook URL",
          integrateHumanMessages: "Integrar mensagens humanas",
          integrateHumanMessagesTooltip: "Quando habilitado, o sistema envia para o IAHub as mensagens trocadas entre cliente e atendente humano para manter o contexto antes da IA assumir.",
          signMessage: "Assinar respostas com o nome do agente",
          signMessageTooltip: "Quando habilitado, as respostas da IA chegam ao cliente assinadas com o nome do agente na primeira linha, igual às mensagens assinadas pelos atendentes. Desligado, a resposta sai sem assinatura.",
          aiHubAgentIdHelper: "ID do agente no AI Hub (obrigatório)",
          aiHubBaseUrlLabel: "URL Base do AI Hub",
          aiHubBaseUrlHelper: "URL base do hub de IA. Se vazio, usa AI_HUB_BASE_URL do servidor",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Agente de IA",
          edit: "Editar Agente de IA",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        validation: {
          nameTooShort: "Nome muito curto! Mínimo de 5 caracteres.",
          nameTooLong: "Nome muito longo! Máximo de 100 caracteres.",
          nameRequired: "Nome é obrigatório",
          agentIdRequired: "AI Hub Agent ID é obrigatório",
          invalidBaseUrl: "Deve ser uma URL válida iniciando com http:// ou https://",
        },
        test: {
          title: "Testar Agente",
          subtitle: "Usa a configuração salva do agente",
          emptyTitle: "Teste seu agente aqui!",
          emptyHint: "Envie uma mensagem para iniciar a conversa",
          openAttachment: "Abrir anexo",
          attachTooltip: "Anexar imagem ou áudio (o texto digitado vai como legenda)",
          inputPlaceholder: "Digite sua mensagem...",
          processingError: "Desculpe, ocorreu um erro ao processar sua solicitação. Por favor, tente novamente.",
        },
        logs: {
          title: "Logs de Teste — Hub de IA",
          subtitle: "Requisições enviadas e callbacks recebidos do chat de teste deste agente, em tempo real",
          empty: "Nenhum log registrado ainda.",
          emptyHint: "Envie uma mensagem pelo chat de teste de um agente para gerar logs.",
          sent: "ENVIADO",
          received: "RECEBIDO",
          error: "Erro",
          response: "Resposta",
          clear: "Limpar Logs",
          reload: "Recarregar",
        },
      },
      prompts: {
        title: "Agentes de IA",
        humanCooldown: {
          title: "Pausa da IA após resposta do atendente",
          helper:
            "Vale para todos os agentes. Assim que um atendente responde — pelo FaleCRM ou direto pelo celular — a IA fica em silêncio nesse chamado por este tempo. Use 0 para desligar a pausa.",
          label: "Minutos",
          save: "Salvar",
          saved: "Tempo de pausa salvo!",
          invalid: "Informe um número de minutos igual ou maior que zero.",
        },
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          agentId: "Agent ID",
          integrateHumanMessages: "Integra mensagens humanas",
          aiHub: "AI Hub",
          aiHubTooltip: {
            enabled: "AI Hub ativo - Clique para desativar",
            disabled: "AI Hub desativado - Clique para ativar (configure o Agent ID primeiro)",
          },
          actions: "Ações",
        },
        integrations: {
          enabled: "Sim",
          disabled: "Não",
        },
        toasts: {
          aiHubEnabled: "AI Hub ativado com sucesso!",
          aiHubDisabled: "AI Hub desativado com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Agente de IA",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
          editGroup: "Editar grupo",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          whatsapp: "Conexão Origem: ",
          tags: "Tags do contato",
          tagsPlaceholder: "Tags",
          numberHelper: "Brasileiro: DDD + número. Estrangeiro: use + e o código do país (ex.: +1 415 555 2671)",
          emailPlaceholder: "Endereço de e-mail",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        warnings: {
          whatsappValidationSkipped:
            "Contato salvo, mas o número não pôde ser validado no WhatsApp: nenhuma conexão WhatsApp conectada. Para campanhas de SMS a validação não é necessária.",
        },
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          ratingMessage: "Mensagem de avaliação",
          token: "Token",
          orderQueue: "Ordem da fila (Bot)",
          integrationId: "Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        tabs: {
          data: "Dados da Fila",
          schedules: "Horários de Atendimento",
        },
        toasts: {
          saved: "Fila salva com sucesso",
          schedulesPending: "Clique em salvar para registrar as alterações",
        },
      },
      deleteAccountModal: {
        title: "Excluir minha conta",
        intro:
          "Esta ação é permanente. Confira o que acontece ao excluir sua conta:",
        userScope: {
          access: "Seu acesso ao sistema será encerrado imediatamente.",
          tickets: "Seus atendimentos em aberto voltarão para a fila.",
        },
        companyScope: {
          intro:
            "Você é o único administrador: a conta da empresa será encerrada junto.",
          company: "A empresa {{companyName}} será desativada.",
          users: "{{total}} outro(s) usuário(s) perderão o acesso.",
          connections:
            "{{total}} conexão(ões) de WhatsApp serão desconectadas.",
          subscription: "A assinatura recorrente será cancelada.",
          history:
            "O histórico de atendimentos é mantido de forma anonimizada; e-mail, nome da empresa e CNPJ ficam liberados para um novo cadastro.",
        },
        passwordLabel: "Confirme sua senha",
        acknowledge: "Entendo que esta ação não pode ser desfeita.",
        buttons: {
          cancel: "Cancelar",
          confirm: "Excluir minha conta",
        },
        toasts: {
          success: "Conta excluída com sucesso.",
        },
        loginBanner: "Sua conta foi excluída com sucesso.",
      },
      userModal: {
        deleteAccount: {
          title: "Excluir minha conta",
          hint:
            "Ao excluir sua conta, seu acesso ao sistema será encerrado. Esta ação não pode ser desfeita.",
          button: "Excluir minha conta",
        },
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          whatsapps: "Conexões que o usuário controla",
          salesGoal: "Meta de Vendas",

          allTicket: "Ticket Sem Fila [Invisível]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Desabilitado",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          PENDENTE: "Mensagem Pendente",
          AGENDADA: "Mensagem Agendada",
          ENVIADA: "Mensagem Enviada",
          ERRO: "Erro de Envio",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          signMessage: "Assinar mensagem",
          whatsapp: "Conexão para envio *",
          whatsappPlaceholder: "Selecione uma conexão",
          contactSearchPlaceholder: "Digite para buscar contato (nome ou número)",
          contactMinChars: "Digite pelo menos 2 caracteres para buscar...",
          contactNotFound: "Nenhum contato encontrado",
          contactLoading: "Buscando contatos...",
        },
        validation: {
          required: "Obrigatório",
          bodyMin: "Mensagem muito curta",
          sendAtPast:
            "Não é permitido agendar mensagem no passado (tolerância de 2 minutos).",
          whatsappRequired: "Selecione uma conexão",
        },
        confirmationModal: {
          deleteTitle: "Excluir anexo",
          deleteMessage: "Tem certeza que deseja excluir o anexo deste agendamento?",
        },
        toasts: {
          deleted: "Anexo excluído com sucesso.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
        },
        form: {
          name: "Nome",
          color: "Cor",
          blockAi: "Bloquear IA",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      internalChat: {
        actions: {
          reply: "Responder",
          copy: "Copiar",
        },
        reply: {
          you: "Você",
          cancel: "Cancelar resposta",
        },
        search: {
          open: "Pesquisar mensagens",
          title: "Pesquisar mensagens",
          placeholder: "Pesquisar",
          prompt: "Pesquisar por mensagens nesta conversa.",
          close: "Fechar pesquisa",
          loadMore: "Carregar mais",
          noResults: "Nenhuma mensagem encontrada.",
        },
        copy: {
          success: "Mensagem copiada com sucesso.",
          error: "Não foi possível copiar a mensagem.",
          empty: "Não há nada para copiar nesta mensagem.",
        },
        jump: {
          notFound: "Não foi possível abrir esta mensagem.",
          tooOld: "Esta mensagem é antiga demais para ser aberta aqui.",
        },
        list: {
          title: "Conversas",
          new: "Nova",
          empty: "Nenhuma conversa ainda. Clique em \"Nova\" para começar.",
        },
        tabs: {
          chats: "Conversas",
          messages: "Mensagens",
        },
        modal: {
          title: "Conversa",
          titleField: "Título",
          titleRequired: "Por favor, preencha o título da conversa.",
          usersRequired: "Por favor, selecione pelo menos um usuário.",
        },
        messages: {
          empty: "Nenhuma mensagem nesta conversa ainda.",
          inputPlaceholder: "Escreva uma mensagem",
        },
        header: {
          edit: "Editar conversa",
          delete: "Excluir conversa",
        },
        deleteConfirm: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO",
          titleFileList: "Lista de arquivo(s)"
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
        emailSync: {
          tooltip: "Atualizar emails (verificar novos)",
          error: "Não foi possível verificar os emails. Tente novamente.",
          received: "{{count}} novo email recebido.",
          received_plural: "{{count}} novos emails recebidos.",
          none: "Nenhum email novo encontrado.",
        },
        sorting: {
          title: "Ordenação",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      ticketsWhatsappSelect: {
        placeholder: "Conexões",
      },
      tickets: {
        muted: "Notificações silenciadas",
        inactiveConnection: {
          badge: "Conexão excluída",
          tooltip: "Este chamado pertence a uma conexão excluída em {{date}}. Disponível somente para consulta.",
          readOnly: "Chamado de uma conexão excluída — somente leitura. Não é possível responder nem reabrir.",
          removedToast: "A conexão deste chamado foi excluída. O chamado foi encerrado.",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
          noQueueAccess: "Você não tem acesso à fila deste chamado",
          assumed: "Chamado assumido com sucesso!",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
        contactRemoved: "Contato removido",
        closePreview: "Fechar visualização",
        dropFileHere: "Solte o arquivo aqui",
        advanced: {
          selectTicket: "Selecionar Ticket",
          nav: {
            ticket: "Ticket",
            tickets: "Atendimentos",
          },
        },
        developmentRequest: {
          request: "Solicitar desenvolvimento",
          previewTicketNotFound: "Ticket não encontrado para gerar preview.",
          saveTicketNotFound: "Ticket não encontrado para salvar solicitação.",
          created: "Solicitação de desenvolvimento registrada com sucesso.",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        bulkTitle: "Transferir {{count}} chamados",
        keepQueue: "Manter a fila de cada chamado",
        keepConnection: "Manter a conexão de cada chamado",
        fieldLabel: "Digite para buscar usuários",
        pendingUserHelper: "Opcional: deixe em branco para manter o chamado em Aguardando",
        openUserHelper: "Opcional: deixe em branco para devolver o chamado para Aguardando na fila escolhida",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        noQueue: "Sem fila",
        offline: "offline",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
        selectConnection: "Selecione uma conexão",
        errors: {
          invalidTicket: "Ticket inválido para transferência",
          selectUser: "Selecione um usuário",
        },
      },
      ticketContextMenu: {
        selection: "Seleção",
        select: "Selecionar",
        selectAll: "Selecionar Todos",
        clearSelection: "Limpar Seleção",
        selected: "selecionados",
        selectedCount: "{{count}} selecionado(s)",
        cancel: "Cancelar",
        actions: {
          title: "Ações",
          accept: "Aceitar",
          close: "Finalizar",
          transfer: "Transferir",
          return: "Retornar para Fila",
          resolve: "Resolver",
          schedule: "Criar Agendamento",
          markUnread: "Marcar como Não Lido",
          markRead: "Marcar como Lido",
          resetAlarm: "Resetar Alarme",
          mute: "Silenciar notificações",
          muteFor8Hours: "8 horas",
          muteFor1Week: "1 semana",
          muteForever: "Sempre",
          unmute: "Reativar som",
        },
        confirmAcceptTitle: "Confirmar Aceitar",
        confirmAcceptMessage: "Deseja aceitar {{count}} atendimento(s)?",
        confirmCloseTitle: "Confirmar Finalizar",
        confirmCloseMessage: "Deseja finalizar {{count}} atendimento(s)?",
        confirmReturnTitle: "Confirmar Retornar",
        confirmReturnMessage: "Deseja retornar {{count}} atendimento(s) para a fila?",
        confirmResolveTitle: "Confirmar Resolver",
        confirmResolveMessage: "Deseja resolver {{count}} atendimento(s)?",
        confirmMarkUnreadTitle: "Confirmar Marcar como Não Lido",
        confirmMarkUnreadMessage: "Deseja marcar {{count}} atendimento(s) como não lido?",
        confirmMarkReadTitle: "Confirmar Marcar como Lido",
        confirmMarkReadMessage: "Deseja marcar {{count}} atendimento(s) como lido?",
        bulkActionSuccess: "{{count}} atendimento(s) - ação '{{action}}' realizada com sucesso!",
        bulkActionFail: "{{count}} atendimento(s) falharam na ação.",
        bulkActionCancelled: "Ação cancelada: {{count}} atendimento(s) não foram alterados.",
        errors: {
          transferTicketNotFound: "Não foi possível identificar o ticket para transferência",
        },
      },
      ticketsSearch: {
        sections: {
          contacts: "Contatos",
          commonGroups: "Grupos em comum",
          messages: "Mensagens",
        },
        alsoInGroup: "~{{name}} também está neste grupo",
        showMore: "Ver mais",
        noResults: "Nenhum resultado encontrado",
        noResultsHint: "Nada corresponde a \"{{term}}\" nesta aba.",
        searchedUntil: "Pesquisado até {{date}}",
        searchOlder: "Buscar em mensagens mais antigas",
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        contactsHeader: "Contatos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        buttons: {
          accept: "Aceitar",
          closed: "Finalizar",
          reopen: "Reabrir"
        },
        sorting: {
          oldestFirst: "Mais antigos primeiro",
          newestFirst: "Mais recentes primeiro",
          longestWaitFirst: "Maior tempo de espera",
          shortestWaitFirst: "Menor tempo de espera",
          unreadFirst: "Não lidas primeiro",
          autoReorder: "Reordenação automática"
        },
        filters: {
          title: "Filtros",
          searchMode: "Modo de busca",
          contactNameOnly: "Buscar apenas nome do contato",
          queues: "Filas",
          whatsapp: "Conexão WhatsApp",
          tags: "Tags",
          contactTags: "Tags do contato",
          contactTagsPlaceholder: "Filtrar por tags do contato",
          users: "Usuários",
        },
        noConnection: {
          title: "Nenhuma conexão atribuída",
          message: "O filtro por conexão está ativo e seu usuário não tem nenhuma conexão atribuída. Peça ao administrador para atribuir uma conexão no seu cadastro.",
        },
        item: {
          comment: "Comentário",
          queueLabel: "Fila: {{name}}",
          attendantLabel: "Atendente: {{name}}",
          aiAgentLabel: "Agente de IA: {{name}}",
        },
      },
      contactsListPanel: {
				newContact: "Novo contato",
        noContacts: "Nenhum contato encontrado",
        noContactsText: "Use a busca para encontrar contatos ou adicione novos na página de contatos",
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        noQueue: "Sem fila",
        selectQueue: "Selecione a fila",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
        selectConnection: "Selecionar conexão",
        selectConnectionDialogTitle: "Selecionar conexão para o chamado",
        errors: {
          selectConnection: "Selecione uma conexão",
          selectWhatsappConnection: "Selecione uma conexão do WhatsApp",
          connectionNotConnected: "A conexão selecionada não está conectada. Por favor, selecione uma conexão ativa.",
        },
        existingTicket: {
          title: "Ticket Já Existe",
          message: "Já existe um ticket aberto para este contato.",
          unknownUser: "Usuário desconhecido",
          attendantLabel: "Atendente:",
          queueLabel: "Fila:",
          connectionLabel: "Conexão:",
          groupSingleTicket: "Este grupo já possui um chamado em andamento. Um grupo tem um único chamado, em qualquer conexão — abra o existente.",
          canCreateNew: "Você pode abrir o ticket já existente ou criar um novo ticket na conexão selecionada.",
          canCreateNewWithConnection: "Você pode abrir o ticket já existente ou criar um novo ticket na conexão selecionada ({{connection}}).",
          sameConnection: "O ticket existente já está na conexão selecionada. Deseja abrir este ticket?",
          createNew: "Criar Novo Ticket",
          openExisting: "Abrir Ticket Existente",
        },
        templatePicker: {
          title: "Janela de 24 horas expirada",
          description: "A janela de 24 horas expirou. Envie um template de mensagem para iniciar uma nova conversa.",
          noTemplates: "Nenhum modelo de mensagem aprovado encontrado. Crie e submeta templates para aprovação na página de Templates.",
          selectTemplate: "Selecione um modelo",
          preview: "Pré-visualização:",
          emptyBody: "(Sem texto no corpo)",
          variables: "Variáveis:",
          variable: "Variável",
          send: "Enviar",
          sending: "Enviando...",
          sent: "Template enviado com sucesso!",
        },
      },
      mainDrawer: {
        listItems: {
					ticketRatings: "Avaliações",
					ticketsConference: "Conferência",
					messagesReport: "Relatório de Mensagens",
					attendanceMonitor: "Monitoramento",
					kanban: "Fluxos",
					kanbanAll: "Todos os fluxos",
					clientCentral: "Central de Clientes",
					usageReport: "Relatórios",
					clientes: "Clientes",
					followUp: "Follow-UP",
					tagPhrases: "Frases que geram Tag",
					forbiddenWords: "Termos proibidos",
					forbiddenWordsRegister: "Cadastro de termos",
					forbiddenWordsReport: "Relatório de termos",
					development: "Desenvolvimento",
					campaignsList: "Listagem",
					contactLists: "Listas de Contatos",
					campaignsConfig: "Configurações",
					messageTemplates: "Templates de Mensagem",
					management: "Gerenciamento",
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Atendimentos",
          pendingMessages: "Pendentes",
          quickMessages: "Respostas Rápidas",
          documentTemplates: "Modelos de Documentos",
          catalog: "Catálogo de Produtos",
          contacts: "Contatos",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          perfis: "Perfis de Usuario",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          files: "Lista de arquivos",
          prompts: "Agentes de IA",
          queueIntegration: "Integrações",
        },
        appBar: {
					tooltips: {
						darkMode: "Alternar tema claro/escuro",
						volume: "Volume das notificações",
						tickets: "Notificações de atendimentos",
						announcements: "Informativos",
						internalChat: "Chat interno",
						account: "Minha conta",
					},
          notRegister:"Sem notificações",
          refresh: "Atualizar página",
          clearCache: {
            tooltip: "Limpar cache",
            title: "Limpar cache e dados do CRM?",
            message: "Isso apaga o cache, os cookies e os dados do CRM salvos neste navegador, encerra a sua sessão e recarrega o sistema na versão mais recente. Mensagens que ainda não foram enviadas serão perdidas. Depois é só entrar de novo.",
          },
          openFollowUp: "Abrir popup de follow-up",
          greeting: {
            hello: "Olá",
            welcome: "Bem-vindo a",
            activeUntil: "Ativo até {{date}}",
          },
          toasts: {
            popupBlocked: "O navegador bloqueou a popup de follow-up. Permita popups e tente novamente.",
          },
          user: {
            profile: "Perfil",
            language: "Idioma",
            logout: "Sair",
          },
        },
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
        toasts: {
          deleted: "Integração excluída com sucesso.",
        },
      },
      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        showHideToken: "Mostrar/ocultar token",
        buttons: {
          send: "Enviar",
        },
        toasts: {
          sent: "Mensagem enviada com sucesso",
        },
        doc: {
          title: "Documentação para envio de mensagens",
          methods: "Métodos de Envio",
          textMessages: "Mensagens de Texto",
          mediaMessages: "Mensagens de Mídia",
          instructions: "Instruções",
          importantNotes: "Observações importantes",
          tokenNote: "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens.",
          tokenNoteHowTo: "Para realizar o cadastro acesse o menu \"{{menu}}\", clique no botão editar da conexão e insira o token no devido campo.",
          numberFormat: "O número para envio não deve ter máscara ou caracteres especiais e deve ser composto por:",
          countryCode: "Código do país",
          areaCode: "DDD",
          textInfo: "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          mediaInfo: "Seguem abaixo a lista de informações necessárias para envio das mensagens de mídia:",
          method: "Método",
          headers: "Authorization (Bearer token) e Content-Type ({{contentType}})",
          fileValue: "arquivo",
          sendTest: "Teste de Envio",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      catalog: {
        title: "Catálogo de Produtos",
        searchPlaceholder: "Pesquisar produto ou SKU",
        connection: "Conexão",
        collection: "Coleção",
        allCollections: "Todas",
        empty: "Nenhum produto no catálogo desta conexão. Use Sincronizar para trazer os produtos do WhatsApp.",
        table: {
          image: "Imagem",
          name: "Produto",
          sku: "SKU",
          price: "Preço",
          status: "Situação",
          actions: "Ações",
        },
        status: {
          published: "Publicado",
          hidden: "Oculto",
          localOnly: "Só no CRM",
        },
        buttons: {
          sync: "Sincronizar",
          add: "Novo produto",
        },
        toasts: {
          synced: "Catálogo sincronizado: {{created}} novos, {{updated}} atualizados, {{removed}} removidos.",
          deleted: "Produto excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir produto",
          deleteMessage: "Tem certeza que deseja excluir este produto? Ele também será removido do catálogo do WhatsApp.",
        },
        modal: {
          addTitle: "Novo produto",
          editTitle: "Editar produto",
          name: "Nome",
          description: "Descrição",
          price: "Preço",
          currency: "Moeda",
          retailerId: "SKU (código do produto)",
          retailerIdHint: "Identificador usado pelo WhatsApp ao enviar o produto. Se ficar vazio, o provedor gera um.",
          productUrl: "Link do produto",
          addImage: "Adicionar imagem",
          changeImage: "Trocar imagem",
          isHidden: "Ocultar no catálogo público",
          hint: "O produto é criado no catálogo do WhatsApp e fica disponível para envio no chat.",
          save: "Salvar",
          cancel: "Cancelar",
          saved: "Produto salvo com sucesso.",
          validation: {
            nameRequired: "Informe o nome do produto.",
            nameShort: "Nome muito curto.",
            priceRequired: "Informe o preço.",
            priceInvalid: "Preço inválido.",
          },
        },
        picker: {
          title: "Enviar produto do catálogo",
          searchPlaceholder: "Buscar produto",
          empty: "Nenhum produto encontrado. Sincronize o catálogo na tela Catálogo de Produtos.",
          mode: "Como enviar",
          modeSingle: "Um produto",
          modeList: "Lista de produtos",
          modeCatalog: "Catálogo completo",
          message: "Mensagem (opcional)",
          header: "Título da lista",
          footer: "Rodapé (opcional)",
          send: "Enviar",
          cancel: "Cancelar",
          sent: "Produto enviado.",
          selectOne: "Selecione ao menos um produto.",
        },
      },
      documentTemplates: {
        title: "Modelos de Documentos",
        searchPlaceholder: "Pesquisar...",
        table: {
          name: "Nome",
          description: "Descrição",
          active: "Ativo",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Modelo",
          save: "Salvar",
          cancel: "Cancelar",
          insertVariable: "Inserir variável",
          pageConfig: "Configurar página",
          send: "Gerar e enviar",
        },
        toasts: {
          saved: "Modelo salvo com sucesso!",
          deleted: "Modelo removido com sucesso!",
          sent: "Documento enviado com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir modelo",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        editor: {
          name: "Nome do modelo",
          description: "Descrição",
          active: "Ativo",
          fontFamily: "Fonte",
          fontSize: "Tamanho",
          paperSize: "Papel",
          margins: "Margens (cm)",
          marginTop: "Superior",
          marginBottom: "Inferior",
          marginLeft: "Esquerda",
          marginRight: "Direita",
          variableGroups: {
            system: "Sistema",
            contact: "Contato",
            cliente: "Cliente",
            clienteCustom: "Campos personalizados",
          },
        },
        sendModal: {
          title: "Enviar documento",
          selectTemplate: "Modelo de documento",
          missingFields: "Preencha as informações pendentes",
          resolvedFields: "Dados preenchidos automaticamente",
          noClienteLinked:
            "Este contato não possui cliente vinculado — os campos de cliente devem ser preenchidos manualmente.",
          caption: "Mensagem (opcional)",
          preview: "Visualizar",
          previewTitle: "Pré-visualização do documento",
          send: "Gerar e enviar",
          cancel: "Cancelar",
        },
        toolbar: {
          bold: "Negrito",
          italic: "Itálico",
          underline: "Sublinhado",
          alignLeft: "Alinhar à esquerda",
          alignCenter: "Centralizar",
          alignRight: "Alinhar à direita",
          justify: "Justificar",
          bulletList: "Lista",
          orderedList: "Lista numerada",
          insertTable: "Inserir tabela",
          removeTable: "Remover tabela",
        },
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo(s)",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        attachments: {
          title: "Anexos",
          maxReached: "Limite de {{max}} anexos por resposta rápida atingido.",
          rejected: "Arquivo(s) não permitido(s): {{files}}",
          notFound: "Anexo(s) desta resposta rápida não foram encontrados no servidor.",
          deleteAllMessage:
            "O anexo desta resposta rápida será removido. Deseja prosseguir?",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
          mediaAlt: "Mídia da mensagem",
        },
        modal: {
          title: "Mensagens Rápidas",
          search: "Pesquisar mensagens rápidas...",
          empty: "Nenhuma mensagem rápida cadastrada",
          noResults: "Nenhuma mensagem encontrada",
          viewMessage: "Visualizar mensagem",
          close: "Fechar",
          useMessage: "Usar mensagem",
          hasMedia: "Mídia",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          filesSuffix: "arquivos",
          status: "Status",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
          downloadSample: "Baixar planilha de exemplo",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          saved: "Lista salva com sucesso.",
          deleted: "Registro excluído",
        },
        searchPlaceholder: "Pesquisar por ID ou nome",
        pagination: {
          rowsPerPage: "Itens por página",
          displayedRows: "{{from}}-{{to}} de {{total}}",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
          importing: "Importando…",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        importProgress: {
          uploading: "Enviando planilha… {{percent}}%",
          processing: "Processando planilha…",
          importing: "Importando contatos: {{processed}} de {{total}}",
        },
        validation: {
          queued: "Na fila para validação no WhatsApp…",
          progress: "Validando números no WhatsApp: {{checked}} de {{total}}",
          done: "Validação concluída: {{valid}} válidos e {{invalid}} inválidos.",
          doneWithPending:
            "Validação concluída: {{valid}} válidos, {{invalid}} inválidos e {{unvalidated}} sem validação.",
          unavailable:
            "Validação no WhatsApp indisponível (nenhuma conexão WhatsApp conectada). Os contatos foram importados e o disparo não é afetado; importe a planilha de novo para tentar validar os pendentes.",
          error:
            "Erro ao validar os números no WhatsApp. Os contatos foram importados; importe a planilha de novo para tentar validar os pendentes.",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
          validWhatsapp: "WhatsApp válido",
          invalidWhatsapp: "WhatsApp inválido",
          notValidated: "Número não validado no WhatsApp",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
          downloadSample: "Clique aqui para baixar a planilha de exemplo.",
        },
        toasts: {
          deleted: "Registro excluído",
          imported:
            "{{created}} contatos importados ({{duplicates}} já estavam na lista, {{invalid}} linhas sem número válido).",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
          noContactList: "Não definida",
          noWhatsapp: "Não definido",
          notScheduled: "Sem agendamento",
          notCompleted: "Não concluída",
          confirmationEnabled: "Habilitada",
          confirmationDisabled: "Desabilitada",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Lista de Tags",
            fileList: "Lista de Arquivos",
            none: "Nenhuma",
            whatsappConnection: "Conexão WhatsApp",
            responseQueue: "Fila para resposta da campanha",
            responseQueueHelper: "Se selecionar uma fila, o prazo de resposta em minutos se torna obrigatório.",
            responseWindow: "Prazo de resposta (minutos)",
            responseWindowHelper: "Obrigatório. Encaminha para a fila se o contato responder dentro deste prazo.",
            responseWindowDisabledHelper: "Selecione uma fila para habilitar este campo.",
            dispatchType: "Início da campanha",
            dispatchImmediate: "Iniciar imediatamente",
            dispatchScheduled: "Agendar para data/hora",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
          validation: {
            integerMinutes: "Use um número inteiro de minutos",
            minWindow: "Prazo mínimo é 1 minuto",
            maxWindow: "Prazo máximo é 10080 minutos (7 dias)",
            queueAndWindow: "Selecione a fila e o prazo para habilitar o encaminhamento",
            windowRequired: "Informe o prazo em minutos",
            responseQueueRequired: "Selecione uma fila de resposta",
          },
          toasts: {
            missingVariables: "Preencha todas as variáveis do template antes de salvar:",
            smsMessageRequired: "Escreva a mensagem de texto da campanha de SMS.",
            smsBaratoTooLong: "A mensagem tem {{length}} caracteres após a conversão para o formato do SMS Barato — o limite do provedor é {{max}}.",
            templateRequired: "Selecione um template para a campanha.",
            scheduledAtRequired: "Preencha a data/hora de agendamento.",
            responseWindowRequired: "Informe o prazo de resposta em minutos (mínimo 1) para a fila selecionada.",
          },
          sms: {
            sectionTitle: "MENSAGEM - Para SMS",
            messageLabel: "Mensagem do SMS *",
            messagePlaceholder: "Texto que será enviado. Use {{variable}} para personalizar.",
            helperSmsBarato: "{{length}}/{{max}} caracteres · SMS Barato envia 1 SMS por mensagem, sem acentos e sem quebras de linha",
            helperSegments: "{{length}} caracteres · {{encoding}} · {{segments}} segmento(s) cobrado(s) · {{perSegment}} caracteres por segmento",
            overLimit: "A mensagem excede o limite de {{max}} caracteres do SMS Barato — reduza o texto para salvar a campanha.",
            willBeSentAs: "Será enviado como:",
            ucs2Warning: "A mensagem contém caracteres fora do padrão GSM-7 (emojis, símbolos e — no Witi.me — acentos). Isso reduz o limite de 160 para 70 caracteres por segmento e encarece o disparo.",
          },
          template: {
            sectionTitle: "TEMPLATE - Para Cloud API",
            label: "Template",
            selectConnection: "Selecione uma conexão Cloud API para carregar os templates.",
            selected: "Template selecionado:",
            category: "Categoria:",
            language: "Idioma:",
            text: "Texto:",
          },
          variables: {
            title: "Configuração de Variáveis do Template",
            description: "Configure como cada variável do template será preenchida com dados dos contatos ou valores fixos.",
            variable: "Variável",
            buttonUrlRequired: "{{component}} - Botão URL (obrigatório)",
            buttonType: "Botão {{type}}",
            contactData: "Dado do Contato",
            fixedValue: "Valor Fixo",
            contactField: "Campo do Contato",
            fixedValuePlaceholder: "Digite o valor que será usado para todos os contatos",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
        statuses: {
          inactive: "Inativa",
          scheduled: "Programada",
          inProgress: "Em Andamento",
          canceled: "Cancelada",
          finished: "Finalizada",
        },
        actions: {
          stop: "Parar Campanha",
          start: "Iniciar Campanha",
          startNow: "Iniciar agora",
          viewReport: "Ver Relatório",
        },
        pagination: {
          rowsPerPage: "Itens por página",
          displayedRows: "{{from}}-{{to}} de {{total}}",
          moreThan: "mais de {{value}}",
        },
      },
      announcements: {
        active: 'Ativo',
        inactive: 'Inativo',
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Título",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Título",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
        toasts: {
          saved: "Configurações salvas",
        },
        intervals: {
          title: "Intervalos",
          baileysOnly: "A aleatoriedade dos intervalos de disparo é aplicada apenas para conexões Baileys.",
          messageInterval: "Intervalo Randômico de Disparo",
          longerIntervalAfter: "Intervalo Maior Após",
          greaterInterval: "Intervalo de Disparo Maior",
          noInterval: "Sem Intervalo",
          notDefined: "Não definido",
          seconds: "{{count}} segundo",
          seconds_plural: "{{count}} segundos",
        },
        buttons: {
          addVariable: "Adicionar Variável",
          saveSettings: "Salvar Configurações",
        },
        variables: {
          shortcut: "Atalho",
          content: "Conteúdo",
        },
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
		  id:"ID",
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
          orderQueue: "Ordenação da fila (bot)",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
        toasts: {
          deleted: "Fila excluída com sucesso.",
          hasPrompts: "Não é possível excluir a fila. Existem prompts associados a esta fila. Por favor, reatribua ou exclua os prompts antes de deletar esta fila.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
        selectQueue: "Selecione uma fila",
      },
      users: {
        title: "Usuários",
        table: {
		  id: "ID",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          queues: "Filas",
          defaultConnection: "Conexão Padrão",
          allTicket: "Ticket Sem Fila",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
          salesReport: "Relatório de Metas",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
        salesReport: {
          title: "Relatório de Metas de Vendas",
          period: "Período",
          user: "Usuário",
          salesGoal: "Meta (R$)",
          totalSales: "Total Vendido (R$)",
          achievement: "Atingimento",
          actions: "Ações",
          viewDetails: "Ver detalhes das vendas",
          noData: "Nenhuma venda encontrada no período",
          filters: {
            startDate: "Data Inicial",
            endDate: "Data Final",
            allUsers: "Todos os Usuários",
            filter: "Filtrar",
          },
          details: {
            title: "Detalhes das Vendas",
            totalSales: "Total de Vendas",
            salesCount: "Quantidade de Vendas",
            date: "Data",
            clientName: "Cliente",
            value: "Valor",
            observations: "Observações",
            total: "TOTAL",
            noSales: "Nenhuma venda encontrada para este usuário no período",
          },
        },
      },
      helps: {
        title: "Central de Ajuda",
        form: {
          title: "Título",
          video: "Código do Vídeo",
        },
        table: {
          video: "Vídeo",
        },
        toasts: {
          saveError: "Não foi possível realizar a operação. Verifique se já existe uma ajuda com o mesmo título ou se os campos foram preenchidos corretamente",
        },
      },
      schedules: {
        title: "Agendamentos",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
        calendar: {
          yesterday: "Ontem",
          tomorrow: "Amanhã",
          noEventsInRange: "Não há agendamentos no período.",
          showMore: "+{{total}} mais",
          eventFallback: "Agendamento",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
		  deleteAllMessage: "Tem certeza que deseja deletar todas as Tags?",
		  deleteAllTitle: "Deletar Todos",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Registros Tagdos",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
		  deleteAll: "Deletar Todas",
          viewContacts: "Ver contatos com esta tag",
        },
        toasts: {
		  deletedAll: "Todas Tags excluídas com sucesso!",
          deleted: "Tag excluído com sucesso.",
        },
      },
      tagContactsModal: {
        title: "Contatos com a tag",
        count: "{{count}} contato(s)",
        search: "Buscar por nome, número ou CNPJ do cliente...",
        empty: "Nenhum contato com esta tag.",
        minChars: "Digite ao menos {{count}} caracteres para buscar.",
        close: "Fechar",
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          kanban: "Kanban",
          schedules: "Horários",
          companies: "Empresas",
          plans: "Planos",
          email: "E-mail",
          cloudApi: "Cloud API",
          customFields: "Campos personalizados",
          requiredFields: "Campos obrigatórios",
          help: "Ajuda",
          empsis: "Empsis",
          templateCredits: "Créditos de Template",
          aiCredits: "Créditos de IA",
          instagramWebhooks: "Webhooks IG",
          systemAlerts: "Alertas do Sistema",
        },
        companiesManager: {
          fields: {
            name: "Nome",
            cnpj: "CNPJ",
            email: "E-mail",
            adminPassword: "Senha do administrador",
            phone: "Telefone",
            plan: "Plano",
            status: "Status",
            campaigns: "Campanhas",
            dueDate: "Data de Vencimento",
            recurrence: "Recorrência",
            empsisToken: "Token Empsis",
            empsisTokenHelper: "Usado para validar a licença na Empsis",
            customValue: "Valor personalizado (R$)",
            customUsers: "Usuários (personalizado)",
            customConnections: "Conexões (personalizado)",
          },
          options: {
            active: "Ativa",
            inactive: "Inativa",
            enabled: "Habilitadas",
            disabled: "Desabilitadas",
          },
          recurrence: {
            MENSAL: "Mensal",
            BIMESTRAL: "Bimestral",
            TRIMESTRAL: "Trimestral",
            SEMESTRAL: "Semestral",
            ANUAL: "Anual",
          },
          validation: {
            cnpjInvalid: "CNPJ inválido",
            cnpjRequired: "CNPJ obrigatório",
            passwordRequired: "Senha obrigatória",
            passwordMin: "Mínimo de 5 caracteres",
            empsisTokenRequired: "Token da Empsis obrigatório",
          },
          customization: "Personalização (cliente com preço/limites próprios — deixe em branco para usar o plano)",
          buttons: {
            clear: "Limpar",
            delete: "Excluir",
            addDueDate: "+ Vencimento",
            user: "Usuário",
            save: "Salvar",
            generateToken: "Gerar token",
            recheckLicense: "Revalidar licença",
          },
          tokenVisibility: {
            show: "Mostrar token",
            hide: "Ocultar token",
          },
          restricted: {
            title: "Acesso Restrito",
            message: "Apenas o usuário administrador principal pode gerenciar empresas.",
            hint: "Entre em contato com o administrador do sistema se precisar fazer alterações.",
          },
          license: {
            section: "Licença Empsis",
            column: "Licença",
            columnMonitor: "Licença (monitor)",
            monitorTooltip: "Modo monitor: o status é consultado na Empsis, mas nenhuma empresa é bloqueada.",
            status: {
              noCnpj: "Bloqueada: sem CNPJ",
              exemptInvalid: "Isenta (licença inválida)",
              exempt: "Isenta",
              valid: "Válida",
              invalid: "Inválida",
              unchecked: "Não verificada",
            },
            checkedAt: "Consultada em {{date}}",
            token: {
              autoRenew: "Renovação automática do token",
              noAutoRenew: "Token sem renovação automática",
              missing: "Sem token da Empsis",
            },
            exemptLabel: "Isenta da validação de licença",
            exemptNoCnpjHint: "Sem CNPJ a empresa fica bloqueada mesmo isenta. Cadastre o CNPJ para liberar.",
          },
          tokenDialog: {
            title: "Gerar token da Empsis",
            description: "Usuário e senha de acesso à Empsis. O usuário e a senha ficam guardados cifrados para o FaleCRM gerar outro token sozinho quando este vencer (30 dias).",
            user: "Usuário da Empsis",
            password: "Senha da Empsis",
            cancel: "Cancelar",
            generate: "Gerar",
          },
          grid: {
            createdAt: "Criada em",
            dueDate: "Vencimento",
            reactivate: "Reativar empresa",
            deactivate: "Inativar empresa",
          },
          toasts: {
            tokenGeneratedPending: "Token gerado. Ele será salvo junto com a empresa.",
            tokenGeneratedSaved: "Token gerado e salvo para a empresa.",
            licenseUnavailable: "A Empsis não deu resposta definitiva ({{reason}}). O último status foi mantido.",
            noDetails: "sem detalhes",
            licenseRechecked: "Licença revalidada: {{status}}.",
            licenseRecheckedWithReason: "Licença revalidada: {{status}} ({{reason}}).",
            exemptOn: "Empresa marcada como isenta da validação de licença.",
            exemptOff: "Isenção de licença removida.",
            loadError: "Não foi possível carregar a lista de registros",
            success: "Operação realizada com sucesso!",
            error: "Não foi possível realizar a operação",
            reactivated: "Empresa reativada com sucesso!",
            deactivated: "Empresa inativada. Usuários não poderão fazer login e as conexões de WhatsApp foram desconectadas.",
            statusError: "Não foi possível alterar o status da empresa",
          },
          showInactive: "Ver inativas ({{count}})",
          confirm: {
            deleteTitle: "Exclusão de Registro",
            deleteMessage: "Deseja realmente excluir esse registro?",
            reactivateTitle: "Reativar a empresa {{name}}?",
            deactivateTitle: "Inativar a empresa {{name}}?",
            reactivateMessage: "Os usuários voltarão a ter acesso e as conexões de WhatsApp com sessão salva serão religadas automaticamente.",
            deactivateMessage: "Os usuários desta empresa não poderão mais fazer login e as conexões de WhatsApp serão desconectadas (a sessão salva é preservada para uma futura reativação).",
          },
        },
        empsis: {
          title: "Integração Empsis",
          description: "O token da Empsis é usado para consultar os imobilizados (campos de Patrimônio dos boards de locação) e para validar a licença de uso. Para gerar, informe o CNPJ, o usuário e a senha de acesso à Empsis. O FaleCRM salva o token e guarda o usuário e a senha cifrados para gerar outro sozinho quando este vencer. A Empsis dá 30 dias de validade a cada token.",
          docsLink: "Documentação da API",
          fields: {
            cnpj: "CNPJ",
            user: "Usuário da Empsis",
            password: "Senha da Empsis",
            token: "Token da API Empsis",
            tokenPlaceholder: "Nenhum token gerado ainda",
            tokenHelper: "Somente leitura. Para trocar o token, use o Gerar e salvar acima.",
          },
          buttons: {
            generate: "Gerar e salvar",
            generating: "Gerando...",
            test: "Testar conexão",
            testing: "Testando...",
          },
          autoRenew: {
            active: "Renovação automática ativa · usuário {{user}}",
            generatedAt: " · token gerado em {{date}}",
            inactive: "Renovação automática desativada: gere o token aqui para o FaleCRM renová-lo sozinho.",
          },
          currentToken: "Token atual",
          toasts: {
            generated: "Token gerado e salvo. Ele será renovado sozinho quando vencer.",
            generatedNoRenew: "Token gerado e salvo, mas sem renovação automática.",
          },
          errors: {
            serverUnreachable: "Não foi possível falar com o servidor.",
          },
          testResult: {
            ok: "Conexão OK: {{count}} item(ns) de imobilizado encontrados.",
            okEmpty: "Conexão OK, mas a Empsis não devolveu nenhum item ativo.",
            failed: "Falha na conexão: {{reason}}",
          },
        },
        options: {
          loading: "Atualizando...",
          sections: {
            integrations: "INTEGRAÇÕES",
            asaas: "ASAAS",
            aiTransferNotify: "AVISO DE TRANSFERÊNCIA DA IA",
          },
          messages: {
            updated: "Operação atualizada com sucesso.",
            updateError: "Erro ao atualizar configuração.",
          },
          fields: {
            userRating: {
              label: "Avaliações",
              options: {
                enabled: "Habilitadas",
                disabled: "Desabilitadas",
              },
            },
            crmConvertedQuestion: {
              label: "Pergunta de Conversão (CRM)",
              helper: "Pergunta \"Convertido?\" ao fechar o atendimento",
              options: {
                enabled: "Habilitada",
                disabled: "Desabilitada",
              },
            },
            scheduleType: {
              label: "Gerenciamento de Expediente",
              options: {
                disabled: "Desabilitado",
                queue: "Fila",
                company: "Empresa",
              },
            },
            checkMsgIsGroup: {
              label: "Ignorar Mensagens de Grupos",
              options: {
                enabled: "Ativado",
                disabled: "Desativado",
              },
            },
            callType: {
              label: "Aceitar Chamada",
              options: {
                enabled: "Aceitar",
                disabled: "Não Aceitar",
              },
            },
            chatbotType: {
              label: "Tipo Chatbot",
              options: {
                text: "Texto",
              },
            },
            sendGreetingAccepted: {
              label: "Enviar saudação ao aceitar o ticket",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            sendMsgTransfTicket: {
              label: "Enviar mensagem de transferência de fila/agente",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            sendGreetingMessageOneQueues: {
              label: "Enviar saudação quando houver somente 1 fila",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            autoManageConnection: {
              label: "Auto gerenciamento de conexão",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            sidebarBehavior: {
              label: "Comportamento do menu lateral",
              options: {
                expanded: "Sempre expandido",
                collapsed: "Retraído (com hover)",
                collapsed_no_hover: "Retraído (sem hover)",
              },
            },
            sidebarSubmenuBehavior: {
              label: "Comportamento dos submenus",
              options: {
                expanded: "Sempre expandidos",
                collapsible: "Colapsáveis",
              },
            },
            unifyTicketsByContact: {
              label: "Chamado de contato com várias conexões",
              helper: "Um por contato: o contato tem um único chamado, em qualquer conexão. Um por conexão: cada conexão tem o seu chamado com o contato; enviar ou encaminhar sem escolher a conexão usa a do atendente, e assumir não muda o chamado de conexão.",
              options: {
                enabled: "Um por contato (qualquer conexão)",
                disabled: "Um por conexão",
              },
            },
            groupTicketUnify: {
              label: "Chamado de grupo com várias conexões",
              helper: "Um por grupo: quando mais de uma conexão participa do mesmo grupo, existe um único chamado (a conexão escolhida ao enviar passa a ser a do chamado). Um por conexão: cada conexão tem o seu chamado do grupo e todos mostram a conversa inteira.",
              options: {
                enabled: "Um por grupo (qualquer conexão)",
                disabled: "Um por conexão",
              },
            },
            notifyGroupMessages: {
              label: "Notificar mensagens de grupo",
              helper: "Toca o som e mostra o aviso também para mensagens de grupo, com a mesma regra dos chamados individuais (Aguardando: quem pode abrir o chamado; com atendente: só o atendente). Cada grupo pode ser silenciado individualmente.",
              options: {
                disabled: "Desabilitado (grupo não avisa)",
                enabled: "Habilitado",
              },
            },
            notifyPhoneUnreadMessages: {
              label: "Avisar o celular de mensagem sem leitura",
              helper: "Vale para conexões com \"Mostrar digitando e online do contato\" ligada. Com atendente usando o FaleCRM o número fica online e o celular não notifica; se uma mensagem de cliente ficar alguns minutos (padrão 3) sem ser aberta, o número sai do online por alguns segundos para o celular notificar.",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado (o celular só notifica quando ninguém está usando o FaleCRM)",
              },
            },
            messageHistory: {
              label: "Histórico de mensagens",
              helper: "Contato: histórico completo | Ticket: apenas do atendimento | Conexão: apenas da mesma conexão",
              options: {
                contact: "Por contato (todas as mensagens)",
                ticket: "Por ticket (isolado)",
                whatsapp: "Por Conexão (mesma conexão)",
              },
            },
            ticketConnectionScope: {
              label: "Restringir atendimentos às conexões do usuário",
              helper: "Quando habilitado, cada usuário (exceto admin) só vê atendimentos das conexões que ele controla (conexão padrão + conexões atribuídas no cadastro do usuário). Sem conexão atribuída, não vê nenhum atendimento. Desabilitado: comportamento atual (todos veem tudo por fila).",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            ticketCloseWithoutInteraction: {
              label: "Finalizar chamado sem interação",
              helper: "Controla o que acontece quando o atendente finaliza um chamado sem nunca ter enviado uma mensagem ao contato (mensagens automáticas e de sistema não contam). Em qualquer modo o chamado entra na métrica \"Finalizados sem interação\" do Dashboard.",
              options: {
                allowed: "Permitido",
                warn: "Avisar e pedir confirmação",
                blocked: "Bloquear",
              },
            },
            askCompletionMessageOnClose: {
              label: "Perguntar antes de enviar a mensagem de conclusão",
              helper: "Ao finalizar um chamado cuja conexão tem mensagem de conclusão configurada, pergunta ao atendente se ela deve ser enviada. Fechamentos automáticos (inatividade, chatbot, API) sempre enviam.",
              options: {
                disabled: "Desabilitado (sempre envia)",
                enabled: "Habilitado (pergunta ao finalizar)",
              },
            },
            transferPendingTickets: {
              label: "Transferir chamados em Aguardando",
              helper: "Mostra o botão Transferir nos chamados que ainda não foram aceitos. Sem usuário escolhido, o chamado continua em Aguardando na nova fila/conexão.",
              options: {
                disabled: "Desabilitado",
                enabled: "Habilitado",
              },
            },
            transferToOfflineUser: {
              label: "Transferir para usuário offline",
              helper: "Desabilitado, o chamado só pode ser transferido para quem está online (vale também para a IA). Assumir o chamado para si continua liberado.",
              options: {
                disabled: "Desabilitado",
                enabled: "Habilitado",
              },
            },
            clientImport: {
              label: "Importação de Clientes",
              helper: "Quando habilitado, permite importar clientes de banco de dados externo",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            whatsappConnectionType: {
              label: "Tipo de Conexão WhatsApp",
              helper: "Define quais tipos de conexão a empresa pode utilizar",
              options: {
                both: "Ambos (Baileys + Cloud API)",
                baileys: "Somente Baileys (Não-Oficial)",
                cloudapi: "Somente Cloud API (Oficial Meta)",
              },
            },
            attendanceAlarmMinutes: {
              label: "Alarme de atraso no monitoramento (minutos)",
              helper: "Tempo máximo sem resposta antes do ticket entrar em alarme. Padrão: 10 minutos.",
              errors: {
                invalid: "Informe um valor válido em minutos (mínimo 1).",
              },
            },
            outOfHoursMessageInterval: {
              label: "Intervalo da mensagem fora do expediente (minutos)",
              helper: "Envia o aviso uma vez por conversa a cada X minutos. 0 = a cada mensagem. Padrão: 60.",
              errors: {
                invalid: "Informe um valor em minutos entre 0 e 1440.",
              },
            },
            attendanceAlarmEnabled: {
              label: "Ativar alarmes no monitoramento",
              helper: "Quando ativado, tickets sem resposta entram em alarme visual após o tempo configurado.",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            attendanceAlarmResetEnabled: {
              label: "Permitir resetar alarme",
              helper: "Quando ativado, adiciona a opção 'Resetar Alarme' no menu do ticket para dar OK no alarme sem enviar mensagem ao cliente.",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            transcriptionApiKey: {
              label: "Chave OpenAI p/ transcrição de áudios",
              helper: "Com a chave configurada, áudios recebidos são transcritos automaticamente (Whisper) e exibidos abaixo do player. Deixe vazio para desativar. Cada áudio gera uma chamada à API da OpenAI.",
              showHide: "Mostrar/ocultar chave da API",
            },
            aiTransferNotifyEnabled: {
              label: "Aviso de transferência da IA",
              helper: "Quando a IA transferir um chamado, envia pelo WhatsApp um aviso com o resumo da conversa para os números configurados. No agente de IA, ligue também \"Notificar Transferência\".",
              options: {
                enabled: "Habilitado",
                disabled: "Desabilitado",
              },
            },
            aiTransferNotifyConnectionId: {
              label: "Conexão que envia o aviso",
              helper: "Somente conexões API Não-Oficial (Baileys). A conexão precisa estar conectada.",
              none: "Nenhuma",
            },
            aiTransferNotifyNumbers: {
              label: "Números que recebem o aviso",
              helper: "DDI + DDD + número, ex.: 5542999999999. Vários números: separe com ponto e vírgula.",
              errors: {
                invalid: "Número inválido. Use DDI + DDD + número, ex.: 5542999999999.",
              },
            },
            asaasToken: {
              label: "Token Asaas",
            },
          },
        },
        requiredFields: {
          title: "Campos obrigatórios de cadastro",
          description: "Defina quais campos serão obrigatórios no cadastro de clientes e de contatos (/contacts).",
          sections: {
            cliente: "Cadastro de Clientes",
            contacts: "Cadastro de Contatos (/contacts)",
          },
          buttons: {
            save: "Salvar configuração",
            saving: "Salvando...",
          },
          messages: {
            saved: "Configuração de campos obrigatórios salva com sucesso.",
            error: "Erro ao salvar configuração de campos obrigatórios.",
          },
          fields: {
            cliente: {
              NOMECLI: "Razão Social / Nome",
              NOMEFANTASIA: "Nome Fantasia",
              PESSOA: "Tipo de Pessoa",
              STATUS: "Status",
              USUARIO_RESPONSAVEL: "Usuário Responsável",
              INSCESTCLI: "Inscrição Estadual",
              insc_municipal: "Inscrição Municipal",
              suframa: "SUFRAMA",
              contribuinte_icms: "Contribuinte ICMS",
              DDDCLI: "DDD (Telefone)",
              E_MAIL: "E-mail",
              FONECLI: "Telefone",
              DDDCELULAR: "DDD (Celular)",
              CELULAR: "Celular",
              site: "Website",
              CEPCLI: "CEP",
              ENDCLI: "Endereço",
              NUMERO: "Número",
              BAIRROCLI: "Bairro",
              CIDADECLI: "Cidade",
              ESTADOCLI: "Estado",
              LIMITE: "Limite de Crédito",
              metas_vendas: "Metas de Vendas",
              potencial_vendas: "Potencial de Vendas",
              acoes_vendas: "Ações de Vendas",
              OBS: "Observações",
              CGCCLI: "CNPJ",
              CPFCLI: "CPF",
            },
            contacts: {
              name: "Nome",
              number: "Número",
              email: "E-mail",
            },
          },
        },
        kanban: {
          title: "Configurações do Kanban",
          description: "Gerencie as regras de criação de cards, agendamento e tempo sem interação.",
          loading: "Atualizando...",
          options: {
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
          requireSchedule: {
            label: "Agendamento obrigatório ao criar card",
            helper: "Quando habilitado, o card só é movido entre colunas com agendamento preenchido.",
          },
          creationMode: {
            label: "Criação de cards ao encerrar ticket",
            helper: "Define como o sistema se comporta ao encerrar um atendimento.",
            options: {
              optional: "Opcional",
              mandatory: "Obrigatório",
              hidden: "Oculto",
            },
          },
          duplicateContact: {
            label: "Card duplicado do mesmo contato",
            helper: "Define o que acontece quando o contato já tem card ao criar pelo atendimento.",
            options: {
              disabled: "Desativado",
              warn: "Avisar",
              blocked: "Bloquear",
            },
          },
          duplicateContactScope: {
            label: "Onde procurar o card do contato",
            helper: "Define o alcance da verificação de card duplicado do contato.",
            options: {
              column: "Mesma coluna do quadro",
              board: "Qualquer coluna do quadro",
              any: "Qualquer quadro",
            },
          },
          codcli: {
            label: "Enviar CODCLI em contratos do Kanban",
            helper: "Quando habilitado, envia o CODCLI do cliente vinculado ao card para geração de contratos.",
          },
          contactMethods: {
            title: "Meios de contato no relacionamento",
            description: "Defina quais meios de contato ficam disponíveis ao registrar relacionamento no Kanban.",
            helper: "Essas opções aparecerão nos formulários de relacionamento do Kanban.",
            placeholder: "Ex.: Prospecção",
            addButton: "Adicionar meio de contato",
            removeButton: "Remover meio de contato",
            options: {
              visit: "Visita",
              budget: "Orçamento",
              followUp: "Follow-up",
              negotiation: "Negociação",
              afterSales: "Pós-venda",
              complaint: "Reclamação",
              referral: "Indicação",
            },
          },
          inactivity: {
            title: "Tempo sem interação dos cards",
            description: "Defina em quantos dias o card muda de classe visual e a cor de cada nível.",
            rules: "Os tempos são em dias. A cor de Alerta é aplicada quando atingir o limite de Alerta; a cor Crítica quando atingir o limite Crítico; e a cor Urgente quando atingir o limite Urgente.",
            enableLabel: "Colorir cards por inatividade",
            enableHelper: "Quando desabilitado, os cards não recebem destaque visual por tempo sem interação.",
            noPermission: "Você não tem permissão para alterar as regras de tempo sem interação.",
            warningDays: "Alerta (dias)",
            warningColor: "Alerta (cor)",
            warningDaysHelper: "Ex.: 1",
            dangerDays: "Crítico (dias)",
            dangerColor: "Crítico (cor)",
            dangerDaysHelper: "Ex.: 3",
            criticalDays: "Urgente (dias)",
            criticalColor: "Urgente (cor)",
            criticalDaysHelper: "Ex.: 5",
          },
          messages: {
            scheduleSaved: "Configuração de agendamento atualizada com sucesso.",
            creationModeSaved: "Modo de criação de cards atualizado com sucesso.",
            duplicateContactSaved: "Verificação de card duplicado atualizada com sucesso.",
            codcliSaved: "Configuração de envio de CODCLI atualizada com sucesso.",
            contactMethodsSaved: "Meios de contato do relacionamento atualizados com sucesso.",
            inactivitySaved: "Configuração de tempo sem interação atualizada com sucesso.",
          },
          errors: {
            update: "Erro ao atualizar configuração.",
            contactMethodsEmpty: "Selecione pelo menos um meio de contato.",
            invalidDays: "Informe um valor de dias válido (0 ou maior).",
            invalidDaysOrder: "A ordem dos dias deve ser: Alerta <= Crítico <= Urgente.",
            invalidColor: "Informe uma cor válida no formato hexadecimal (ex.: #ff0000).",
          },
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          unifyTicketsByContact: {
            name: "Unificar conversas por contato",
            note: "Quando habilitado, todas as conversas de um contato são unificadas independente do número. Quando desabilitado, cada número WhatsApp terá uma conversa separada.",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          groupTicketUnify: {
            name: "Chamado de grupo com várias conexões",
            note: "Um por grupo: um único chamado por grupo, em qualquer conexão. Um por conexão: cada conexão tem o seu chamado do grupo e todos mostram a conversa inteira.",
            options: {
              enabled: "Um por grupo (qualquer conexão)",
              disabled: "Um por conexão",
            },
          },
          clientImport: {
            name: "Importação de Clientes",
            note: "Habilita ou desabilita a funcionalidade de importação de clientes do banco de dados externo. Quando desabilitado, o botão 'Importar Clientes' fica oculto.",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          webhookKommoSendCodcli: {
            name: "Enviar CODCLI em Contratos Kanban",
            note: "Quando habilitado, ao mover um card para a coluna de geração de contratos, o sistema envia o CODCLI do cliente vinculado ao card. Se desabilitado ou sem cliente, usa CODCLI padrão (1).",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
        email: {
          title: "Configurações de Email (SMTP)",
          description: "Configure os dados do servidor SMTP para envio de emails pelo sistema",
          fields: {
            host: "Servidor SMTP",
            hostPlaceholder: "smtp.exemplo.com",
            port: "Porta",
            user: "Usuário SMTP",
            userPlaceholder: "usuario@exemplo.com",
            password: "Senha SMTP",
            from: "Email Remetente",
            fromPlaceholder: "noreply@empresa.com",
            fromName: "Nome do Remetente",
            fromNamePlaceholder: "Sistema CRM",
            secure: "Usar SSL/TLS (recomendado para porta 465)",
            active: "Configuração Ativa",
          },
          buttons: {
            update: "Atualizar",
            test: "Testar Email",
          },
          testDialog: {
            title: "Enviar Email de Teste",
            description: "Digite um endereço de email válido para receber o email de teste:",
            email: "Email de Teste",
            emailPlaceholder: "teste@exemplo.com",
            send: "Enviar",
          },
          toasts: {
            requiredFields: "Por favor, preencha todos os campos obrigatórios",
            updated: "Configurações de email atualizadas com sucesso!",
            saved: "Configurações de email salvas com sucesso!",
            saveError: "Erro ao salvar configurações de email",
            fillBeforeTest: "Por favor, preencha as configurações antes de testar",
            invalidEmail: "Por favor, insira um endereço de email válido",
            testError: "Erro ao enviar email de teste",
          },
        },
        instagram: {
          title: "Configurações do Instagram (Instagram Login)",
          info: {
            beforeProduct: "Credenciais do produto",
            afterProduct: "do seu app na Meta. São usadas no login facilitado (OAuth) e na verificação de assinatura dos webhooks. Obtenha o App ID e o App Secret do Instagram em",
            path: "> seu app > Instagram > Configuração da API.",
          },
          managedByServer: {
            title: "O aplicativo da Meta já está configurado neste servidor.",
            description: "As credenciais abaixo são ignoradas — o login facilitado usa as variáveis do servidor (IG_APP_ID, IG_APP_SECRET, IG_REDIRECT_URI). Os campos seguem disponíveis apenas para instalações que ainda não migraram.",
          },
          fields: {
            appIdHelper: "Instagram app ID (produto Instagram do app Meta)",
            appIdPlaceholder: "Ex: 123456789012345",
            appSecretHelper: "Usado no OAuth e na verificação HMAC do webhook",
            verifyTokenHelper: "Token definido por você para verificação do webhook no painel da Meta",
            graphVersion: "Versão da Graph API",
            latest: "Mais Recente",
            redirectUriHelper: "Deve ser idêntica à URI cadastrada no app da Meta (Instagram > Configuração da API > Business Login)",
          },
          webhookUrl: "URL do Webhook (configure no painel da Meta, produto Instagram > Webhooks, campos messages e comments):",
          suggestedRedirectUri: "Redirect URI OAuth sugerida:",
          save: "Salvar Configurações",
          toasts: {
            loadError: "Erro ao carregar configurações do Instagram",
            saved: "Configurações do Instagram salvas com sucesso!",
            saveError: "Erro ao salvar configurações do Instagram",
          },
        },
        instagramWebhooks: {
          title: "Monitor de Webhooks do Instagram",
          description: "Acompanhe em tempo real os webhooks que a Meta envia para este sistema. Use o botão \"Testar\" no painel da Meta (ou \"Simular\" abaixo) e veja aqui se o evento chegou, em qual formato, se a assinatura é válida e se o backend reconhece o campo para fazer o processamento.",
          status: {
            processed: "Processado",
            received: "Recebido",
            ignored: "Ignorado",
            error: "Erro",
          },
          simulated: "simulado",
          recognized: "Reconhecido",
          recognizedTooltip: "Há processamento dedicado no backend",
          unhandled: "Sem handler",
          unhandledTooltip: "Webhook chega, mas ainda sem processamento dedicado",
          signatureInvalid: "inválida",
          signatureInvalidTooltip: "Assinatura HMAC inválida",
          signatureValidTooltip: "Assinatura HMAC verificada",
          payload: "Payload recebido",
          legend: {
            recognized: "reconhecido (processado pelo backend)",
            unhandled: "sem handler dedicado (chega, mas ainda não é processado)",
          },
          simulateAll: "Simular todos os campos",
          table: {
            receivedAt: "Recebido em",
            field: "Campo",
            signature: "Assinatura",
            connection: "Conexão",
            detail: "Detalhe",
          },
          empty: "Nenhum webhook recebido ainda. Clique em \"Simular\" ou dispare um teste no painel da Meta.",
          toasts: {
            loadError: "Não foi possível carregar os eventos de webhook.",
            cleared: "Eventos limpos.",
            clearError: "Falha ao limpar eventos.",
            simulated: "Eventos simulados gerados (um por campo).",
            simulateError: "Falha ao simular eventos.",
          },
        },
        onSpace: {
          title: "Integração OnSpace",
          description: "Sempre que um contato enviar uma mensagem no WhatsApp, o ChatCRM notificará o OnSpace automaticamente para registrar o lead na Conferência de Agendamentos.",
          fields: {
            url: "URL do OnSpace",
            urlPlaceholder: "https://meuonspace.com.br",
            urlHelper: "URL base do sistema OnSpace (sem barra no final)",
            salaoId: "Salão ID",
            salaoIdPlaceholder: "Ex: 123",
            salaoIdHelper: "ID do salão/clínica no OnSpace (obrigatório)",
            apiKey: "API Key do OnSpace",
            apiKeyPlaceholder: "Deixe em branco se não utilizar autenticação",
            apiKeyHelper: "Enviada no header x-api-key (opcional)",
          },
          toasts: {
            salaoIdInvalid: "Salão ID é obrigatório e deve ser um número inteiro.",
            saved: "Configurações do OnSpace salvas com sucesso!",
            saveError: "Erro ao salvar configurações do OnSpace.",
          },
        },
        schedulesUpdated: "Horários atualizados com sucesso.",
        systemAlerts: {
          title: "Alertas do sistema por WhatsApp",
          description: "Avisa por WhatsApp quando o sistema detectar congestionamento no acesso ao banco de dados — o sinal que antecede as travas de atendimento. Esta configuração vale para a instalação inteira: o alerta cobre todas as empresas, e a conexão escolhida pode ser de qualquer uma delas. O aviso sai no máximo uma vez a cada 15 minutos, e uma segunda mensagem confirma quando tudo normaliza.",
          enabled: "Enviar alertas por WhatsApp",
          connection: "Conexão de envio",
          noConnection: "Nenhuma",
          connectionHint: "Qualquer conexão do sistema, de qualquer empresa. Prefira uma que não seja a principal de atendimento.",
          numbers: "Números de destino",
          numbersHint: "Separe por ponto e vírgula, com DDI e DDD.",
          validNumbers: "{{count}} número válido.",
          validNumbers_plural: "{{count}} números válidos.",
          invalidEntries: "{{count}} entrada será ignorada por não parecer um número.",
          invalidEntries_plural: "{{count}} entradas serão ignoradas por não parecerem um número.",
          sendTest: "Enviar alerta de teste",
          testHint: "O teste ignora o intervalo mínimo e usa a configuração já salva — salve antes de testar.",
          toasts: {
            loadError: "Não foi possível carregar as configurações de alerta.",
            saved: "Configurações de alerta salvas.",
            saveError: "Não foi possível salvar as configurações de alerta.",
            testSent: "Alerta de teste enviado para {{count}} número.",
            testSent_plural: "Alerta de teste enviado para {{count}} números.",
            testNotSent: "Não foi possível enviar: {{reason}}.",
            unknownError: "erro desconhecido",
            testError: "Falha ao disparar o alerta de teste.",
          },
        },
        cloudApi: {
          title: "Configurações Globais da Meta Cloud API",
          info: "Estas configurações são globais e compartilhadas entre todas as conexões Cloud API. O App Secret e o Verify Token são definidos no painel de Apps da Meta e são únicos por aplicativo.",
          managedByServer: "As credenciais abaixo são ignoradas — o login facilitado usa as variáveis do servidor (META_APP_ID, META_APP_SECRET, META_CONFIG_ID). Os campos seguem disponíveis apenas para instalações que ainda não migraram.",
          embeddedSignup: {
            title: "Embedded Signup (Conexão com 1 clique)",
            description: "Configure o Facebook App ID e o Config ID para permitir que os usuários conectem o WhatsApp Business com apenas um clique, sem precisar inserir manualmente WABA ID, Phone Number ID e Token. Obtenha esses valores no",
          },
          globalSection: "Configurações Globais",
          fields: {
            appIdHelper: "ID do aplicativo Meta (menu Configurações > Básico no painel de Apps)",
            configIdHelper: "ID da configuração do WhatsApp Embedded Signup (WhatsApp > Configuração da API > Embedded Signup)",
            appSecretHelper: "Secret do aplicativo Meta (menu Configurações > Básico no painel de Apps)",
            apiVersion: "Versão da API",
          },
          webhookUrl: "URL do Webhook (configure no painel de Apps da Meta):",
          toasts: {
            loadError: "Erro ao carregar configurações da Cloud API",
            saved: "Configurações da Cloud API salvas com sucesso!",
            saveError: "Erro ao salvar configurações da Cloud API",
          },
        },
      },
      messagesList: {
				queueFailed: {
					message: "Mensagem não enviada: \"{{preview}}\". {{reason}}",
					genericReason: "Tente enviar de novo.",
				},
				system: {
					ratedHidden: "Cliente avaliou o atendimento em {{date}} (Ticket #{{ticket}})",
					rated: "Cliente avaliou o atendimento com nota {{rate}} de {{max}} em {{date}} (Ticket #{{ticket}})",
					closedBy: "Atendimento finalizado por {{user}} em {{date}} (Ticket #{{ticket}})",
					takenBy: "Chamado assumido por ({{user}}) - {{date}}",
					transferredBy: "Chamado transferido por ({{user}}) - De {{from}} para {{to}} - {{date}}",
					transferredFromTo: "Chamado transferido de {{from}} para {{to}} - {{date}}",
					transferredToPendingQueue: "Chamado transferido por ({{user}}) - De {{from}} para Aguardando na fila {{queue}} - {{date}}",
					transferredToPendingNoQueue: "Chamado transferido por ({{user}}) - De {{from}} para Aguardando sem fila - {{date}}",
					started: "Início do chamado - {{queue}} ({{user}}) - {{date}}",
					systemUser: "Sistema",
					adminQueue: "ADMINISTRATIVO",
					queueFallback: "Fila",
				},
				chips: {
					unknownDate: "data desconhecida",
					ticketMissing: "Chamado #{{ticket}} (não encontrado) — mensagens a partir de {{date}}",
					openedExternal: "Chamado aberto por mensagem enviada externamente em {{date}} (Ticket #{{ticket}})",
					openedByAgent: "Atendimento iniciado por {{user}} em {{date}} (Ticket #{{ticket}})",
					openedByCustomer: "Chamado aberto por mensagem do cliente em {{date}} (Ticket #{{ticket}})",
					openedByImport: "Histórico importado do celular a partir de {{date}} (Ticket #{{ticket}})",
				},
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
        emptyChat: "Diga olá para seu novo contato!",
        transcription: {
          label: "Transcrição:",
          processing: "Transcrevendo áudio…",
          retry: "Tentar novamente",
        },
        media: {
          downloading: "Baixando mídia…",
          downloadingShort: "Baixando…",
          failed: "Não foi possível baixar esta mídia.",
          retry: "Tentar novamente",
          unavailable: "Mídia indisponível",
          download: "Download",
        },
        mediaViewer: {
          open: "Abrir no visualizador",
          goToMessage: "Ir para a mensagem",
          zoomIn: "Ampliar",
          zoomOut: "Reduzir",
        },
        jumpNotFound: "A mensagem selecionada não foi encontrada no histórico deste ticket.",
        jumpTooOld: "A mensagem é antiga demais para o salto direto. Role o histórico para chegar até ela.",
        jumpToQuoted: "Ir para a mensagem citada",
        documentCard: {
          label: "Documento",
          open: "Abrir",
          download: "Baixar",
        },
        interactive: {
          viewOptions: "Ver opções",
          poll: "Enquete",
          pollSelectOne: "Selecione uma opção",
          pollSelectMany: "Selecione uma ou mais opções",
        },
        catalog: {
          productTitle: "Produto",
          productsTitle: "Produtos",
          orderTitle: "Pedido",
          orderTotal: "Total",
          orderLoading: "Carregando itens do pedido…",
          orderFailed: "Não foi possível carregar os itens deste pedido.",
          sku: "SKU",
          unnamedProduct: "Produto sem nome",
        },
        forwardSelection: {
          selectedSingle: "{{count}} mensagem selecionada",
          selectedMultiple: "{{count}} mensagens selecionadas",
          forwardMessages: "Encaminhar mensagens",
          cancelSelection: "Cancelar seleção",
        },
        forwarded: {
          label: "Encaminhada",
          frequently: "Encaminhada com frequência",
        },
        instagram: {
          postTooltip: "Post: {{caption}}",
          openCommentedPost: "Abrir a publicação comentada",
          commentedPostAlt: "Publicação comentada",
          comment: "Comentário",
          publicReply: "Resposta pública",
          viewPost: "ver post",
          reply: "Responder",
          replyPublic: "Responder no post (público)",
          replyDm: "Responder por DM",
          dm: {
            storyMention: "Mencionou você no story",
            storyReply: "Respondeu ao seu story",
            reel: "Reel",
            post: "Post",
            shared: "Conteúdo compartilhado",
            watchHere: "Assistir aqui",
            closePlayer: "Fechar player",
            openInInstagram: "Abrir no Instagram",
            downloadMedia: "Baixar mídia",
            storyExpired: "A mídia do story não foi baixada a tempo; stories expiram em 24h.",
            reelPlayerTitle: "Reel do Instagram",
          },
        },
        contactFallback: "Contato",
        you: "Você",
        mention: {
          noNumber: "Não foi possível iniciar conversa direta: participante sem número disponível.",
          dialogTitle: "Participante marcado",
          dialogText: "Você marcou este participante no grupo.",
          name: "Nome:",
          number: "Número:",
          notAvailable: "Não disponível",
          chatPrivately: "Conversar no privado",
        },
        sharedContact: {
          unnamed: "Contato sem nome",
          startMissingNumber: "Não foi possível iniciar a conversa: número não encontrado no contato compartilhado.",
          startSaveFailed: "Não foi possível iniciar a conversa: falha ao salvar o contato compartilhado.",
          alreadyExists: "O contato já existe no banco de dados.",
          saved: "Contato salvo com sucesso!",
          saveMissingNumber: "Não foi possível salvar: número não encontrado no contato compartilhado.",
          saveFailed: "Não foi possível salvar o contato compartilhado.",
          shared: "Contato compartilhado",
          quotedWithNumber: "Contato: {{name}} - {{number}}",
          quotedName: "Contato: {{name}}",
          quotedMultiple: "Contatos compartilhados: {{count}}",
          summaryOthers: "{{name}} e {{count}} outro contato",
          summaryOthers_plural: "{{name}} e {{count}} outros contatos",
          count: "{{count}} contato",
          count_plural: "{{count}} contatos",
          viewAll: "Ver todos",
          chat: "Conversar",
        },
        delivery: {
          failedWithCode: "Falha no envio: {{error}} (código Meta: {{code}})",
          failedWithError: "Falha no envio: {{error}}",
          failed: "Falha no envio da mensagem",
        },
        pendingAck: {
          timeoutHandled: "Timeout de callback já tratado com reenvio manual de template.",
          timeoutHandledShort: "Timeout já tratado com reenvio.",
          timeoutMinutes: "Sem confirmação de status da Meta há mais de {{minutes}} minutos. {{reason}}",
          timeoutLong: "Sem confirmação de status da Meta por muito tempo. {{reason}}",
          defaultReason: "A mensagem foi aceita no envio inicial, mas não recebemos callback de sent/delivered/read/failed.",
          awaitingMeta: "Mensagem enviada para a Meta e aguardando confirmação de status (sent/delivered/read). Isso pode ocorrer por atraso no callback do webhook.",
          processing: "Mensagem em processamento. Ainda não recebemos confirmação de status.",
        },
        reactions: {
          allTab: "Todas {{total}}",
          empty: "Nenhuma reação nesta categoria.",
          clickToRemove: "Clique para remover",
          react: "Reagir",
          search: "Pesquisar reação",
          notFound: "Nenhum emoji encontrado",
          categories: {
            search: "Resultados",
            recent: "Reações recentes",
            people: "Smileys e pessoas",
            nature: "Animais e natureza",
            foods: "Comidas e bebidas",
            activity: "Atividades",
            places: "Viagens e lugares",
            objects: "Objetos",
            symbols: "Símbolos",
            flags: "Bandeiras",
            custom: "Personalizados",
          },
        },
        connectionBadge: {
          withDetails: "Conexão: {{details}}",
          withId: "Conexão #{{id}}",
        },
        historyLoaded: "HISTÓRICO - Todas as conversas anteriores foram carregadas",
        deleted: {
          byAgent: "Essa mensagem foi apagada pelo atendente",
          byContact: "Essa mensagem foi apagada pelo contato",
          hide: "Ocultar mensagem",
          show: "Ver mensagem",
        },
        quoted: {
          statusAuthor: "{{author}} • Status",
        },
        callLog: {
          call: "Chamada",
          started: "Iniciada",
          video: "Chamada de video",
          voice: "Chamada de voz",
          fallback: "{{call}} {{status}} em {{date}}",
        },
        edited: {
          label: "Editada",
          original: "Original: {{body}}",
        },
        openTicketFailed: "Não foi possível abrir a conversa. Dados do ticket não encontrados.",
        existingTicket: {
          title: "Conversa já existente",
          text: "Já existe uma conversa aberta com este contato. Deseja abrir a conversa existente?",
          agent: "Atendente:",
          queue: "Fila:",
          open: "Abrir Conversa",
        },
        goToBottom: "Ir para o fim da conversa",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagens",
        selectedCount: "Mensagens selecionadas: {{count}}",
        previewPrefix: "Prévia",
        previewContactWithNumber: "Contato: {{name}} - {{number}}",
        previewContactWithName: "Contato: {{name}}",
        previewContactWithNumberOnly: "Contato: {{number}}",
        previewSharedContact: "Contato compartilhado",
        previewSharedLocation: "Localização compartilhada",
        previewMedia: "Mídia ({{mediaType}})",
        previewFile: "arquivo",
        searchContactLabel: "Buscar contato (nome ou número)",
        loadMoreContacts: "Carregar mais contatos",
        forwarding: "Encaminhando...",
        forward: "Encaminhar",
        cancel: "Cancelar",
        successSingle: "Mensagem encaminhada para {{name}}",
        successMultiple: "{{count}} mensagens encaminhadas para {{name}}",
        stoppedOnError: "Encaminhamento interrompido por falha em uma das mensagens.",
        windowClosed: "A janela de 24h de {{name}} está fechada. Acesse o atendimento com esse contato e envie um template para reabrir antes de encaminhar.",
      },
      messagesInput: {
				recordingPaused: "Pausado",
        placeholderOpen: "Digite uma mensagem",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        placeholderReopen: "Digite para reabrir e enviar mensagem...",
        signMessage: "Assinar",
        tooltips: {
					pauseRecording: "Pausar gravação",
					resumeRecording: "Continuar gravação",
          emojiPicker: "Emoji",
          moreActions: "Mais ações",
          attachFile: "Anexar arquivo",
          sendContact: "Enviar contato",
          quickMessages: "Respostas rápidas",
          stickers: "Figurinhas",
          sendTemplate: "Enviar template",
          signMessage: "Assinar mensagens",
          sendMessage: "Enviar mensagem",
          voiceMessage: "Mensagem de voz",
        },
        failedAudio: {
          title: "Áudio não enviado",
          resend: "Reenviar áudio",
          discard: "Descartar áudio",
        },
        errors: {
          ticketIdNotFound: "ID do ticket não encontrado",
          noQueueAccess: "Você não tem acesso à fila deste chamado",
          otherOpenTicketSentHere: "Este contato já tem outro atendimento em andamento. A mensagem foi enviada neste chamado, que continua como está.",
          noQueueAccessNewTicket: "Você não tem acesso à fila deste chamado. A mensagem foi enviada em um chamado novo seu.",
        },
        replyPreview: {
          contactWithNumber: "Contato: {{name}} - {{number}}",
          contact: "Contato: {{value}}",
          sharedContact: "Contato compartilhado",
        },
        attachedFile: "Arquivo anexado",
        mentionFallbackName: "Contato",
        connection: {
          selectedTooltip: "Conexão: {{name}}",
          selectedFallback: "Selecionada",
          select: "Selecionar conexão",
        },
        cloudApi: {
          windowExpiredPlaceholder: "Janela de 24h expirada — envie um template pelo botão laranja ao lado",
          windowExpiredInline: "Janela de 24h expirada. Use o botão de template para enviar mensagem.",
          windowExpiredTitle: "Janela de 24 horas expirada",
          windowExpiredText: "A janela de 24 horas expirou. Envie um template de mensagem para iniciar uma nova conversa.",
          noTemplates: "Nenhum modelo de mensagem aprovado encontrado. Crie e submeta templates para aprovação na página de Templates.",
          selectTemplate: "Selecione um modelo",
          preview: "Pré-visualização:",
          emptyBody: "(Sem texto no corpo)",
          variables: "Variáveis:",
          variableLabel: "Variável {{name}}",
          templateSent: "Template enviado com sucesso!",
          sending: "Enviando...",
          send: "Enviar",
        },
        stickers: {
          removed: "Figurinha removida da biblioteca.",
          openTicketToPull: "Abra um ticket para puxar figurinhas da conversa.",
          pulled: "Figurinhas puxadas do WhatsApp: {{count}}.",
          pullFromWhatsApp: "Puxar do WhatsApp",
          empty: "Nenhuma figurinha encontrada na conversa deste ticket no WhatsApp.",
          favorites: "Favoritas",
          library: "Biblioteca",
          removeFromLibrary: "Remover da biblioteca",
          removeTitle: "Remover figurinha",
          removeConfirm: "Esta figurinha será removida da biblioteca para todos os usuários da empresa.",
        },
        media: {
          dropHere: "Solte o arquivo aqui para enviar",
          filesSelected: "{{count}} arquivo selecionado",
          filesSelected_plural: "{{count}} arquivos selecionados",
          captionPlaceholder: "Digite uma legenda (opcional)...",
        },
        instagram: {
          replyingPublic: "Respondendo no post (público)",
          replyingDm: "Respondendo por DM",
        },
      },
      messageSearchDrawer: {
        title: "Pesquisar mensagens",
        placeholder: "Pesquisar",
        prompt: "Pesquisar por mensagens nesta conversa.",
        noResults: "Nenhuma mensagem encontrada.",
        previousTicket: "Ticket anterior",
        loadMore: "Carregar mais",
        you: "Você",
        contact: "Contato",
      },
      contactDrawer: {
        header: "Dados do contato",
        headerGroup: "Dados do Grupo",
        buttons: {
          edit: "Editar contato",
          merge: "Unificar contato",
        },
        favorites: {
          title: "Mensagens favoritas",
          none: "Nenhuma",
          noMessages: "Nenhuma mensagem favoritada para este contato.",
          loadMore: "Carregar mais",
          loading: "Carregando...",
          previewAlt: "Pré-visualização da mídia",
          ticketLabel: "Ticket",
          senderYou: "Você",
          senderContact: "Contato",
          messageDeleted: "Mensagem apagada",
          image: "Imagem",
          media: "Mídia",
          messageWithoutContent: "Mensagem sem conteúdo",
          ticketNotFound: "Não foi possível localizar o ticket desta mensagem.",
          messageFromAnotherTicket: "Esta mensagem pertence a outro ticket. Abra esse ticket para navegar até ela."
        },
        shared: {
          mediaTab: "Media",
          docsTab: "Docs",
          linksTab: "Links",
          loadMore: "Carregar mais",
          loading: "Carregando...",
          previewAlt: "Pré-visualização",
          image: "Imagem",
          video: "Vídeo",
          document: "Documento",
          link: "Link",
          empty: {
            media: "Nenhuma mídia compartilhada neste chat.",
            docs: "Nenhum documento compartilhado neste chat.",
            links: "Nenhum link compartilhado neste chat."
          }
        },
        extraInfo: "Outras informações",
        toasts: {
          merged: "Contato unificado com sucesso. A atualização será aplicada automaticamente.",
        },
        members: {
          title: "Membros do Grupo",
          count: "{{count}} membro",
          count_plural: "{{count}} membros",
          groupLabel: "Grupo",
          updated: "Atualizado {{when}}",
          syncTooltip: "Atualizar membros manualmente",
          syncing: "Atualizando membros...",
          synced: "Membros do grupo atualizados!",
          loadError: "Não foi possível carregar os membros. Verifique se o WhatsApp está conectado e tente sincronizar novamente.",
          admin: "Admin",
          startConversation: "Iniciar conversa",
          participantNotLinked: "Este participante não está vinculado a um contato cadastrado.",
          alreadyAttended: "Este contato já está sendo atendido por {{name}}.",
          anotherAttendant: "outro atendente",
          lastSync: {
            now: "agora",
            minutes: "há {{count}} min",
            hours: "há {{count}}h",
          },
        },
      },
      mergeContactModal: {
        title: "Unificar Contatos",
        currentContact: "Contato atual:",
        searchPlaceholder: "Buscar contato por nome ou número...",
        noContactsFound: "Nenhum contato encontrado",
        searchHint: "Digite pelo menos 2 caracteres para buscar",
        warning: "Esta ação não pode ser desfeita!",
        mergeInfoTitle: "O que será unificado:",
        mergeInfo1: "Todos os tickets serão movidos para o contato principal",
        mergeInfo2: "Todas as mensagens serão migradas",
        mergeInfo3: "O contato duplicado será removido",
        success: "Contatos unificados com sucesso!",
        buttons: {
          cancel: "Cancelar",
          merge: "Unificar",
          merging: "Unificando...",
        },
        selectContact: "Selecione um contato para unificar",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
        validation: {
          nameTooShort: "Nome muito curto",
        },
      },
        ticketActionButtons: {
          mandatoryKanbanCard: "Card no Kanban é obrigatório",
          mandatoryKanbanCardMessage: "Você precisa criar um card no Kanban antes de encerrar este atendimento.",
          optionalKanbanCard: "Deseja criar um card no Kanban?",
          optionalKanbanCardMessage: "Você gostaria de criar um card no Kanban para este atendimento?",
          confirmKanbanCard: "Deseja criar um card no Kanban antes de encerrar?",
          createCard: "Criar Card",
          skip: "Pular",
          withoutInteractionTitle: "Finalizar sem interação?",
          withoutInteractionMessage:
            "Você não enviou nenhuma mensagem ao contato neste chamado. Deseja finalizar mesmo assim? O chamado será contabilizado como finalizado sem interação.",
          completionMessageTitle: "Enviar mensagem de conclusão?",
          completionMessageText: "A conexão deste chamado está configurada para enviar a mensagem abaixo ao contato quando o chamado é finalizado:",
          completionMessageBatchHint: "A resposta vale para todos os chamados selecionados.",
          completionMessageSend: "Enviar",
          completionMessageSkip: "Não enviar",
          tooltips: {
            searchMessages: "Pesquisar mensagens",
            createKanbanCard: "Criar Card no Kanban",
            call: "Ligar pelo WhatsApp",
            inCall: "Em ligação com este contato",
          },
        },
      calls: {
        status: {
          dialing: "Iniciando ligação…",
          ringing: "Chamando…",
          answering: "Conectando…",
          incoming: "Ligação recebida",
          connected: "Em ligação · {{time}}",
          endedReasons: {
            ended: "Ligação encerrada",
            rejected: "Ligação recusada",
            missed: "Não atendida",
            mediaFailed: "Falha na conexão de áudio",
          },
        },
        actions: {
          answer: "Atender",
          ignore: "Ignorar",
          hangUp: "Desligar",
          mute: "Desativar microfone",
          unmute: "Ativar microfone",
          openTicket: "Abrir atendimento",
          close: "Fechar",
        },
        permission: {
          title: "Ligar pelo WhatsApp",
          noPermission: "{{name}} ainda não autorizou receber ligações deste número. Envie um pedido de permissão: o cliente recebe um botão no WhatsApp para aceitar (vale por 7 dias).",
          waitingReply: "Pedido enviado. Assim que o cliente aceitar, o botão de ligar é liberado aqui.",
          windowClosed: "A janela de 24 horas está fechada, então o pedido não pode ser enviado agora. Espere o cliente mandar uma mensagem ou envie um modelo de permissão de ligação pelo seletor de templates.",
          requestLimit: "O limite de pedidos de permissão para este contato foi atingido (1 por dia, 2 por semana). Libera em {{date}}.",
          callLimit: "O limite de ligações para este contato foi atingido. Libera em {{date}}.",
          granted: "{{name}} autorizou receber ligações.",
          callingDisabled: "As ligações não estão habilitadas nesta conexão. Um administrador pode habilitar em Conexões → editar a conexão → Ligações.",
          lookupFailed: "Não foi possível consultar a permissão de ligação deste contato agora.",
          staleCall: "Você tem uma ligação anterior que ainda consta em andamento. Encerre-a para poder ligar.",
          request: "Pedir permissão",
          requestAgain: "Pedir de novo",
          requested: "Pedido de permissão enviado ao contato.",
          callNow: "Ligar agora",
          callAnyway: "Tentar ligar",
          endStaleCall: "Encerrar ligação anterior",
        },
        errors: {
          alreadyInCall: "Você já está em uma ligação.",
          microphone: "Não foi possível usar o microfone. Libere o acesso ao microfone no navegador e tente de novo.",
          insecureContext: "O navegador só libera o microfone em páginas HTTPS. Acesse o sistema pelo endereço com https.",
        },
        warnings: {
          otherOpenTicketCalledHere: "Este contato já tem outro atendimento em andamento. A ligação será feita neste chamado, que continua como está.",
          noQueueAccessNewTicket: "Você não tem acesso à fila deste chamado. A ligação será feita em um chamado novo seu.",
        },
        settings: {
          title: "Ligações (WhatsApp Calling)",
          help: "Permite ligar e atender ligações de voz pelo navegador. Exige número com limite de pelo menos 2.000 conversas por dia e o campo de webhook “calls” assinado no app da Meta. Ligações feitas pela empresa são cobradas por minuto pela Meta. As ligações recebidas seguem a configuração “Aceitar Chamada”.",
          status: "Ligações neste número",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          iconVisibility: "Ícone de ligação para o cliente",
          iconDefault: "Visível",
          iconHidden: "Oculto",
          callbackPermission: "Quem liga para a empresa já autoriza retorno",
          save: "Salvar ligações",
          saved: "Configurações de ligação salvas.",
          loadError: "Não foi possível ler as configurações de ligação deste número.",
        },
      },
      linkClienteModal: {
        title: "Vincular contato a cliente",
        contact: "Contato",
        searchLabel: "Buscar cliente",
        searchHelper: "Busque por nome fantasia, razão social ou CNPJ",
        newCliente: "Criar novo cliente",
        success: "Contato vinculado ao cliente com sucesso!",
        alreadyLinked: "Este contato já está vinculado a este cliente.",
        buttons: {
          cancel: "Cancelar",
          link: "Vincular",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        linkCliente: "Vincular a cliente",
        agents: "Agentes",
        registerAppointment: "Observações do Contato",
        appointmentsModal: {
          title: "Observações do Contato",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket",
		  titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      ticketAIAgentModal: {
        title: "Agentes",
        searchLabel: "Selecionar agente de IA",
        searchPlaceholder: "Busque pelo nome do agente",
        noOptions: "Nenhum agente encontrado",
        none: "Nenhum",
        currentAgent: "Agente atual: {{agent}}",
        clearHumanAttendant: "Remover atendente humano atual desta conversa",
        buttons: {
          cancel: "Cancelar",
          remove: "Remover agente",
          save: "Salvar",
        },
        success: {
          assigned: "Agente de IA atribuído com sucesso.",
          removed: "Agente de IA removido com sucesso.",
        },
        errors: {
          invalidTicket: "Ticket inválido para atribuir agente.",
          selectAgent: "Selecione um agente para continuar.",
        },
        warnings: {
          humanAttendantLinked: "Atenção: enquanto houver atendente humano vinculado, a IA não responde às mensagens.",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        deleteForEveryone: "Apagar para todos",
        deleteForMe: "Apagar para mim",
        copy: "Copiar mensagem",
        copyImage: "Copiar Imagem",
        saveImage: "Salvar imagem",
        favorite: "Favoritar mensagem",
        unfavorite: "Desfavoritar mensagem",
        markPending: "Marcar como pendente",
        unmarkPending: "Remover pendência",
        reply: "Responder",
        replyPrivate: "Responder no privado",
        forward: "Encaminhar",
        edit: "Editar",
        details: "Detalhes da mensagem",
        copySuccess: "Mensagem copiada com sucesso.",
        copyImageUrlSuccess: "URL da imagem copiada com sucesso.",
        copyError: "Não foi possível copiar a mensagem.",
        replyPrivateError: "Não foi possível identificar o número do remetente.",
        confirmationModal: {
          title: "Apagar mensagem?",
          titleDeleteForEveryone: "Apagar para todos?",
          titleDeleteForMe: "Apagar para mim?",
          message: "Esta ação não pode ser revertida.",
          messageDeleteForEveryone: "Esta mensagem será apagada para você e para o destinatário.",
          messageDeleteForMe: "Esta mensagem será apagada apenas para você. O destinatário ainda poderá vê-la.",
        },
        editModal: {
          title: "Editar mensagem",
          body: "Nova mensagem",
          cancel: "Cancelar",
          confirm: "Salvar",
        },
        editErrors: {
          tooOld: "Esta mensagem não pode mais ser editada (limite de 15 minutos).",
          cannotEdit: "Não foi possível editar a mensagem.",
          notFromMe: "Você só pode editar mensagens enviadas por você.",
          deleted: "Mensagens deletadas não podem ser editadas.",
          media: "Mensagens de mídia não podem ser editadas.",
        },
        stickerNoMedia: "Figurinha sem mídia para salvar.",
        stickerAdded: "Figurinha adicionada às minhas figurinhas.",
        imageFilename: "imagem",
        addToMyStickers: "Adicionar às minhas figurinhas",
      },
      pendingMessages: {
        title: "Mensagens Pendentes",
        rowsPerPage: "Linhas por página",
        filters: {
          search: "Buscar mensagem",
          contact: "Contato",
          dateFrom: "Pendência de",
          dateTo: "Pendência até",
          pendingUser: "Criado por",
          whatsapp: "Canal WhatsApp",
          status: "Status",
          all: "Todos"
        },
        table: {
          pendingAt: "Data/Hora pendência",
          contact: "Contato",
          pendingUser: "Usuário",
          whatsapp: "WhatsApp",
          status: "Status",
          message: "Mensagem",
          actions: "Ações",
          removePending: "Remover pendência",
          viewMessages: "Visualizar mensagens",
          messageDeleted: "Mensagem apagada",
          messageWithoutContent: "Mensagem sem conteúdo",
          image: "Imagem",
          video: "Vídeo",
          audio: "Áudio",
          document: "Documento",
          sticker: "Figurinha",
          fileTypePrefix: "Arquivo"
        },
        statuses: {
          none: "Sem status",
          aguardando: "Aguardando",
          em_analise: "Em Análise",
          em_producao: "Em Produção",
          retornar_cliente: "Retornar Cliente",
          finalizado: "Finalizado",
          atrasado: "Atrasado"
        },
        toasts: {
          removed: "Pendência removida com sucesso",
          statusUpdated: "Status atualizado",
          ticketNotFound: "Ticket não encontrado para esta mensagem.",
          loadConversationFailed: "Não foi possível carregar a conversa deste ticket.",
        }
      },
      languages: {
        pt: "Português",
        en: "English",
        es: "Español",
      },
      forgetPassword: {
        title: "Redefinir senha",
        toasts: {
          emailSent: "Email enviado com sucesso!",
          passwordReset: "Senha redefinida com sucesso.",
          emailNotFound: "Email não encontrado",
        },
        buttons: {
          signup: "Não tem uma conta? Cadastre-se!",
          resetPassword: "Redefinir Senha",
          sendEmail: "Enviar Email",
        },
        form: {
          verificationCode: "Código de Verificação",
          newPassword: "Nova senha",
          confirmPassword: "Confirme a senha",
        },
        validation: {
          passwordRule: "Sua senha precisa ter no mínimo 8 caracteres, sendo uma letra maiúscula, uma minúscula e um número.",
        },
      },
      kanban: {
        lanes: {
          open: "Em aberto",
        },
      },
      common: {
				dateTimeAt: "{{date}} às {{time}}",
        yes: "Sim",
        no: "Não",
        ok: "OK",
        cancel: "Cancelar",
        save: "Salvar",
        saving: "Salvando...",
        close: "Fechar",
        delete: "Excluir",
        edit: "Editar",
        add: "Adicionar",
        new: "Novo",
        search: "Buscar",
        filter: "Filtrar",
        clear: "Limpar",
        back: "Voltar",
        next: "Próximo",
        previous: "Anterior",
        confirm: "Confirmar",
        loading: "Carregando...",
        loadMore: "Carregar mais",
        all: "Todos",
        none: "Nenhum",
        noRecords: "Nenhum registro encontrado",
        noResults: "Nenhum resultado encontrado",
        actions: "Ações",
        name: "Nome",
        email: "E-mail",
        phone: "Telefone",
        status: "Status",
        type: "Tipo",
        date: "Data",
        startDate: "Data inicial",
        endDate: "Data final",
        from: "De",
        to: "Até",
        total: "Total",
        active: "Ativo",
        inactive: "Inativo",
        enabled: "Habilitado",
        disabled: "Desabilitado",
        required: "Obrigatório",
        optional: "Opcional",
        export: "Exportar",
        exportExcel: "Exportar Excel",
        print: "Imprimir",
        refresh: "Atualizar",
        select: "Selecione",
        selected: "Selecionado",
        description: "Descrição",
        notes: "Observações",
        createdAt: "Criado em",
        updatedAt: "Atualizado em",
        user: "Usuário",
        company: "Empresa",
        unknown: "Desconhecido",
        error: "Erro",
        success: "Sucesso",
        notInformed: "Não informado",
        featureNotEnabled: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        calendar: {
          today: "Hoje",
          previous: "Anterior",
          next: "Próximo",
          month: "Mês",
          week: "Semana",
          day: "Dia",
          agenda: "Agenda",
          date: "Data",
          time: "Hora",
          event: "Evento",
          allDay: "Dia inteiro",
          noEventsInRange: "Nenhum evento neste período.",
          showMore: "+ Ver mais ({{count}})",
        },
        time: {
          minutesAgo: "há {{count}} minuto",
          minutesAgo_plural: "há {{count}} minutos",
          hoursAgo: "há {{count}} hora",
          hoursAgo_plural: "há {{count}} horas",
          daysAgo: "há {{count}} dia",
          daysAgo_plural: "há {{count}} dias",
        },
      },
      validation: {
        required: "Obrigatório",
        tooShort: "Muito curto",
        tooLong: "Muito longo",
        invalidEmail: "E-mail inválido",
        invalidPhone: "Telefone inválido",
        invalidUrl: "URL inválida",
        invalidDate: "Data inválida",
        invalidNumber: "Número inválido",
        minLength: "Mínimo de {{count}} caracteres",
        maxLength: "Máximo de {{count}} caracteres",
        min: "Valor mínimo: {{min}}",
        max: "Valor máximo: {{max}}",
        positiveNumber: "Informe um número positivo",
        passwordsMustMatch: "As senhas não conferem",
        invalidCnpj: "CNPJ inválido",
        invalidCpf: "CPF inválido",
      },
      labels: {
        priority: {
          low: "Baixa",
          medium: "Média",
          normal: "Normal",
          high: "Alta",
          urgent: "Urgente",
        },
        severity: {
          critical: "Crítico",
          high: "Alto",
          medium: "Médio",
          low: "Baixo",
          info: "Informativo",
        },
        weekdays: {
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      backendErrors: {
				ERR_CALL_NO_PERMISSION: "O contato ainda não autorizou receber ligações deste número.",
				ERR_CALL_NOT_ENABLED: "As ligações não estão habilitadas neste número na Meta.",
				ERR_CALL_RECEIVER_UNCALLABLE: "Este contato não pode receber ligações pelo WhatsApp.",
				ERR_CALL_DUPLICATE: "Já existe uma ligação em andamento com este contato.",
				ERR_CALL_LIMIT_REACHED: "O limite de ligações deste número foi atingido. Tente mais tarde.",
				ERR_CALL_PERMISSION_REQUEST_LIMIT: "Limite de pedidos de permissão atingido para este contato (1 por dia, 2 por semana).",
				ERR_CALL_BUSINESS_INITIATED_UNAVAILABLE: "Ligações feitas pela empresa não estão disponíveis para este número.",
				ERR_CALL_TEMPORARILY_DISABLED: "As ligações deste número estão suspensas temporariamente pela Meta por baixa qualidade.",
				ERR_CALL_CANNOT_BE_ENABLED: "Não é possível habilitar ligações: o número precisa de limite de pelo menos 2.000 conversas por dia.",
				ERR_CALL_PERMANENT_PERMISSION_EXISTS: "O contato já autorizou ligações sem prazo; não é preciso pedir de novo.",
				ERR_CALL_PREREQUISITES_MISSING: "Pré-requisitos ausentes: assine o campo de webhook “calls” no app da Meta.",
				ERR_CALL_RECIPIENT_NOT_ALLOWED: "Número de teste: o contato não está na lista de destinatários permitidos.",
				ERR_CALL_PERMISSION_LOOKUP_RATE_LIMIT: "Muitas consultas de permissão em pouco tempo. Aguarde um instante.",
				ERR_CALL_FAILED: "A Meta recusou a ligação. Tente de novo em instantes.",
				ERR_CALL_BAILEYS_FAILED: "A ligação não saiu por esta conexão. Tente de novo em instantes.",
				ERR_CALL_ENGINE_FAILED: "O motor de ligação desta conexão não iniciou. Tente de novo em instantes.",
				ERR_CALL_LINE_BUSY: "Esta conexão já está em outra ligação.",
				ERR_CALL_CONNECTION_OFFLINE: "A conexão do WhatsApp não está conectada.",
				ERR_CALL_INVALID_SDP: "O navegador não conseguiu preparar o áudio da ligação.",
				ERR_CALL_ALREADY_IN_PROGRESS: "Você já tem uma ligação em andamento.",
				ERR_CALL_ALREADY_ANSWERED: "Outro atendente já atendeu esta ligação.",
				ERR_CALL_NOT_FOUND: "Esta ligação já foi encerrada.",
				ERR_CALL_NOT_YOURS: "Esta ligação está com outro atendente.",
				ERR_CALL_GROUP_UNSUPPORTED: "Não é possível ligar para grupos.",
				ERR_CALL_PROVIDER_UNAVAILABLE: "Ligações estão disponíveis apenas em conexões da API oficial.",
				ERR_CALL_PERMISSION_WINDOW_CLOSED: "A janela de 24 horas está fechada: o pedido de permissão só pode ser enviado com um modelo aprovado.",
				ERR_CALL_INVALID_SETTINGS: "Configuração de ligação inválida.",
				ERR_RATING_MESSAGE_REQUIRED: "Escreva a pergunta de avaliação.",
				ERR_RATING_INVALID_WINDOW: "O prazo para responder deve ser de 1 a 168 horas.",
        ERR_INVALID_PASSWORD: "Senha incorreta.",
        ERR_MEDIA_URL_REQUIRED:
          "Não foi possível identificar a figurinha selecionada.",
        ERR_STICKER_REMOVED_FROM_LIBRARY:
          "Esta figurinha já foi removida da biblioteca.",
        ERR_MESSAGES_REPORT_INVALID_PERIOD:
          "Informe um período válido no relatório (data inicial e data final).",
        ERR_MESSAGES_REPORT_TERM_TOO_SHORT:
          "Digite pelo menos 3 caracteres no termo de busca.",
        ERR_TICKET_CLOSE_WITHOUT_INTERACTION:
          "Você não interagiu com o contato neste chamado.",
        ERR_TICKET_CLOSE_WITHOUT_INTERACTION_BLOCKED:
          "Não é possível finalizar este chamado: você ainda não interagiu com o contato.",
        ERR_TICKET_CLOSE_ASK_COMPLETION_MESSAGE:
          "Confirme se a mensagem de conclusão deve ser enviada antes de finalizar o chamado.",
        ERR_NO_OTHER_WHATSAPP:
          "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp conectado encontrado. Por favor, conecte pelo menos um número de WhatsApp na página de conexões.",
        ERR_NO_BAILEYS_WAPP_FOUND:
          "Nenhuma conexão WhatsApp (QR Code) conectada para validar números. Conecte um WhatsApp na página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_CLOUDAPI_WINDOW_CLOSED:
          "A janela de 24 horas expirou. Envie um template de mensagem para iniciar uma nova conversa.",
        ERR_CLOUDAPI_REVOKE_UNSUPPORTED:
          "A Meta recusou apagar esta mensagem para o destinatário: o recurso \"apagar para todos\" ainda não está liberado para números da API Oficial. A mensagem NÃO foi apagada no aparelho do cliente.",
        ERR_META_SEND_TEMPLATE:
          "Erro ao enviar template pelo WhatsApp Cloud API.",
        ERR_AI_CREDIT_NOT_ENABLED:
          "A cobrança de créditos de IA não está habilitada para sua empresa.",
        ERR_AI_CREDIT_COMPANY_NOT_LINKED:
          "Esta empresa ainda não está vinculada ao iaHub, então não há para onde enviar o crédito. Vincule em Configurações → Créditos de IA.",
        ERR_AI_CREDIT_INVALID_VALUE:
          "Valor de recarga de créditos de IA inválido.",
        ERR_AI_CREDIT_INVALID_SETTING:
          "Configuração de créditos de IA inválida.",
        ERR_AI_CREDIT_INVALID_RANGE:
          "O crédito mínimo não pode ser maior que o crédito máximo.",
        ERR_AI_CREDIT_TOPUP_NOT_FOUND:
          "Recarga de créditos de IA não encontrada.",
        ERR_AI_CREDIT_TOPUP_NOT_PAID:
          "Esta recarga ainda não foi paga: não há crédito para enviar ao iaHub.",
        ERR_AI_HUB_NOT_CONFIGURED:
          "O iaHub não está configurado neste ambiente (AI_HUB_BASE_URL e AI_HUB_RESELLER_KEY no .env do backend).",
        ERR_AI_HUB_UNAUTHORIZED:
          "O iaHub recusou a chave da revenda. Confira a AI_HUB_RESELLER_KEY.",
        ERR_AI_HUB_UNAVAILABLE:
          "Não foi possível falar com o iaHub agora. Tente novamente em instantes.",
        ERR_AI_HUB_COMPANY_NOT_FOUND:
          "Empresa não encontrada nesta revenda do iaHub.",
        ERR_AI_HUB_RESELLER_CONFLICT:
          "Essa empresa do iaHub já pertence a outra revenda.",
        ERR_AI_HUB_AGENT_NOT_FOUND:
          "Agente não encontrado no iaHub. Confira o ID do agente — um caractere a mais ou a menos já impede a IA de responder.",
        ERR_PROMPT_AGENT_OTHER_HUB_COMPANY:
          "Esta empresa é cobrada por créditos de IA e o agente escolhido pertence a outra empresa do iaHub: o consumo dele não sairia do saldo desta empresa. Use um agente da empresa vinculada.",
        ERR_AI_CREDIT_AGENT_MISMATCH:
          "Não dá para cobrar esta empresa vinculada a essa empresa do iaHub: o consumo da IA é descontado da empresa dona do agente, e há prompts com agente de outra empresa.",
        ERR_AI_CREDIT_HUB_COMPANY_IN_USE:
          "Essa empresa do iaHub já está vinculada a outra empresa do CRM.",
        ERR_AI_CREDIT_LINK_HAS_BALANCE:
          "A empresa anterior no iaHub tem saldo comprado; a troca de vínculo não foi feita.",
        ERR_TEMPLATE_CREDIT_INSUFFICIENT:
          "Saldo de créditos de template insuficiente. Recarregue em Financeiro para continuar enviando templates.",
        ERR_TEMPLATE_CREDIT_NOT_ENABLED:
          "A cobrança de templates não está habilitada para sua empresa.",
        ERR_TEMPLATE_CREDIT_INVALID_VALUE:
          "Valor de recarga inválido.",
        ERR_TEMPLATE_CREDIT_ADJUST_BELOW_ZERO:
          "O ajuste deixaria o saldo negativo.",
        ERR_TEMPLATE_CREDIT_REASON_REQUIRED:
          "Informe o motivo do ajuste de saldo.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: 
          "Este não é um número de Whatsapp válido.",
        ERR_CHECK_NUMBER:
          "O número informado não está cadastrado no WhatsApp ou não existe.",
        ERR_MEDIA_MIMETYPE_NOT_FOUND:
          "Não foi possível identificar o tipo de arquivo da mídia.",
        ERR_INVALID_MIMETYPE:
          "Tipo de arquivo inválido.",
        ERR_IMPORT_CONTACTS_FAILED:
          "Falha ao carregar contatos do WhatsApp. Tente novamente mais tarde.",
        ERR_WHATSAPP_NOT_CONNECTED:
          "Essa conexão de WhatsApp não está conectada. Verifique a página de conexões.",
        ERR_NO_CONTACTS_SYNCED_YET:
          "Não foi possível ler a agenda do celular nesta conexão agora. Tente de novo em alguns minutos; se continuar, importe os contatos por planilha ou cadastre-os em \"Adicionar contato\".",
        ERR_IMPORT_NO_FILE:
          "Nenhum arquivo foi enviado. Selecione uma planilha CSV, XLS ou XLSX.",
        ERR_IMPORT_INVALID_FILE_TYPE:
          "Tipo de arquivo não suportado. Envie uma planilha CSV, XLS ou XLSX.",
        ERR_IMPORT_TOO_MANY_ROWS:
          "A planilha tem linhas demais. Divida em arquivos com no máximo 5000 linhas.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_CONTACT_NOT_IN_CONNECTION:
          "Este contato não pertence à conexão atual. Verifique se a conexão do WhatsApp é a mesma que foi usada para iniciar a conversa.",
        ERR_GROUP_NOT_IN_CONNECTION:
          "Este grupo não pertence à conexão atual. Use uma conexão do WhatsApp que participe do grupo.",
        ERR_WAPP_NOT_CONNECTED:
          "A conexão do WhatsApp está desconectada. Verifique a página de conexões e reconecte.",
        ERR_WAPP_NOT_RESPONDING:
          "A conexão do WhatsApp não está respondendo. A mensagem não foi enviada; aguarde a conexão voltar e envie de novo.",
        ERR_WAPP_RECIPIENT_NO_DEVICES:
          "O WhatsApp não encontrou nenhum aparelho deste contato (número sem WhatsApp ou identificador desatualizado). A mensagem não foi enviada.",
        ERR_CLOUDAPI_GROUP_UNSUPPORTED:
          "A Cloud API não suporta envio para grupos.",
        ERR_DELETE_WAPP_MSG: 
          "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_EDITING_WAPP_MSG:
          "Não foi possível editar a mensagem do WhatsApp.",
        ERR_MESSAGE_NOT_FOUND:
          "Mensagem não encontrada.",
        ERR_CANNOT_EDIT_MESSAGE_NOT_FROM_ME:
          "Você só pode editar mensagens enviadas por você.",
        ERR_CANNOT_EDIT_DELETED_MESSAGE:
          "Mensagens deletadas não podem ser editadas.",
        ERR_MESSAGE_TOO_OLD_TO_EDIT:
          "Esta mensagem não pode mais ser editada (limite de 15 minutos).",
        ERR_CANNOT_EDIT_MEDIA_MESSAGE:
          "Mensagens de mídia não podem ser editadas.",
        ERR_CANNOT_EDIT_CLOUDAPI_MESSAGE:
          "Conexões da API Oficial (Meta) não permitem editar mensagens já enviadas. A mensagem continua como está no aparelho do cliente.",
        ERR_MESSAGE_BODY_REQUIRED:
          "O corpo da mensagem é obrigatório.",
        ERR_OTHER_OPEN_TICKET: 
          "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED:
          "Sessão expirada. Por favor entre.",
        ERR_COMPANY_BLOCKED:
          "Sua assinatura está vencida. Acesse o Financeiro e regularize o pagamento para voltar a usar o sistema.",
        ERR_COMPANY_INACTIVE:
          "Esta empresa está inativa. Entre em contato com o suporte para mais informações.",
        ERR_LICENSE_INVALID:
          "A licença de uso desta empresa não é válida. Entre em contato com a Empsis para regularizar.",
        ERR_LICENSE_CHECK_DISABLED:
          "A validação de licença não está ativa nesta instalação.",
        ERR_STORAGE_USAGE_RUNNING:
          "O cálculo de armazenamento já está em execução. Aguarde terminar.",
        ERR_COMPANY_EMPSIS_TOKEN_REQUIRED:
          "Informe o token da Empsis da empresa. Use o botão Gerar token se não tiver um.",
        ERR_EMPSIS_TOKEN_MISSING_FIELDS:
          "Informe CNPJ, usuário e senha da Empsis para gerar o token.",
        ERR_EMPSIS_TOKEN_REFUSED:
          "A Empsis recusou a geração do token. Confira CNPJ, usuário e senha.",
        ERR_EMPSIS_UNAVAILABLE:
          "A Empsis não respondeu agora. Tente de novo em instantes.",
        ERR_EMPSIS_TOKEN_READONLY:
          "O token da Empsis não pode ser digitado. Gere um novo pelo botão Gerar e salvar.",
        ERR_SAME_PLAN:
          "A empresa já está neste plano.",
        ERR_PLAN_QR_CONNECTION_NOT_ALLOWED:
          "O plano da empresa não inclui conexão de WhatsApp via QR Code.",
        ERR_PLAN_CHANGE_NOT_ALLOWED:
          "A troca de plano não está disponível para esta empresa. Entre em contato com o suporte.",
        ERR_MP_LEGACY_SUBSCRIPTION_REQUIRES_CARD:
          "Sua assinatura atual está no modelo antigo do Mercado Pago e não permite alterar o valor. Recadastre o cartão na tela Financeiro (seção Meu plano) para concluir a alteração.",
        ERR_ADDON_CHANGE_ALREADY_PENDING:
          "Já existe uma alteração de add-ons pendente. Conclua o pagamento ou cancele a alteração antes de solicitar outra.",
        ERR_ADDON_MIXED_CHANGE:
          "Adicione e remova add-ons em operações separadas.",
        ERR_ADDON_INVALID_QUANTITY:
          "Quantidade de add-ons inválida.",
        ERR_ADDON_NOT_AN_UPGRADE:
          "A alteração solicitada não adiciona nenhum add-on.",
        ERR_ADDON_NOT_A_DOWNGRADE:
          "A alteração solicitada não remove nenhum add-on.",
        ERR_CHANGE_REQUEST_NOT_FOUND:
          "Alteração de plano não encontrada.",
        ERR_CHANGE_REQUEST_ALREADY_PAID:
          "O pró-rata desta alteração já foi pago — ela será aplicada automaticamente.",
        ERR_CHANGE_REQUEST_NOT_CANCELLABLE:
          "Esta alteração não pode mais ser cancelada.",
        ERR_CARD_TOKEN_REQUIRED:
          "É necessário informar o cartão para esta operação.",
        ERR_INVOICE_WITHOUT_VALUE:
          "Esta fatura não possui valor de cobrança.",
        ERR_CUSTOM_VALUE_INVALID:
          "Valores de personalização inválidos.",
        ERR_PLAN_WITHOUT_VALUE:
          "Este plano não tem valor de cobrança definido. Entre em contato com o suporte.",
        ERR_COMPANY_WITHOUT_PLAN:
          "A empresa não possui um plano vinculado. Entre em contato com o suporte.",
        ERR_SUBSCRIPTION_ALREADY_ACTIVE:
          "Já existe uma assinatura automática ativa para esta empresa.",
        ERR_NO_ACTIVE_SUBSCRIPTION:
          "Não há assinatura automática ativa para cancelar.",
        ERR_INVOICE_NOT_FOUND:
          "Fatura não encontrada.",
        ERR_INVOICE_ALREADY_PAID:
          "Esta fatura já foi paga.",
        ERR_MP_PLAN_NOT_SYNCED:
          "Não foi possível sincronizar o plano com o Mercado Pago. Tente novamente em instantes.",
        ERR_MP_PIX_UNAVAILABLE:
          "Pagamento por Pix indisponível no momento. Use cartão de crédito ou fale com o suporte.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: 
          "Você não tem permissão para acessar este recurso.",
        ERR_WAPP_TOKEN_IN_USE:
          "Este token já está em uso por outra conexão.",
        ERR_WAPP_NAME_IN_USE:
          "Já existe uma conexão com este nome nesta empresa.",
        ERR_USER_NO_QUEUE_ACCESS:
          "Você não tem acesso à fila deste chamado.",
        ERR_TICKETS_FROM_OTHER_USERS:
          "Este contato possui chamados abertos com outros atendentes. Por favor, assuma um dos chamados existentes antes de enviar mensagens.",
        ERR_PENDING_TICKET_WITH_AGENT:
          "Este chamado esta em aguardando com agente vinculado. Assuma o chamado para remover a IA antes de enviar mensagens.",
        ERR_TRANSFER_USER_OFFLINE:
          "Este usuário está offline. A transferência para usuário offline está desabilitada nas configurações.",
        ERR_DUPLICATED_CONTACT: 
          "Já existe um contato com este número.",
        ERR_CONTACT_SAVE_FAILED:
          "Não foi possível salvar o contato. Tente novamente.",
        ERR_CONTACT_UPDATE_FAILED:
          "Não foi possível atualizar o contato. Tente novamente.",
        ERR_NO_SETTING_FOUND: 
          "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: 
          "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: 
          "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: 
          "Nenhum usuário encontrado com este ID.",
        ERR_TICKET_INACTIVE: 
          "Este chamado pertence a uma conexão excluída e não pode ser reaberto, transferido ou respondido.",
        ERR_NO_WAPP_FOUND: 
          "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: 
          "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: 
          "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_CHANNEL_SINGLE_QUEUE_ONLY:
          "Este tipo de canal permite apenas uma fila.",
        ERR_QUEUE_HAS_PROMPTS:
          "Não é possível excluir a fila. Existem prompts associados a esta fila. Por favor, reatribua ou exclua os prompts antes de deletar esta fila.",
        ERR_NO_TICKETNOTE_FOUND:
          "Nenhuma nota de ticket encontrada com este ID.",
        ERR_NO_HELP_FOUND:
          "Nenhuma ajuda encontrada com este ID.",
        ERR_NO_SCHEDULE_FOUND:
          "Nenhum agendamento encontrado com este ID.",
        ERR_QUEUE_NOT_FOUND:
          "Nenhuma fila encontrada com este ID.",
        ERR_NO_DIALOG_FOUND:
          "Nenhuma integração encontrada com este ID.",
        ERR_NO_PROMPT_FOUND:
          "Nenhum prompt encontrado com este ID.",
        ERR_NO_PLAN_FOUND:
          "Nenhum plano encontrado com este ID.",
        ERR_NO_KANBAN_BOARD_FOUND:
          "Nenhum quadro Kanban encontrado com este ID.",
        ERR_NO_KANBAN_CARD_FOUND:
          "Nenhum cartão Kanban encontrado com este ID.",
        ERR_NO_KANBAN_COLUMN_FOUND:
          "Nenhuma coluna Kanban encontrada com este ID.",
        ERR_KANBAN_CARD_DUPLICATE_CONTACT:
          "Já existe um card deste contato. Confirme para criar mesmo assim.",
        ERR_KANBAN_CARD_DUPLICATE_CONTACT_BLOCKED:
          "Já existe um card deste contato — a criação de card duplicado está bloqueada nesta empresa.",
        ERR_NO_MESSAGE_FOUND:
          "Nenhuma mensagem encontrada com este ID.",
        ERR_NO_COMPANY_FOUND:
          "Nenhuma empresa encontrada com este ID.",
        ERR_COMPANY_INVALID_CNPJ:
          "CNPJ inválido. Informe um CNPJ válido.",
        ERR_COMPANY_CNPJ_ALREADY_EXISTS:
          "Já existe uma empresa cadastrada com este CNPJ.",
        ERR_COMPANY_NAME_ALREADY_EXISTS:
          "Já existe uma empresa cadastrada com este nome.",
        ERR_COMPANY_INVALID_NAME:
          "Nome da empresa inválido. Informe ao menos 2 caracteres.",
        ERR_COMPANY_INVALID_EMAIL:
          "Informe um e-mail válido.",
        ERR_USER_EMAIL_ALREADY_EXISTS:
          "Este e-mail já está em uso. Faça login ou cadastre-se com outro e-mail.",
        ERR_COMPANY_INVALID_PASSWORD:
          "Informe uma senha com pelo menos 5 caracteres.",
        ERR_NO_CONTACTLISTITEM_FOUND:
          "Nenhum item de lista de contatos encontrado com este ID.",
        ERR_NO_CONTACTLIST_FOUND:
          "Nenhuma lista de contatos encontrada com este ID.",
        ERR_NO_QUICKMESSAGE_FOUND:
          "Nenhuma mensagem rápida encontrada com este ID.",
        ERR_NO_TAG_FOUND:
          "Nenhuma tag encontrada com este ID.",
        ERR_NO_FILE_FOUND:
          "Nenhum arquivo encontrado com este ID.",
        ERR_NO_RATING_FOUND:
          "Nenhuma avaliação encontrada com este ID.",
        ERR_NO_CHAT_FOUND:
          "Nenhum chat encontrado com este ID.",
        ERR_NO_CLIENTE_FOUND:
          "Nenhum cliente encontrado com este ID.",
        ERR_COMMENT_REQUIRES_CONTENT_OR_MEDIA:
          "O comentário requer conteúdo ou mídia.",
        ERR_NO_COMMENT_FOUND:
          "Nenhum comentário encontrado com este ID.",
        ERR_NO_BAILEYS_DATA_FOUND:
          "Nenhum dado Baileys encontrado com este ID.",
        ERR_NO_CAMPAIGN_FOUND:
          "Nenhuma campanha encontrada com este ID.",
        ERR_NO_ANNOUNCEMENT_FOUND:
          "Nenhum anúncio encontrado com este ID.",
        ERR_USER_NOT_FOUND:
          "Usuário não encontrado.",
        ERR_NO_SUPER:
          "Você não tem permissão de super administrador.",
        ERR_APPLYING_REACTION: "Não foi possível aplicar a reação.",
        ERR_POLL_UNSUPPORTED_CHANNEL: "Esta conexão não permite votar em enquetes.",
        ERR_POLL_INVALID: "Esta mensagem não é uma enquete válida.",
        ERR_POLL_INVALID_OPTION: "Opção inválida para esta enquete.",
        ERR_POLL_TOO_MANY_OPTIONS: "Esta enquete não permite escolher tantas opções.",
        ERR_POLL_SECRET_NOT_FOUND: "Não foi possível votar: a chave desta enquete não está mais disponível.",
        ERR_SENDING_POLL_VOTE: "Não foi possível enviar o voto.",
        ERR_BILLING_ADDONS_NOT_CONFIGURED: "Os add-ons de cobrança não estão configurados.",
        ERR_CAMPAIGN_MESSAGE_OR_TEMPLATE_REQUIRED: "Informe uma mensagem ou um template para a campanha.",
        ERR_CAMPAIGN_NOT_FOUND: "Campanha não encontrada.",
        ERR_CAMPAIGN_RESPONSE_QUEUE_INVALID: "A fila de resposta da campanha é inválida.",
        ERR_CAMPAIGN_RESPONSE_QUEUE_NOT_FOUND: "A fila de resposta da campanha não foi encontrada.",
        ERR_CAMPAIGN_RESPONSE_ROUTING_INCOMPLETE: "A configuração de roteamento das respostas da campanha está incompleta.",
        ERR_CAMPAIGN_RESPONSE_WINDOW_INVALID: "A janela de resposta da campanha é inválida.",
        ERR_CAMPAIGN_SMS_MESSAGE_REQUIRED: "Campanha por SMS precisa de uma mensagem.",
        ERR_CAMPAIGN_SMS_NO_MEDIA: "Campanha por SMS não aceita anexos.",
        ERR_CAMPAIGN_SMS_TOO_LONG: "A mensagem da campanha por SMS é longa demais.",
        ERR_CAMPAIGN_TEMPLATE_REQUIRED: "Selecione um template para a campanha.",
        ERR_CATALOG_CHANNEL_UNSUPPORTED: "Este canal não suporta catálogo de produtos.",
        ERR_CATALOG_DELETE_UNAVAILABLE: "Não é possível excluir produtos neste catálogo.",
        ERR_CATALOG_DISCOVERY_FAILED: "Não foi possível localizar o catálogo na Meta.",
        ERR_CATALOG_MESSAGE_UNSUPPORTED: "Esta conexão não suporta envio de produtos do catálogo.",
        ERR_CATALOG_META_PERMISSION: "Sem permissão para acessar o catálogo na Meta.",
        ERR_CATALOG_MULTI_UNSUPPORTED: "Esta conexão não suporta envio de vários produtos de uma vez.",
        ERR_CATALOG_NOT_BUSINESS: "A conta do WhatsApp não é uma conta comercial.",
        ERR_CATALOG_NOT_FOUND: "Catálogo não encontrado.",
        ERR_CATALOG_NO_CONNECTION: "Nenhuma conexão disponível para o catálogo.",
        ERR_CATALOG_NO_PRODUCT_SELECTED: "Selecione ao menos um produto.",
        ERR_CATALOG_PRODUCT_NO_IMAGE: "O produto não possui imagem.",
        ERR_CATALOG_PRODUCT_NO_RETAILER_ID: "O produto não possui código (retailer ID).",
        ERR_CATALOG_PROVIDER_FAILURE: "Falha na comunicação com o provedor do catálogo.",
        ERR_CATALOG_SEND_UNAVAILABLE: "Envio de produtos indisponível nesta conexão.",
        ERR_CATALOG_SYNC_FAILED: "Falha ao sincronizar o catálogo.",
        ERR_CATALOG_SYNC_UNAVAILABLE: "Sincronização de catálogo indisponível nesta conexão.",
        ERR_CATALOG_TICKET_REQUIRED: "Informe o atendimento para enviar o produto.",
        ERR_CATALOG_UPDATE_UNAVAILABLE: "Não é possível editar produtos neste catálogo.",
        ERR_CATALOG_WABA_NOT_CONFIGURED: "Conta WhatsApp Business (WABA) não configurada.",
        ERR_CATALOG_WAPP_NOT_CONNECTED: "A conexão do WhatsApp não está conectada.",
        ERR_CATALOG_WRONG_CONNECTION: "O produto pertence a outra conexão.",
        ERR_CHAT_MESSAGE_NOT_FOUND: "Mensagem do chat não encontrada.",
        ERR_CLOUDAPI_ACCOUNT_NOT_REGISTERED: "Número não registrado na API Oficial (Cloud API).",
        ERR_CLOUDAPI_CONNECTION_NOT_FOUND: "Conexão da API Oficial não encontrada.",
        ERR_CLOUDAPI_DISPLAY_NAME_NOT_APPROVED: "O nome de exibição ainda não foi aprovado pela Meta.",
        ERR_CLOUDAPI_INVALID_CONFIG: "Configuração da API Oficial inválida.",
        ERR_CLOUDAPI_INVALID_MEDIA_FORMAT: "Formato de mídia não aceito pela API Oficial.",
        ERR_CLOUDAPI_INVALID_MEDIA_MIME: "Tipo de arquivo não aceito pela API Oficial.",
        ERR_CLOUDAPI_MEDIA_TYPE_MISMATCH: "O tipo da mídia não corresponde ao esperado pelo template.",
        ERR_CLOUDAPI_RATE_LIMIT: "Limite de envios da API Oficial atingido. Tente novamente em instantes.",
        ERR_CLOUDAPI_SUBSCRIPTION: "Falha ao assinar os eventos (webhook) da API Oficial.",
        ERR_CONTACT_DATA_REQUIRED: "Informe ao menos um dado de contato (telefone, e-mail ou Instagram).",
        ERR_CONTACT_EMAIL_REQUIRED: "O contato não possui e-mail.",
        ERR_CONTACT_INSTAGRAM_REQUIRED: "O contato não possui Instagram.",
        ERR_CONTACT_NOT_FOUND: "Contato não encontrado.",
        ERR_CONTACT_NOT_ON_WHATSAPP: "O número do contato não está no WhatsApp.",
        ERR_CONTACT_NO_INSTAGRAM_ID: "O contato não possui ID do Instagram.",
        ERR_CONTACT_NO_PHONE_NUMBER: "O contato não possui número de telefone.",
        ERR_DOCUMENTTEMPLATE_CONTENT_TOO_LARGE: "O conteúdo do modelo de documento é grande demais.",
        ERR_DOCUMENT_MISSING_VARIABLES: "Faltam variáveis para gerar o documento.",
        ERR_EMAIL_CONNECTION_NOT_FOUND: "Conexão de e-mail não encontrada.",
        ERR_EMAIL_DELIVERY_REJECTED: "O servidor de e-mail recusou o envio.",
        ERR_EMAIL_SETTING_ALREADY_EXISTS: "Já existe uma configuração de e-mail.",
        ERR_EMAIL_SETTING_NOT_FOUND: "Configuração de e-mail não encontrada.",
        ERR_EMPTY_CHAT_MESSAGE: "A mensagem não pode ser vazia.",
        ERR_FORBIDDENWORD_DUPLICATED: "Este termo proibido já está cadastrado.",
        ERR_GROUPS_RESYNC_UNSUPPORTED: "Esta conexão não suporta ressincronizar grupos.",
        ERR_INSTAGRAM_INVALID_CONFIG: "Configuração do Instagram inválida.",
        ERR_INSTAGRAM_UNSUPPORTED_MEDIA: "Tipo de mídia não suportado pelo Instagram.",
        ERR_INSTAGRAM_WINDOW_CLOSED: "A janela de 24h do Instagram expirou. Aguarde o contato responder.",
        ERR_INVALID_ATTENDANCE_ALARM_MINUTES: "Minutos do alarme de atendimento inválidos.",
        ERR_INVALID_OUT_OF_HOURS_INTERVAL: "Intervalo da mensagem fora do expediente inválido (0 a 1440 minutos).",
        ERR_INVALID_CONTACT_ID: "ID do contato inválido.",
        ERR_INVALID_DATE_FILTER: "Filtro de data inválido.",
        ERR_INVALID_DATE_RANGE_FILTER: "Intervalo de datas inválido.",
        ERR_INVALID_EMAIL_CONNECTION: "Conexão de e-mail inválida.",
        ERR_INVALID_MUTE_DURATION: "Duração de silenciamento inválida.",
        ERR_INVALID_PAYMENT_DATA: "Dados de pagamento inválidos.",
        ERR_INVALID_PENDING_STATUS: "Status de pendente inválido.",
        ERR_INVALID_REACTION: "Reação inválida.",
        ERR_INVALID_SMS_CONNECTION: "Conexão de SMS inválida.",
        ERR_INVALID_SOLICITACAO_ID: "ID da solicitação inválido.",
        ERR_INVALID_SOLICITACAO_STATUS: "Status da solicitação inválido.",
        ERR_INVALID_TICKET_ID: "ID do atendimento inválido.",
        ERR_INVALID_UPDATED_AT_FILTER: "Filtro de data de atualização inválido.",
        ERR_INVALID_USER_ID: "ID do usuário inválido.",
        ERR_INVALID_WHATSAPP_ID: "ID da conexão inválido.",
        ERR_MESSAGE_NOT_IN_SCOPE: "A mensagem não pertence a este atendimento.",
        ERR_MESSAGE_NO_TICKET: "A mensagem não está vinculada a um atendimento.",
        ERR_NOT_INSTAGRAM_CONNECTION: "Esta conexão não é do Instagram.",
        ERR_NO_CATALOG_PRODUCT_FOUND: "Produto do catálogo não encontrado.",
        ERR_NO_DOCUMENTTEMPLATE_FOUND: "Modelo de documento não encontrado.",
        ERR_NO_FILENAME: "Nome do arquivo não informado.",
        ERR_NO_FILE_UPLOADED: "Nenhum arquivo enviado.",
        ERR_NO_FORBIDDENWORD_FOUND: "Termo proibido não encontrado.",
        ERR_NO_QUICKMESSAGE_MEDIA_FOUND: "Anexo da resposta rápida não encontrado.",
        ERR_NO_SOLICITACAO_DESENVOLVIMENTO_FOUND: "Solicitação de desenvolvimento não encontrada.",
        ERR_NO_TAGPHRASE_FOUND: "Frase de tag não encontrada.",
        ERR_NO_WHATSAPP_FOUND: "Conexão não encontrada.",
        ERR_PUBLIC_API_INVALID_TOKEN: "Token da API pública inválido.",
        ERR_PUBLIC_API_NOT_CONFIGURED: "API pública não configurada.",
        ERR_PUBLIC_API_NO_TOKEN: "Token da API pública não informado.",
        ERR_QUICKMESSAGE_MAX_MEDIAS: "Limite de anexos da resposta rápida atingido.",
        ERR_QUOTED_MSG_NOT_IN_CHAT: "A mensagem citada não pertence a este chat.",
        ERR_SENDING_CATALOG_PRODUCT: "Erro ao enviar o produto do catálogo.",
        ERR_SENDING_CLOUDAPI_MSG_INVALID_CONNECTION: "Conexão da API Oficial inválida para envio.",
        ERR_SENDING_INSTAGRAM_MSG_INVALID_CONNECTION: "Conexão do Instagram inválida para envio.",
        ERR_SENDING_WAPP_MSG_CONTACT_NOT_FOUND: "Contato não encontrado para envio da mensagem.",
        ERR_SMSBARATO_REQUEST_FAILED: "Falha na requisição ao SMS Barato.",
        ERR_SMSDEV_REQUEST_FAILED: "Falha na requisição ao SMSDev.",
        ERR_TAGPHRASE_DUPLICATED: "Esta frase já está cadastrada.",
        ERR_TAGPHRASE_INVALID_PHRASE: "Frase inválida.",
        ERR_TEMPLATE_CREDIT_INVALID_CATEGORY: "Categoria de template inválida.",
        ERR_TEMPLATE_HEADER_MEDIA_REQUIRED: "O template exige uma mídia no cabeçalho.",
        ERR_TEMPLATE_MISSING_FIELDS: "Faltam campos obrigatórios do template.",
        ERR_TEMPLATE_NOT_APPROVED: "O template ainda não foi aprovado pela Meta.",
        ERR_TEMPLATE_NOT_FOUND: "Template não encontrado.",
        ERR_TEMPLATE_SYNC_META_LIST: "Falha ao buscar a lista de templates na Meta.",
        ERR_TEMPLATE_VARIABLES_MISMATCH: "As variáveis informadas não correspondem às do template.",
        ERR_TEMPLATE_WABA_MISMATCH: "O template pertence a outra conta WhatsApp Business.",
        ERR_TEST_EMAIL_REQUIRED: "Informe um e-mail para o teste.",
        ERR_TICKET_NOT_FOUND: "Atendimento não encontrado.",
        ERR_TICKET_OR_CONTACT_REQUIRED: "Informe o atendimento ou o contato.",
        ERR_TICKET_REQUIRED: "Informe o atendimento.",
        ERR_TRANSFER_USER_REQUIRED: "Selecione o usuário para transferir.",
        ERR_WABA_CONNECTION_NOT_FOUND: "Conexão WhatsApp Business (WABA) não encontrada.",
        ERR_WABA_NOT_CONFIGURED: "Conta WhatsApp Business (WABA) não configurada.",
        ERR_WABA_OR_WHATSAPP_REQUIRED: "Informe a conta WABA ou a conexão.",
        ERR_WAPP_NOT_CLOUDAPI: "Esta conexão não é da API Oficial.",
        ERR_WAPP_NOT_FOUND: "Conexão do WhatsApp não encontrada.",
        ERR_WAPP_VALIDATION_ABORTED: "Validação do número cancelada.",
        ERR_WHATSAPP_CONNECTION_EXISTS: "Já existe uma conexão com este número.",
        ERR_WHATSAPP_NAME_REQUIRED: "Informe o nome da conexão.",
        ERR_WITIME_REQUEST_FAILED: "Falha na requisição ao Witime.",
        ERR_QUEUE_INVALID_COLOR: "Informe uma cor válida para a fila.",
        ERR_QUEUE_INVALID_NAME: "O nome da fila precisa ter pelo menos 2 caracteres.",
        ERR_QUEUE_NAME_ALREADY_EXISTS: "Já existe uma fila com este nome.",
        ERR_QUEUE_LIMIT_REACHED: "O limite de filas do seu plano foi atingido.",
        ERR_QUICKMESSAGE_INVALID_NAME: "O atalho e a mensagem precisam ter pelo menos 3 caracteres.",
        ERR_QUICKMESSAGE_REQUIRED: "Preencha o atalho e a mensagem.",
        ERR_PROMPT_NAME_INVALID: "Informe o nome do prompt.",
        ERR_PROMPT_AIHUB_AGENTID_REQUIRED: "Informe o ID do agente do iaHub.",
        ERR_PROMPT_COOLDOWN_INVALID: "Informe um número de minutos igual ou maior que zero.",
        ERR_PROMPT_COOLDOWN_MAX: "O tempo máximo de pausa é 10080 minutos (7 dias).",
        ERR_TICKETNOTE_INVALID_NAME: "A nota precisa ter pelo menos 3 caracteres.",
        ERR_MEDIA_REDOWNLOAD_FAILED: "Não foi possível baixar a mídia novamente. Tente mais tarde.",
        ERR_TRANSCRIPTION_DISABLED: "A transcrição de áudios está desativada. O administrador pode configurar a chave da OpenAI em Configurações → Opções.",
        ERR_TRANSCRIPTION_NOT_RETRYABLE: "Esta transcrição não pode ser refeita agora: ela já foi refeita ou está em andamento.",
        ERR_INSTAGRAM_STORY_EXPIRED: "O story expirou no Instagram (stories ficam disponíveis por 24h).",
        ERR_INSTAGRAM_MEDIA_UNAVAILABLE: "O Instagram não entrega mais este arquivo.",
        ERR_INSTAGRAM_REEL_NO_FILE: "O Instagram não entrega o arquivo do reel; use \"Abrir no Instagram\".",
        ERR_WHATSAPP_ID_REQUIRED: "Selecione uma conexão.",
        ERR_WHATSAPP_LIMIT_REACHED: "O limite de conexões do seu plano foi atingido.",
        ERR_USER_LIMIT_REACHED: "O limite de usuários do seu plano foi atingido.",
        ERR_CONTACT_NOT_GROUP: "Este contato não é um grupo.",
        ERR_GROUP_CONNECTION_NOT_FOUND: "Não foi possível encontrar a conexão deste grupo.",
        ERR_SYSTEM_ALERTS_CONNECTION_REQUIRED: "Selecione a conexão que enviará os alertas.",
        ERR_SYSTEM_ALERTS_NUMBERS_REQUIRED: "Informe ao menos um número de destino válido.",
        ERR_PAIRING_INVALID_NUMBER: "Número inválido. Informe DDI + DDD + número, somente dígitos (ex.: 5511999998888).",
        ERR_PAIRING_BAILEYS_ONLY: "O login por número só está disponível para conexões Baileys.",
        ERR_ADMIN_ONLY: "Acesso não permitido. Apenas administradores podem acessar este recurso.",
        ERR_FORWARD_MESSAGE_FAILED: "Não foi possível encaminhar a mensagem.",
        ERR_PROFILE_NOT_FOUND: "Perfil não encontrado.",
        ERR_PROFILE_NAME_REQUIRED: "Informe o nome do perfil.",
        ERR_PROFILE_NAME_ALREADY_EXISTS: "Já existe um perfil com este nome nesta empresa. Escolha outro nome.",
        ERR_SCHEDULE_CONNECTION_INVALID: "A conexão selecionada não pertence à empresa.",
        ERR_SCHEDULE_INVALID_DATE: "Data/hora do agendamento inválida.",
        ERR_SCHEDULE_IN_PAST: "Não é permitido agendar mensagem no passado (tolerância de 2 minutos).",
        ERR_FORBIDDEN_OTHER_COMPANY: "Este registro pertence a outra empresa.",
        ERR_CAMPAIGN_DELETE_IN_PROGRESS: "Não é permitido excluir uma campanha em andamento.",
        ERR_CAMPAIGN_UPDATE_NOT_ALLOWED: "Só é permitido alterar campanhas inativas, programadas ou canceladas.",
        ERR_CAMPAIGN_INVALID_NAME: "O nome da campanha precisa ter pelo menos 3 caracteres.",
        ERR_CAMPAIGN_REQUIRED: "Informe o nome da campanha.",
        ERR_PEDIDO_NOT_FOUND: "Pedido não encontrado.",
        ERR_PEDIDO_ITEMS_REQUIRED: "O pedido deve conter pelo menos um item.",
        ERR_PEDIDO_DELETE_NOT_ALLOWED: "Não é possível excluir pedidos já entregues ou enviados.",
        ERR_INVALID_RESET_TOKEN: "Verifique o token informado.",
        ERR_CONTACTLIST_INVALID_NAME: "O nome da lista precisa ter pelo menos 3 caracteres.",
        ERR_CONTACTLIST_REQUIRED: "Informe o nome da lista.",
        ERR_CONTACTLISTITEM_INVALID_NAME: "O nome do contato precisa ter pelo menos 3 caracteres.",
        ERR_CONTACTLISTITEM_REQUIRED: "Informe o nome do contato.",
        ERR_FORBIDDENWORD_INVALID_TERM: "O termo precisa ter pelo menos 2 caracteres.",
        ERR_FORBIDDENWORD_REQUIRED: "Informe o termo.",
        ERR_TAGPHRASE_REQUIRED: "Informe a frase.",
        ERR_TAGPHRASE_TAG_REQUIRED: "Selecione a tag.",
        ERR_ANNOUNCEMENT_REQUIRED: "Informe o título e o texto do informativo.",
        ERR_DOCUMENTTEMPLATE_INVALID_NAME: "O nome do modelo precisa ter pelo menos 2 caracteres.",
        ERR_DOCUMENTTEMPLATE_REQUIRED: "Informe o nome e o conteúdo do modelo.",
        ERR_HELP_INVALID_NAME: "O título precisa ter pelo menos 3 caracteres.",
        ERR_HELP_REQUIRED: "Informe o título.",
        ERR_RATING_NAME_ALREADY_EXISTS: "Já existe um registro com este nome.",
        ERR_PLAN_INVALID_NAME: "O nome do plano precisa ter pelo menos 2 caracteres.",
        ERR_PLAN_NAME_ALREADY_EXISTS: "Já existe um plano com este nome.",
        ERR_MP_CANCEL_FAILED: "Não foi possível cancelar a assinatura no Mercado Pago. Tente novamente em instantes.",
        ERR_MP_PAYMENT_FAILED: "Não foi possível processar o pagamento no Mercado Pago. Confira os dados e tente novamente.",
        ERR_MP_PREFERENCE_FAILED: "Não foi possível iniciar o pagamento no Mercado Pago. Tente novamente em instantes.",
        ERR_MP_SUBSCRIPTION_FAILED: "Não foi possível criar a assinatura no Mercado Pago. Confira os dados do cartão e tente novamente.",
        ERR_MP_SUBSCRIPTION_UPDATE_FAILED: "Não foi possível atualizar a assinatura no Mercado Pago. Tente novamente em instantes.",
        ERR_SUBSCRIPTION_INVALID_DATA: "Dados de pagamento incompletos ou inválidos.",
      },
      toasts: {
        genericFallback: "Não foi possível concluir sua solicitação agora. Tente novamente em instantes.",
        genericUnavailable: "Estamos restabelecendo a conexão. Tente novamente em instantes.",
      },
      connectionSelectDialog: {
        title: "Selecionar conexão",
        noConnections: "Nenhuma conexão ativa disponível. Conecte um canal para iniciar o chamado.",
        automatic: "Automático",
        systemDefault: "Padrão do sistema",
        whatsappOfficial: "WhatsApp Oficial",
        officialBadge: "OFICIAL",
        email: "Email",
      },
      pagination: {
        currentPage: "Página atual",
        currentPageHint: "Página atual — digite um número entre 1 e {{total}} e pressione Enter",
      },
      errorBoundary: {
        title: "Oops! Algo deu errado",
        message: "Ocorreu um erro inesperado. Por favor, tente novamente ou volte para a página inicial.",
        goHome: "Ir para Página Inicial",
        reload: "Recarregar Página",
      },
      locationPreview: {
        openInMaps: "Clique para abrir no Google Maps",
      },
      phoneFormat: {
        notFound: "Número não encontrado",
      },
      ticketsConference: {
        title: "Conferência de Tickets",
        subtitle: "Tickets finalizados/concluídos",
        filters: {
          search: "Buscar por contato",
          queue: "Fila",
          user: "Responsável",
          campaign: "Campanha",
          allQueues: "Todas",
          allCampaigns: "Todas",
          allTags: "Todas",
        },
        table: {
          contact: "Contato",
          queue: "Fila",
          user: "Responsável",
          finishedAt: "Finalizado em",
          checked: "Conferido",
          noQueue: "Sem fila",
          empty: "Nenhum ticket finalizado encontrado.",
          allLoaded: "Todos os tickets foram carregados.",
        },
        actions: {
          openChat: "Abrir chat",
          check: "Marcar check",
          uncheck: "Desmarcar check",
        },
        toasts: {
          updated: "Conferência atualizada com sucesso.",
          openChatError: "Não foi possível abrir o chat deste chamado.",
        },
      },
      connectionsDiag: {
        title: "Diagnóstico de Conexões",
        subtitle: "Visão geral de todas as conexões WhatsApp do sistema",
        numberValue: "Número: {{number}}",
        errors: {
          invalidPassword: "Senha inválida",
          loadConnections: "Erro ao carregar conexões",
          connection: "Erro de conexão",
          sendMessage: "Erro ao enviar mensagem",
          autoTest: "Erro ao executar auto-teste",
        },
        status: {
          connected: "CONECTADO",
        },
        login: {
          subtitle: "Digite a senha para acessar o painel",
          password: "Senha",
          submit: "Entrar",
        },
        buttons: {
          testing: "Testando...",
          autoTest: "Auto-Teste Geral",
        },
        stats: {
          connected: "Conectadas",
          disconnected: "Desconectadas",
        },
        table: {
          session: "Sessão",
          number: "Número",
          battery: "Bateria",
          updatedAt: "Atualizado",
          action: "Ação",
          default: "Padrão",
        },
        session: {
          active: "Ativa",
          inactive: "Inativa",
        },
        tooltips: {
          sendTest: "Enviar mensagem de teste",
          notConnected: "Conexão não está conectada",
        },
        autoTest: {
          title: "Auto-Teste de Todas as Conexões",
          description: "Envia uma mensagem de teste por cada conexão conectada e gera um relatório",
          numberLabel: "Número de destino para todos os testes",
          numberHelper: "Todas as conexões enviarão uma mensagem para este número",
          running: "Executando auto-teste...",
          runningHint: "Enviando mensagem de teste por cada conexão. Isso pode levar alguns minutos.",
          report: "Relatório do Auto-Teste",
          totalDuration: "Duração total: {{duration}}",
          summary: {
            total: "Total: {{value}}",
            success: "Sucesso: {{value}}",
            errors: "Erros: {{value}}",
            skipped: "Puladas: {{value}}",
            tested: "Testadas: {{value}}",
          },
          details: "Detalhes por conexão:",
          start: "Iniciar Auto-Teste",
          again: "Testar Novamente",
        },
        testDialog: {
          title: "Enviar Mensagem de Teste",
          connection: "Conexão",
          number: "Número de destino",
          numberHelper: "Número com código do país (ex: 5542998232794)",
          message: "Mensagem (opcional)",
          messageHelper: "Deixe em branco para usar a mensagem padrão de teste",
          messagePlaceholder: "Mensagem personalizada...",
          sending: "Enviando...",
          send: "Enviar Teste",
        },
      },
      profiles: {
        deleteAlert: "Excluir perfil: {{name}}",
        buttons: {
          add: "Adicionar Perfil",
        },
        toasts: {
          deleted: "Perfil excluído com sucesso!",
          deleteError: "Erro ao excluir perfil",
        },
        confirmDelete: {
          title: "Confirmar exclusão",
          message: "Tem certeza que deseja excluir o perfil \"{{name}}\"?",
        },
        validation: {
          required: "Campo obrigatório",
        },
        modal: {
          addTitle: "Novo Perfil",
          editTitle: "Editar Perfil",
          searchPlaceholder: "Buscar menu ou filtro",
          name: "Nome do Perfil",
          nothingFound: "Nenhum menu ou filtro encontrado para \"{{term}}\".",
          allowedMenus: "Menus Permitidos",
          selectAll: "Selecionar todos",
          kanbanBoards: "Fluxos Kanban Permitidos",
          ownCardsOnly: "Kanban: mostrar apenas cards criados pelo próprio usuário",
          boardFallback: "Board #{{id}}",
          permissions: {
            view: "Ver",
            create: "Criar",
            edit: "Editar",
            delete: "Deletar",
          },
          ticketFilters: "Filtros de Atendimentos",
          create: "Cadastrar",
        },
        menus: {
          dashboard: "Dashboard",
          ticketRatings: "Avaliações de Atendimento",
          tickets: "Atendimentos",
          ticketsFullHistory: "Atendimentos - Ver histórico completo do contato",
          ticketsCall: "Atendimentos - Fazer e atender ligações",
          pendingMessages: "Mensagens Pendentes",
          ticketsConference: "Conferência de Tickets",
          messagesReport: "Relatório de Mensagens",
          monitoring: "Monitoramento",
          internalChat: "Chat Interno",
          flows: "Fluxos",
          kanbanEditComments: "Kanban - Editar Comentários",
          kanbanCardInactivityTime: "Kanban - Configurar Tempo de Inatividade dos Cards",
          quickMessages: "Respostas Rápidas",
          documentTemplates: "Modelos de Documentos",
          contacts: "Contatos",
          usageReport: "Relatório de Utilização",
          customers: "Clientes",
          agenda: "Agenda",
          schedules: "Agendamentos",
          tags: "Tags",
          tagPhrases: "Frases que geram Tag",
          forbiddenWordsRegister: "Termos Proibidos - Cadastro",
          forbiddenWordsReport: "Termos Proibidos - Relatório",
          development: "Desenvolvimento",
          campaigns: "Campanhas",
          campaignsList: "Campanhas Listagem",
          campaignsContactLists: "Campanhas - Listas de Contatos",
          campaignsSettings: "Campanhas - Configurações",
          announcements: "Informativos",
          openai: "Open.ai",
          integrations: "Integrações",
          connectionsView: "Conexões - Apenas visualizar",
          connectionsManage: "Conexões - Gerenciar (adicionar, QR Code, editar e excluir)",
          messageTemplates: "Templates de Mensagem",
          catalog: "Catálogo de Produtos",
          files: "Lista de Arquivos",
          queues: "Filas & Chatbot",
          users: "Usuários",
          api: "API",
          billing: "Financeiro",
          profiles: "Perfis de Usuário",
          settings: "Configurações",
          tasks: "Tarefas",
          orders: "Pedidos",
          help: "Ajuda",
        },
        filters: {
          showAll: "Filtro: Todos (ver todos os tickets)",
          queues: "Filtro: Filas",
          whatsapps: "Filtro: WhatsApps",
          followupUser: "Filtro: Usuário (Follow-up)",
        },
      },
      queueOptions: {
        title: "Opções",
        optionTitlePlaceholder: "Título da opção",
        optionMessagePlaceholder: "Digite o texto da opção",
        untitled: "Título não definido",
      },
      facebookSdk: {
        errors: {
          loadFailed: "Falha ao carregar o Facebook SDK",
          noAuthCode: "O Facebook não retornou um código de autorização. Verifique se o app está configurado para 'response_type=code'.",
          loginCancelled: "Login cancelado ou não autorizado pelo usuário.",
          startFailed: "Erro ao iniciar o Facebook Login",
        },
      },
      clienteQuickCreateModal: {
        title: "Novo Cliente",
        subtitle: "Cadastro rápido — preencha os dados principais.",
        personTypes: {
          company: "Pessoa Jurídica",
          individual: "Pessoa Física",
        },
        fields: {
          legalName: "Razão Social",
          nickname: "Apelido",
          areaCode: "DDD",
        },
        sections: {
          contact: "Contato",
          address: "Endereço",
          commercial: "Comercial",
          customFields: "Campos Personalizados",
        },
        buttons: {
          create: "Criar Cliente",
        },
        toasts: {
          nameRequired: "Informe o nome do cliente.",
          personTypeRequired: "Selecione o tipo de pessoa.",
          missingFields: "Preencha os campos obrigatórios: {{fields}}",
          missingCustomFields: "Preencha os campos personalizados obrigatórios: {{fields}}",
          created: "Cliente criado com sucesso!",
          networkUnstable: "Não foi possível salvar o cliente agora (instabilidade de conexão). Tente novamente em instantes.",
        },
      },
      clienteCustomFieldsForm: {
        selectPlaceholder: "Selecione...",
      },
      forbiddenWords: {
        title: "Termos proibidos",
        searchPlaceholder: "Pesquisar",
        table: {
          term: "Termo",
          replacement: "Substituição",
        },
        confirmationModal: {
          deleteTitle: "Remover termo",
          deleteMessage: "Tem certeza que deseja remover este termo?",
        },
        toasts: {
          deleted: "Termo removido com sucesso.",
        },
        modal: {
          title: {
            add: "Adicionar termo",
            edit: "Editar termo",
          },
          form: {
            term: "Termo / palavra",
            replacement: "Substituição sugerida (opcional)",
          },
          pluralHint: "As palavras cadastradas também são reconhecidas no plural.",
          toasts: {
            saved: "Termo salvo com sucesso.",
          },
        },
      },
      forbiddenWordsReport: {
        title: "Relatório de uso de termos proibidos",
        fields: {
          term: "Termo",
          user: "Atendente",
          occurrences: "Ocorrências",
          ticket: "Ticket",
        },
        total: "Total de ocorrências no período: {{total}}",
        byTerm: "Por termo",
        byUser: "Por atendente",
        details: "Detalhamento (últimas ocorrências)",
        noOccurrences: "Nenhuma ocorrência no período.",
      },
      tagPhrases: {
        title: "Frases que geram Tag",
        searchPlaceholder: "Pesquisar",
        fields: {
          phrase: "Frase",
          tag: "Tag aplicada",
          match: "Correspondência",
        },
        match: {
          exact: "Frase exata",
          contains: "Contém a frase",
        },
        status: {
          active: "Ativa",
          inactive: "Inativa",
        },
        confirmationModal: {
          deleteTitle: "Remover frase",
          deleteMessage: "Tem certeza que deseja remover esta frase? Os contatos já marcados mantêm a tag.",
        },
        toasts: {
          deleted: "Frase removida com sucesso.",
        },
        modal: {
          title: {
            add: "Adicionar frase",
            edit: "Editar frase",
          },
          hints: {
            exact: "A tag é aplicada quando a mensagem do cliente for exatamente esta frase, sem nada a mais.",
            contains: "A tag é aplicada quando a mensagem do cliente contiver esta frase, mesmo junto de outro texto.",
            general: "Em qualquer um dos modos, maiúsculas, minúsculas e acentos são ignorados. A tag é adicionada ao contato e ao atendimento em que a mensagem chegou, sem remover as tags que já existirem.",
          },
          toasts: {
            saved: "Frase salva com sucesso.",
          },
        },
      },
      pedidos: {
        title: "Pedidos",
        searchPlaceholder: "Buscar pedido...",
        buttons: {
          new: "Novo Pedido",
        },
        empty: "Nenhum pedido encontrado",
        itemsCount: "{{count}} item",
        itemsCount_plural: "{{count}} itens",
        tooltips: {
          view: "Visualizar",
          delete: "Deletar",
        },
        confirmationModal: {
          deleteTitle: "Deletar Pedido",
          deleteMessage: "Tem certeza que deseja deletar este pedido? Esta ação não pode ser desfeita.",
        },
        toasts: {
          deleted: "Pedido deletado com sucesso",
        },
        status: {
          pendente: "Pendente",
          confirmado: "Confirmado",
          em_producao: "Em Produção",
          enviado: "Enviado",
          entregue: "Entregue",
          cancelado: "Cancelado",
        },
        modal: {
          title: {
            add: "Novo Pedido",
            edit: "Editar Pedido",
          },
          sections: {
            orderData: "Dados do Pedido",
            items: "Itens do Pedido",
            totals: "Totais",
          },
          fields: {
            client: "Cliente",
            orderDate: "Data do Pedido",
            deliveryDate: "Data de Entrega",
            orderType: "Tipo de Pedido",
            orderTypePlaceholder: "Ex: Venda, Orçamento, Serviço",
            paymentMethod: "Forma de Pagamento",
            paymentMethodPlaceholder: "Ex: À vista, Cartão, Boleto",
            subtotal: "Subtotal",
            discount: "Desconto",
            surcharge: "Acréscimo (Frete, Taxas)",
            total: "Valor Total",
          },
          items: {
            code: "Código",
            quantity: "Qtd",
            unit: "UN",
            unitPrice: "Valor Unit.",
          },
          buttons: {
            addItem: "Adicionar Item",
            update: "Atualizar",
          },
          toasts: {
            minOneItem: "O pedido deve ter pelo menos um item",
            selectClient: "Selecione um cliente",
            addItem: "Adicione pelo menos um item ao pedido",
            fillDescriptions: "Preencha a descrição de todos os itens",
            updated: "Pedido atualizado com sucesso",
            created: "Pedido criado com sucesso",
          },
        },
      },
      solicitacoesDesenvolvimento: {
        title: "Desenvolvimento",
        count: "{{count}} solicitação",
        count_plural: "{{count}} solicitações",
        filters: {
          search: "Busca",
          searchPlaceholder: "Contato, telefone ou observação",
        },
        empty: "Nenhuma solicitação encontrada.",
        cardTitle: "#{{id}} - Ticket #{{ticketId}}",
        cardMeta: "Usuário: {{user}} | Criada em: {{date}}",
        noContact: "Sem contato",
        noPhone: "Sem telefone",
        noNotes: "Sem observação",
        toasts: {
          statusUpdated: "Status atualizado com sucesso.",
          contactNotResolved: "Não foi possível identificar ou criar o contato para abrir o chat.",
        },
        fields: {
          ticket: "Ticket",
          contact: "Contato",
          notes: "Observação",
        },
        details: {
          title: "Detalhes da solicitação de desenvolvimento",
          loadError: "Não foi possível carregar os detalhes.",
          fullNotes: "Observação completa",
          createdAt: "Criada em",
          finalizedAt: "Finalizada em",
          lastMessages: "Últimas mensagens capturadas",
          noTicket: "Ticket não disponível para carregar as mensagens.",
          noMarkedMessages: "Nenhuma mensagem marcada nesta solicitação.",
        },
        preview: {
          title: "Validar solicitação de desenvolvimento",
          notesPlaceholder: "Descreva a solicitação. Se deixar vazio, usaremos a observação automática.",
          lastMessages: "Últimas 10 mensagens trocadas",
          noMessages: "Nenhuma mensagem encontrada para este ticket.",
          sender: {
            system: "Sistema",
            agent: "Atendente",
            customer: "Cliente",
          },
          media: "[mídia]",
          confirm: "Confirmar e salvar",
        },
      },
      printPage: {
        noData: "Nenhum dado encontrado.",
        sheetName: "Relatório",
        fileName: "relatorio",
      },
      messageReceiptsModal: {
        noParticipants: "Nenhum participante",
        statusLabel: "Status da mensagem",
        status: {
          pending: "Pendente",
          read: "Lida",
          delivered: "Entregue",
          sent: "Enviada",
        },
        summary: {
          read: "Leram",
          delivered: "Receberam",
          played: "Ouviram",
          pending: "Pendentes",
        },
        tabs: {
          read: "Leram ({{count}})",
          delivered: "Receberam ({{count}})",
          played: "Ouviram ({{count}})",
        },
      },
      cloudApiWindowBanner: {
        expired: "Expirado",
        windowOpen: "Janela aberta: {{time}}",
        officialApi: "API Oficial",
        windowClosed: "Janela de 24h fechada. Envie um template para iniciar conversa.",
        noApprovedTemplates: "Nenhum template aprovado",
      },
      contactNotes: {
        toasts: {
          added: "Observação adicionada com sucesso!",
          deleted: "Observação excluída com sucesso!",
        },
        deleteModal: {
          title: "Excluir Registro",
          message: "Deseja realmente excluir este registro?",
        },
      },
      contactSearchModal: {
        title: "Selecionar Contato",
        searchLabel: "Buscar contato",
      },
      queueSelectDialog: {
        title: "Em qual fila abrir o chamado?",
      },
      forbiddenWordWarning: {
        title: "Atenção ao termo utilizado",
        usingWord: "Você está utilizando a palavra",
        replaceWith: ", substituir por",
        avoid: ". Evite usá-la nas mensagens ao cliente.",
        replace: "Substituir",
        sendAnyway: "Enviar mesmo assim",
      },
      commentThread: {
        reply: "Resposta",
        mediaAttached: "[mídia anexada]",
        title: "Thread de comentários — @{{username}}",
        post: "Post:",
        viewOnInstagram: "ver no Instagram",
        postId: "Post {{id}}",
        empty: "Nenhum comentário neste thread ainda.",
      },
      announcementsPopover: {
        referralText: "{{name}} fez uma indicação para este cliente",
        dateUnavailable: "Data não disponível",
        announcementsDivider: "ANÚNCIOS",
      },
      createKanbanCardModal: {
        toasts: {
          loadBoardsError: "Erro ao carregar quadros Kanban",
          selectBoardAndColumn: "Selecione um quadro e uma coluna",
          ticketNotFound: "Ticket não encontrado",
          requiredFieldsMissing: "Campos obrigatórios não preenchidos: {{fields}}",
          cardCreated: "Card criado com sucesso no Kanban!",
        },
        followUpSource: "criar o card",
        duplicate: {
          withDetails: "Já existe um card deste contato: \"{{title}}\" (#{{id}}) em {{board}} / {{column}}{{createdBy}}.",
          untitled: "sem título",
          createdBy: ", criado por {{name}}",
          simple: "Já existe um card deste contato.",
          blockedHint: "Escolha outro quadro ou outra coluna.",
          warnHint: "Clique em Criar Card para criar mesmo assim.",
        },
        info: {
          ticket: "Ticket:",
          contact: "Contato:",
          number: "Número:",
          noName: "Sem nome",
        },
        form: {
          title: "Título do Card",
          description: "Descrição do Card",
          descriptionRequired: "Obrigatória neste quadro",
          addDefaultDescription: "Adicionar descrição padrão: \"{{description}}\"",
          client: "Cliente",
          clientPlaceholder: "Digite para buscar um cliente...",
          clientNotFound: "Nenhum cliente encontrado",
          newClient: "Criar novo cliente",
          board: "Quadro Kanban",
          selectBoard: "Selecione um quadro",
          column: "Coluna",
          selectColumn: "Selecione uma coluna",
          boardFields: "Campos do quadro",
        },
        customField: {
          required: "Este campo é obrigatório",
          noOptions: "Nenhuma opção disponível",
          selectAtLeastOne: "(selecione pelo menos uma opção)",
        },
      },
      imobilizadoAutocomplete: {
        availability: "{{available}} de {{total}} disponível(is)",
        noOptions: "Nenhum imobilizado encontrado",
        minChars: "Digite ao menos {{min}} letras para buscar",
        loading: "Buscando no Empsis...",
      },
      followUpPrompt: {
        title: "Criar novo follow-up?",
        question: "Após {{source}}, deseja criar um novo follow-up agora?",
        confirm: "Sim, criar",
        sources: {
          default: "esta ação",
          registerCliente: "cadastrar o cliente",
        },
        popupBlocked: {
          title: "Popup bloqueado",
          message: "O navegador bloqueou o dashboard de follow-ups. Clique em \"Tentar novamente\" para abrir a popup.",
          tryAgain: "Tentar novamente",
        },
      },
      campaignReport: {
        title: "Relatório da {{name}}",
        campaignFallback: "Campanha",
        statusLine: "Status: {{status}} {{delivered}} de {{total}}",
        unnamedContact: "Contato sem nome",
        currentStatus: "Status atual: {{status}}.",
        cards: {
          targetContacts: "Contatos Alvo",
          confirmationRequested: "Confirmações Solicitadas",
          confirmed: "Confirmações",
          delivered: "Entregues",
          completedAt: "Conclusão",
        },
        sendStatuses: {
          success: "Sucesso",
          error: "Erro",
          waiting: "Aguardando",
        },
        table: {
          title: "Detalhes de Envio por Contato",
          ariaLabel: "detalhes de envio da campanha",
          contact: "Contato",
          number: "Número",
          sendStatus: "Status de Envio",
          statusDescription: "Descrição do Status",
          empty: "Nenhum registro de envio encontrado para esta campanha.",
        },
      },
      messagesReport: {
        title: "Relatório de Mensagens",
        noUser: "Sem responsável",
        noQueue: "Sem fila",
        hint: "Os filtros são cumulativos; em \"Tags do contato\", entra a conversa cujo contato tenha qualquer uma das tags escolhidas. O atendente é o responsável pelo ticket no momento da consulta; mensagens enviadas por outro operador aparecem sob o responsável atual — quando disponível, a assinatura de quem digitou é exibida na coluna Atendente.",
        buttons: {
          clearFilters: "Limpar filtros",
          exporting: "Exportando...",
        },
        filters: {
          term: "Termo (mensagem ou transcrição)",
          all: "Todas",
          sent: "Enviadas",
          received: "Recebidas",
          user: "Atendente (responsável do ticket)",
          typeMinChars: "Digite ao menos {{min}} caracteres",
          noContacts: "Nenhum contato encontrado",
          contactTags: "Tags do contato",
          queue: "Fila",
          whatsapp: "Conexão",
          includeDeleted: "Incluir apagadas",
        },
        totals: {
          total: "Total: {{value}}",
          received: "Recebidas: {{value}}",
          sent: "Enviadas: {{value}}",
        },
        directionLabels: {
          sent: "Enviada",
          received: "Recebida",
        },
        table: {
          dateTime: "Data/Hora",
          direction: "Direção",
          contact: "Contato",
          user: "Atendente",
          message: "Mensagem",
          queueConnection: "Fila / Conexão",
          inGroup: "no grupo:",
          typedBy: "digitou:",
          openAtMessage: "Abrir conversa nesta mensagem",
          empty: "Nenhuma mensagem encontrada para os filtros selecionados.",
        },
        export: {
          number: "Número",
          group: "Grupo",
          groupAuthor: "Autor (grupo)",
          signature: "Assinatura",
          queue: "Fila",
          whatsapp: "Conexão",
          transcription: "Transcrição",
          deleted: "Apagada",
          ticket: "Ticket",
          fileName: "relatorio-mensagens-{{start}}-a-{{end}}",
          sheetName: "Mensagens",
        },
        pagination: {
          rowsPerPage: "Linhas por página",
          displayedRows: "{{from}}-{{to}} de {{total}}",
        },
        toasts: {
          openFailed: "Não foi possível abrir a conversa desta mensagem.",
          nothingToExport: "Nenhuma mensagem para exportar com os filtros atuais.",
          exportLimited: "Exportação limitada a 5.000 mensagens. Refine o período ou os filtros para exportar o restante.",
        },
      },
      tabAlert: {
        newMessage: "Nova mensagem",
        newMessages: "Novas mensagens",
      },
      templateCreditManager: {
        categories: {
          MARKETING: "Marketing",
          UTILITY: "Utilidade",
          AUTHENTICATION: "Autenticação",
        },
        txTypes: {
          purchase: "Recarga",
          manual_adjust: "Ajuste manual",
          debit: "Débito",
          refund: "Estorno",
        },
        rates: {
          title: "Preços por categoria de template",
          fieldLabel: "{{category}} (R$ por envio)",
          save: "Salvar preços",
          hint: "Preço 0 = envio sem cobrança (mesmo para empresas habilitadas). Defina os preços antes de habilitar a cobrança das empresas.",
        },
        companies: {
          title: "Cobrança de templates por empresa",
          billingEnabled: "Cobrança habilitada",
          balance: "Saldo",
          companyDisabled: "(empresa desativada)",
          adjustBalance: "Ajustar saldo",
          statement: "Extrato",
          empty: "Nenhuma empresa encontrada.",
        },
        adjustDialog: {
          title: "Ajustar saldo — {{name}}",
          hint: "Saldo atual: {{balance}}. Use valor negativo para remover créditos.",
          amount: "Valor do ajuste (R$)",
          reason: "Motivo (obrigatório)",
          adjusting: "Ajustando...",
        },
        historyDialog: {
          title: "Extrato — {{name}}",
          category: "Categoria",
          template: "Template",
          source: "Origem",
          amount: "Valor",
          balanceAfter: "Saldo após",
          empty: "Nenhum movimento registrado.",
        },
        toasts: {
          ratesSaved: "Preços atualizados.",
          balanceAdjusted: "Saldo ajustado.",
        },
      },
      aiCreditManager: {
        topupStatus: {
          awaiting_payment: "Aguardando pagamento",
          pending: "Processando",
          credited: "Creditado",
          failed: "Falhou",
          cancelled: "Cancelada",
          reversed: "Estornada",
          reversalPending: "Estorno pendente",
          reversedAmount: "estornado {{amount}}",
        },
        toasts: {
          hubSyncError: "Salvo no CRM, mas o iaHub não foi atualizado (margem e aviso de saldo continuam como estavam): {{error}}",
          settingsSaved: "Configuração de créditos de IA salva.",
          billingEnabled: "Cobrança de IA ativada (pré-pago).",
          billingDisabled: "Cobrança de IA desativada (cortesia).",
          linkUpdated: "Vínculo com o iaHub atualizado.",
          topupCredited: "Recarga creditada no iaHub.",
          topupNotAccepted: "O iaHub ainda não aceitou a recarga.",
        },
        confirmLinkChange: {
          defaultDetails: "A empresa anterior no iaHub tem saldo comprado.",
          message: "Esse saldo continua na empresa anterior (que volta para cortesia) e as próximas recargas vão para a nova. Trocar mesmo assim?",
        },
        alerts: {
          notConfigured: "<strong>iaHub não configurado neste ambiente.</strong> Defina <code>AI_HUB_BASE_URL</code> e <code>AI_HUB_RESELLER_KEY</code> no .env do backend — sem elas não é possível vincular empresas nem creditar recargas.",
          zeroMarkup: "<strong>Margem em 0%.</strong> A revenda {{name}} está sem margem no iaHub: o consumo de IA dos clientes está sendo cobrado a preço de custo. Defina a margem por chamada abaixo.",
          outOfSync: "O limite de aviso de saldo ou a URL de notificação da revenda no iaHub estão diferentes deste CRM. Clique em <strong>Salvar</strong> para sincronizar.",
          hubError: "Não foi possível falar com o iaHub agora: {{error}}",
        },
        settings: {
          title: "Cobrança de IA deste ambiente",
          titleWithReseller: "Cobrança de IA deste ambiente — revenda {{name}}",
          markup: "Margem por chamada (%)",
          minCredit: "Crédito mínimo",
          maxCredit: "Crédito máximo",
          lowBalanceAlert: "Avisar abaixo de (R$)",
          hint: "A recarga é 1:1: {{amount}} pagos viram {{amount}} de crédito. A margem é somada ao custo da API em cada chamada de IA e fica gravada na revenda do iaHub — o cliente não a vê.",
          hintWithReseller: "A recarga é 1:1: {{amount}} pagos viram {{amount}} de crédito. A margem é somada ao custo da API em cada chamada de IA e fica gravada na revenda {{name}} do iaHub — o cliente não a vê.",
          noReseller: "Sem conexão com o iaHub a margem não pode ser lida nem alterada.",
        },
        pending: {
          title: "Recargas e estornos que não chegaram ao iaHub",
          hint: "O dinheiro entrou e o crédito não saiu — ou o pagamento foi estornado e o crédito ainda está lá. O sistema reenvia sozinho a cada hora; use o botão para forçar agora.",
          status: "Situação",
          credit: "Crédito",
          attempts: "Tentativas",
          action: "Ação",
          resend: "Reenviar",
          resending: "Enviando...",
        },
        companies: {
          title: "Empresas",
          hint: "Ligada = pré-pago (o cliente recarrega e a IA para quando zera). Desligada = cortesia (a casa paga; o consumo é medido, mas nunca bloqueia).",
          billing: "Cobrança",
          balance: "Saldo",
          updatedAt: "Atualizado",
          prepaid: "Pré-pago",
          courtesy: "Cortesia",
          agentOtherCompany: "\"{{prompts}}\" usa agente de \"{{company}}\" — o consumo é descontado lá",
          agentMissing: "\"{{prompts}}\" usa agente inexistente nesta revenda",
          notLinked: "não vinculada",
          blocked: "bloqueada",
          link: "Vincular",
          empty: "Nenhuma empresa encontrada.",
        },
        hubCompany: "Empresa no iaHub",
        linkDialog: {
          title: "Vincular {{name}} ao iaHub",
          noLink: "Sem vínculo",
          notConfirmed: "(não confirmada)",
          agentOwner: "dona do agente desta empresa",
          hint: "A recarga desta empresa credita o saldo da empresa escolhida aqui, e o hub desconta o consumo da empresa dona do agente — para cobrar, as duas precisam ser a mesma.",
          noAgents: "Esta empresa não tem prompt com agente deste iaHub.",
          agentOf: "\"{{prompts}}\": agente de \"{{company}}\"",
          agentOfUnknown: "\"{{prompts}}\": agente de empresa não encontrada nesta revenda",
          saveLink: "Salvar vínculo",
          saveAndCharge: "Salvar e cobrar",
        },
      },
      clienteCustomFieldsManager: {
        types: {
          text: "Texto",
          number: "Número",
          date: "Data",
          select: "Seleção única",
          multiselect: "Seleção múltipla",
          checkbox: "Checkbox",
          textarea: "Área de texto",
          email: "E-mail",
          phone: "Telefone",
          cpf: "CPF",
          cnpj: "CNPJ",
          cep: "CEP",
        },
        addButton: "Adicionar Campo Personalizado",
        table: {
          order: "Ordem",
          label: "Label",
          fieldName: "Nome do Campo",
          inReport: "No Relatório",
        },
        dialog: {
          editTitle: "Editar Campo Personalizado",
          newTitle: "Novo Campo Personalizado",
          fieldLabel: "Label do Campo (como aparecerá no formulário)",
          fieldName: "Nome do Campo (identificador interno)",
          fieldNameHelper: "Será convertido para formato válido automaticamente",
          fieldType: "Tipo de Campo",
          orderIndex: "Ordem de Exibição",
          options: "Opções (separadas por vírgula)",
          optionsHelper: "Ex: Opção 1, Opção 2, Opção 3",
          defaultValue: "Valor Padrão",
          required: "Campo Obrigatório",
          includeInReport: "Incluir este campo no relatório de clientes",
        },
        confirmDelete: "Tem certeza que deseja excluir este campo?",
        toasts: {
          loadError: "Erro ao carregar campos personalizados",
          nameAndLabelRequired: "Nome e Label são obrigatórios",
          updated: "Campo atualizado com sucesso",
          created: "Campo criado com sucesso",
          saveError: "Erro ao salvar campo personalizado",
          deleted: "Campo excluído com sucesso",
          deleteError: "Erro ao excluir campo",
        },
      },
      management: {
        restricted: "Esta tela é restrita ao administrador da plataforma.",
        tabs: {
          billing: "Faturamento",
          usage: "Uso do Sistema",
        },
      },
      billingManager: {
        tabs: {
          companies: "Por empresa",
          statement: "Extrato financeiro",
        },
        all: "Todas",
        companyDisabled: "(empresa desativada)",
        notDueYet: "A vencer",
        days: "{{count}} dia",
        days_plural: "{{count}} dias",
        daysOverdue: "{{count}} dia em atraso",
        daysOverdue_plural: "{{count}} dias em atraso",
        subscriptionStatus: {
          active: "Ativa",
          paymentFailed: "Cobrança falhou",
          cancelled: "Cancelada",
          paused: "Pausada",
          pending: "Pendente",
        },
        paymentStatus: {
          approved: "Recebido",
          pending: "Aguardando",
          rejected: "Recusado",
          cancelled: "Cancelado",
          refunded: "Estornado",
        },
        methods: {
          creditCard: "Cartão",
          other: "Outros",
        },
        types: {
          oneTime: "Avulso",
          recurring: "Assinatura",
        },
        columns: {
          plan: "Plano",
          dueDate: "Vencimento",
          status: "Situação",
          subscription: "Assinatura",
          lastCharge: "Última cobrança",
          lastPayment: "Último pagamento",
          method: "Forma",
          value: "Valor",
          balance: "Saldo",
          periodBalance: "Saldo do período",
          mpPaymentId: "ID Mercado Pago",
          origin: "Origem",
          daysOverdue: "Dias em atraso",
          entries: "Lançamentos",
          cardShare: "% do card",
        },
        origin: {
          invoice: "Fatura",
          invoiceNumber: "Fatura #{{id}}",
          companyDueDate: "Vencimento da empresa",
        },
        companies: {
          title: "Faturamento das empresas",
          filter: "Filtro",
          filters: {
            overdue: "Vencidas",
            blocked: "Bloqueadas",
            subscriptionActive: "Assinatura ativa",
            subscriptionFailed: "Assinatura com falha",
          },
          showInactive: "Ver inativas ({{total}})",
          perMonth: "{{value}}/mês",
          situation: {
            blocked: "Bloqueada",
            gracePeriod: "Em carência",
            upToDate: "Em dia",
          },
          amountDiverges: "Assinatura em {{subscriptionAmount}} mas o plano custa {{planAmount}} — assinante mantém o valor antigo até reassinar",
          lastCharge: {
            approved: "aprovada",
            rejected: "recusada",
          },
          paymentStatus: {
            approved: "Aprovado",
            rejected: "Recusado",
            pending: "Pendente",
            cancelled: "Cancelado",
            refunded: "Estornado",
          },
          empty: "Nenhuma empresa encontrada para o filtro selecionado.",
        },
        detail: {
          fileFallback: "detalhe",
          entries: "{{count}} lançamento",
          entries_plural: "{{count}} lançamentos",
          clients: "{{count}} cliente",
          clients_plural: "{{count}} clientes",
          empty: "Nenhum lançamento compõe este valor.",
          byClient: "Por cliente",
          details: "Detalhes",
        },
        statement: {
          periods: {
            thisMonth: "Este mês",
            lastMonth: "Mês passado",
            last7: "Últimos 7 dias",
            last30: "Últimos 30 dias",
            thisYear: "Este ano",
            custom: "Personalizado",
          },
          cardHint: "clique para ver o detalhamento",
          periodRange: "{{start}} a {{end}}",
          periodSubtitle: "Período de {{period}}",
          currentPositionSubtitle: "Posição atual — independe do período filtrado",
          export: {
            period: "{{start}}_a_{{end}}",
            statementFile: "extrato",
            receivablesFile: "a_receber",
          },
          period: "Período",
          cards: {
            received: {
              title: "Recebido no período",
              caption: "{{total}} pagamento(s) — {{period}}",
            },
            awaiting: {
              title: "Aguardando pagamento",
              caption: "{{total}} cobrança(s) gerada(s) e não paga(s)",
            },
            pending: {
              title: "A vencer (a receber)",
              caption: "{{total}} fatura(s) em aberto — posição atual",
            },
            overdue: {
              title: "Em atraso",
              caption: "{{total}} cobrança(s) vencida(s) — posição atual",
            },
          },
          failedSummary: "{{total}} tentativa(s) recusada(s) no período, somando {{amount}}.",
          failedTitle: "Tentativas recusadas",
          viewWhich: "Ver quais",
          tabs: {
            statement: "Extrato do período",
            pending: "A vencer ({{total}})",
            overdue: "Em atraso ({{total}})",
          },
          statusFilter: {
            approved: "Só recebidos",
            all: "Todas as transações",
            pending: "Aguardando",
            rejected: "Recusados",
            refunded: "Estornados",
          },
          order: "Ordem",
          orderOptions: {
            asc: "Mais antigo primeiro",
            desc: "Mais recente primeiro",
          },
          totalShown: "Total exibido ({{count}} lançamento)",
          totalShown_plural: "Total exibido ({{count}} lançamentos)",
          noTransactions: "Nenhuma transação no período selecionado.",
          dueFilter: {
            all: "Todas (posição atual)",
            period: "Só as que vencem no período",
          },
          estimatedValue: "valor estimado pela composição do plano",
          totalCharges: "Total ({{count}} cobrança)",
          totalCharges_plural: "Total ({{count}} cobranças)",
          nothingOverdue: "Nada em atraso no filtro selecionado.",
          nothingPending: "Nada a vencer no filtro selecionado.",
        },
      },
      companyStorage: {
        title: "Armazenamento de arquivos",
        subtitle: "Espaço em disco ocupado pelos arquivos de cada empresa. Não depende do período filtrado.",
        column: "Armazenamento",
        diskTotal: "Total em disco",
        attributed: "Atribuído às empresas",
        unattributed: "Sem vínculo",
        files: "{{count}} arquivo",
        files_plural: "{{count}} arquivos",
        attributedHint: "Arquivos usados por mais de uma empresa (como fotos de perfil) entram no total de cada uma, mas aqui contam uma vez só.",
        unattributedHint: "Arquivos no disco que nenhum registro do banco aponta, então não dá para saber de qual empresa são (ex.: cópia do upload em envios pelo WhatsApp, áudio convertido, mídia de mensagem apagada).",
        updatedAt: "Atualizado em {{date}}",
        neverCalculated: "Ainda não calculado. Clique em Recalcular.",
        running: "Calculando...",
        runningHint: "O cálculo roda em segundo plano e pode levar alguns minutos.",
        refresh: "Recalcular",
        refreshStarted: "Cálculo iniciado. A tela atualiza sozinha ao terminar.",
        lastError: "O último cálculo falhou: {{error}}",
        ranking: "Empresas que mais ocupam espaço",
        rankingShowing: "{{shown}} de {{total}} empresas com arquivos",
        noFiles: "Nenhum arquivo",
        loadError: "Não foi possível carregar o armazenamento.",
        categories: {
          messages: "Mensagens",
          profilePics: "Fotos de perfil",
          quickMessages: "Respostas rápidas",
          internalChat: "Chat interno",
          campaigns: "Campanhas e agendamentos",
          others: "Outros",
        },
      },
      clientUsageManager: {
        health: {
          ativo: "Ativo",
          atencao: "Atenção",
          inativo: "Inativo",
        },
        periods: {
          last7: "Últimos 7 dias",
          last30: "Últimos 30 dias",
          last90: "Últimos 90 dias",
          custom: "Personalizado",
        },
        situations: {
          todos: "Todas as situações",
          ativo: "Ativos",
          atencao: "Atenção",
          inativo: "Inativos",
        },
        idle: {
          never: "nunca usou",
          today: "hoje",
        },
        dueDate: {
          none: "sem vencimento",
          due: "vence {{date}}",
        },
        search: "Buscar cliente",
        volumePeriod: "Período do volume",
        situation: "Situação",
        showDisabled: "Ver inativadas ({{total}})",
        clearFilters: "Limpar filtros",
        legend: "Situação: verde até 2 dias parado, amarelo de 3 a 7, vermelho acima de 7 — conta a atividade mais recente entre mensagens e login. Em \"chamados\", o par é abertos/finalizados no período.",
        columns: {
          client: "Cliente",
          lastMessage: "Última mensagem",
          lastLogin: "Último login",
          connections: "Conexões",
          users: "Usuários",
          volume: "Volume no período",
          plan: "Plano",
        },
        companyDisabled: "empresa inativada",
        since: "desde {{date}}",
        contacts: "{{total}} contatos",
        sentAt: "{{date}} env.",
        receivedAt: "{{date}} rec.",
        loginEstimated: "Estimado: este usuário ainda não entrou desde que o registro de login foi criado.",
        noUser: "nenhum usuário",
        connectionsCaption: "limite {{limit}} · {{drops}} quedas",
        noConnection: "sem conexão",
        usersCaption: "{{active}} ativos 30d · {{online}} on",
        volumeLine: "{{sent}} env · {{received}} rec",
        ticketsCaption: "chamados {{created}}/{{finished}} · {{active}} aberto",
        noPlan: "sem plano",
        empty: "Nenhum cliente encontrado para o filtro selecionado.",
      },
      financeiro: {
        paymentStatus: {
          approved: "Aprovado",
          pending: "Pendente",
          rejected: "Recusado",
          cancelled: "Cancelado",
          refunded: "Estornado",
        },
        invoiceStatus: {
          paid: "Pago",
          overdue: "Vencido",
          open: "Em Aberto",
        },
        toasts: {
          chargeFailed: "A cobrança da sua assinatura falhou: {{reason}}",
          subscriptionCancelled: "Assinatura cancelada. Sua licença continua válida até o vencimento atual.",
        },
        license: {
          unavailable: "Situação da licença indisponível",
          noExpiration: "Licença ativa, sem vencimento",
          overdue: "Licença vencida há {{count}} dia",
          overdue_plural: "Licença vencida há {{count}} dias",
          overdueDetail: "Venceu em {{date}}. Pague a mensalidade para continuar usando o sistema.",
          dueToday: "Licença vence hoje",
          dueDate: "Vencimento: {{date}}",
          dueIn: "Licença vence em {{count}} dia",
          dueIn_plural: "Licença vence em {{count}} dias",
          upToDate: "Licença em dia",
          validUntil: "Válida até {{date}}",
        },
        cancelModal: {
          title: "Cancelar assinatura automática?",
          message: "A cobrança automática mensal no seu cartão será cancelada. Sua licença continua válida até o vencimento atual e você poderá pagar avulso (Pix ou cartão) quando quiser.",
        },
        plan: "Plano",
        planNamed: "Plano {{name}}",
        perMonth: "{{value}}/mês",
        autoRenewActive: "Renovação automática ativa",
        monthlyCardDebit: "Débito mensal no cartão.",
        monthlyCardDebitEmail: "Débito mensal no cartão ({{email}}).",
        cancelRenewal: "Cancelar renovação",
        lastChargeDeclined: "A última cobrança no cartão foi recusada e a licença não foi renovada. Pague a mensalidade abaixo (Pix ou cartão).",
        regularizeNow: "Regularizar agora",
        payMonthlyFee: "Pagar mensalidade",
        pixOrCard: "Pix ou cartão de crédito",
        preferAutoRenew: "Prefiro ativar a renovação automática no cartão →",
        nothingToDo: "Nada a fazer — sua licença renova sozinha todo mês.",
        managePlan: "Gerenciar plano — usuários e conexões adicionais, troca de plano",
        changePlan: "Trocar de plano",
        invoicesAndHistory: "Faturas e histórico de pagamentos",
        invoicesAndHistoryOpen: "Faturas e histórico de pagamentos ({{count}} em aberto)",
        invoices: "Faturas",
        table: {
          details: "Detalhes",
          value: "Valor",
          dueDate: "Data Venc.",
          action: "Ação",
          method: "Método",
        },
        pay: "PAGAR",
        paid: "PAGO",
        loadMoreInvoices: "Carregar mais faturas",
        paymentHistory: "Histórico de pagamentos",
        noPayments: "Nenhum pagamento registrado ainda.",
        paymentType: {
          recurring: "Assinatura",
          oneTime: "Avulso",
        },
        paymentMethod: {
          creditCard: "Cartão de crédito",
        },
      },
      subscription: {
        title: "Assinatura",
        licenseValidity: "Validade da licença",
        validUntil: "Sua licença é válida até {{date}}",
        noExpiration: "Sem vencimento definido",
        billingEmail: "Email de cobrança",
        subscribeNow: "Assine Agora!",
      },
      checkout: {
        statusDetail: {
          insufficientAmount: "Cartão sem limite disponível.",
          badCardNumber: "Número do cartão inválido.",
          badDate: "Data de validade inválida.",
          badSecurityCode: "Código de segurança inválido.",
          badOther: "Dados do cartão inválidos.",
          callForAuthorize: "O banco pediu autorização — ligue para a operadora do cartão.",
          cardDisabled: "Cartão desativado — contate a operadora.",
          duplicatedPayment: "Pagamento duplicado detectado.",
          highRisk: "Pagamento recusado pela análise antifraude.",
          maxAttempts: "Limite de tentativas atingido — tente mais tarde.",
          otherReason: "Pagamento recusado pela operadora do cartão.",
          default: "Pagamento recusado. Verifique os dados ou tente outro cartão.",
        },
        brickErrors: {
          cardNumberEmpty: "Informe o número do cartão.",
          cardNumberIncomplete: "Número do cartão incompleto.",
          cardNumberInvalid: "Cartão inválido — confira o número digitado.",
          expirationDateEmpty: "Informe a data de vencimento do cartão.",
          expirationDateIncomplete: "Data de vencimento incompleta.",
          expirationDateInvalid: "Data de vencimento inválida.",
          securityCodeEmpty: "Informe o código de segurança.",
          securityCodeIncomplete: "Código de segurança incompleto.",
          securityCodeInvalid: "Código de segurança inválido.",
          cardholderNameEmpty: "Informe o nome do titular como aparece no cartão.",
          emailEmpty: "Informe o e-mail.",
          emailInvalid: "E-mail inválido.",
          identificationNumberEmpty: "Informe o CPF/CNPJ do titular.",
          identificationNumberInvalid: "CPF/CNPJ inválido.",
          identificationTypeEmpty: "Selecione o tipo de documento.",
          paymentMethodNotFound: "Não reconhecemos a bandeira desse cartão.",
          installmentsEmpty: "Selecione o número de parcelas.",
          critical: "Não foi possível processar o formulário de pagamento. Recarregue a página e tente novamente.",
          generic: "Dados do cartão inválidos. Confira as informações e tente novamente.",
        },
        title: {
          templateCredit: "Comprar créditos de template",
          aiCredit: "Comprar créditos de IA",
          addon: "Pagar add-ons do plano",
          renewal: "Renovar licença",
        },
        hint: {
          templateCredit: "Pix ou cartão de crédito — os créditos entram no seu saldo assim que o pagamento for aprovado",
          aiCredit: "Pix ou cartão de crédito — os créditos de IA entram no seu saldo assim que o pagamento for aprovado",
          addon: "Pix ou cartão de crédito — libera os add-ons contratados até o fim do ciclo",
          renewal: "Pix ou cartão de crédito — renova sua licença por 1 mês",
        },
        toasts: {
          approvedTemplateCredit: "Pagamento aprovado! Seus créditos de template foram adicionados.",
          approvedAiCredit: "Pagamento aprovado! Seus créditos de IA foram adicionados.",
          approvedAddon: "Pagamento aprovado! Seus add-ons foram liberados.",
          approvedRenewal: "Pagamento aprovado! Sua licença foi renovada.",
          processing: "Pagamento em processamento. Você será avisado quando for confirmado.",
          subscriptionActivated: "Assinatura ativada! A renovação será feita automaticamente todo mês no seu cartão.",
        },
        pixUnavailableSupport: "Pagamento por Pix indisponível no momento. Entre em contato com o suporte para regularizar a mensalidade.",
        pixUnavailableCard: "Pagamento por Pix indisponível no momento. Conclua o pagamento com cartão de crédito no formulário abaixo.",
        brickBlocked: "Seu navegador bloqueou o formulário de cartão do Mercado Pago (bloqueador de anúncios ou proteção contra rastreamento). Desative a extensão para esta página e recarregue para pagar com cartão.",
        unavailableTitle: "Pagamento indisponível",
        missingPublicKey: "A chave pública do Mercado Pago (REACT_APP_MP_PUBLIC_KEY) não está configurada. Contate o suporte.",
        tabs: {
          payInvoice: "Pagar fatura",
          autoSubscription: "Assinatura automática",
        },
        invoiceError: "Não foi possível gerar a fatura de renovação para esta empresa. Verifique o plano contratado ou contate o suporte.",
        noOpenInvoice: "Nenhuma fatura em aberto para pagamento.",
        invoiceDue: "{{detail}} — vencimento {{date}}",
        payWithPix: "Pagar com Pix (QR Code)",
        subscriptionActiveChip: "Assinatura ativa",
        subscriptionAlreadyActive: "Sua assinatura já está ativa no cartão. A renovação é automática todo mês. Para trocar de cartão, cancele a assinatura na tela Financeiro e assine novamente.",
        subscriptionAlreadyActiveEmail: "Sua assinatura já está ativa no cartão ({{email}}). A renovação é automática todo mês. Para trocar de cartão, cancele a assinatura na tela Financeiro e assine novamente.",
        autoDebit: "Débito mensal automático no cartão de crédito",
        autoDebitPlan: "Débito mensal automático no cartão de crédito — plano {{plan}}",
        perMonth: "{{value}}/mês",
        autoRenewInfo: "Quando o Mercado Pago confirmar o débito, sua licença renova sozinha. Cancele quando quiser.",
        payPixMeanwhile: "Enquanto isso, você pode pagar a fatura deste mês por Pix na aba \"{{tab}}\".",
        noPlanValue: "Empresa sem plano com valor definido — contate o suporte.",
        success: {
          licenseRenewed: "Sua licença foi renovada até {{date}}!",
          qrAlt: "QR Code Pix",
          copied: "Copiado",
          copyPixCode: "Copiar código Pix",
          instructions: "Para finalizar, basta realizar o pagamento escaneando ou colando o código Pix acima :)",
        },
      },
      changePlanDialog: {
        changed: "Plano alterado para {{plan}}. O novo valor vale a partir da próxima renovação.",
        title: "Trocar de plano",
        currentPlan: "Plano atual:",
        perMonth: "{{value}}/mês",
        newPlan: "Novo plano",
        planOption: "{{name}} — {{value}}/mês ({{users}} usuários, {{connections}} conexões)",
        newValueNote: "O período já pago continua até o vencimento atual. A partir da próxima renovação o valor passa a ser",
        autoDebitUpdate: "O débito automático no seu cartão será atualizado para o novo valor — não precisa recadastrar o cartão.",
        confirm: "Confirmar troca",
      },
      planAddons: {
        changeStatus: {
          pendingPayment: "Aguardando pagamento do pró-rata",
          applying: "Aplicando...",
          scheduled: "Redução agendada para o próximo ciclo",
          requiresNewCard: "Aguardando recadastro do cartão",
        },
        toasts: {
          addonsApplied: "Add-ons contratados e liberados!",
          payProrata: "Pague o pró-rata para liberar os add-ons. Abrindo o pagamento...",
          downgradeScheduled: "Redução agendada: valor e limites atuais valem até o fim do ciclo.",
          requestCancelled: "Alteração pendente cancelada.",
          subscriptionMigrated: "Assinatura migrada com sucesso! Alterações pendentes foram aplicadas.",
        },
        unitPrice: "({{value}}/mês cada)",
        title: "Meu plano",
        planChip: "{{description}} — {{value}}/mês",
        limits: "Limites: {{users}} usuário(s) ({{usersInUse}} em uso) · {{connections}} conexão(ões) ({{connectionsInUse}} em uso)",
        extraUsers: "Usuário(s) adicional(is)",
        extraConnections: "Conexão(ões) adicional(is)",
        pending: {
          users: "{{count}} usuário",
          users_plural: "{{count}} usuários",
          connections: "{{count}} conexão",
          connections_plural: "{{count}} conexões",
          usersAndConnections: "{{users}} e {{connections}}",
          upgrade: "Adição de {{items}}",
          downgrade: "Redução de {{items}}",
          newMonthlyFee: "nova mensalidade {{value}}",
          effectiveFrom: "a partir de {{date}}",
          prorata: "(pró-rata: {{value}})",
        },
        payProrata: "Pagar pró-rata",
        replaceCard: "Recadastrar cartão",
        simulation: {
          newMonthlyFee: "Nova mensalidade:",
          prorataNow: "Para liberar agora, pague o proporcional do {{count}} dia restante do ciclo:",
          prorataNow_plural: "Para liberar agora, pague o proporcional dos {{count}} dias restantes do ciclo:",
          noChargeNow: "Sem cobrança agora — os add-ons são liberados na hora e o novo valor entra na próxima renovação.",
          hireAndPay: "Contratar e pagar {{value}}",
          hireAddons: "Contratar add-ons",
          newMonthlyNextCycle: "Nova mensalidade a partir do próximo ciclo:",
          noRefund: "(sem reembolso do período atual)",
          usageWarning: "Atenção: o novo limite fica abaixo do uso atual — nada será excluído, mas novas criações ficarão bloqueadas.",
          scheduleReduction: "Agendar redução",
        },
        undo: "Desfazer",
        replaceDialog: {
          title: "Recadastrar cartão da assinatura",
          description: "Sua assinatura atual foi criada no modelo antigo do Mercado Pago e não permite alterar o valor. Cadastre o cartão para criarmos a assinatura nova de {{value}}/mês — a antiga é cancelada automaticamente, sem cobrança duplicada.",
        },
      },
      templateCredit: {
        categories: {
          marketing: "Marketing",
          utility: "Utilidade",
          authentication: "Autenticação",
        },
        txTypes: {
          purchase: "Recarga",
          manualAdjust: "Ajuste",
          debit: "Débito",
          refund: "Estorno",
        },
        title: "Créditos de template (API Oficial)",
        ratesIntro: "Cada envio de template desconta o valor da categoria:",
        ratesUndefined: "preços ainda não definidos",
        otherValue: "Outro valor",
        generating: "Gerando...",
        buy: "Comprar créditos",
        showStatement: "Ver extrato",
        hideStatement: "Ocultar extrato",
        table: {
          template: "Template",
          value: "Valor",
          balanceAfter: "Saldo após",
        },
        noMovements: "Nenhum movimento registrado.",
      },
      aiCredit: {
        topupStatus: {
          awaitingPayment: "Aguardando pagamento",
          pending: "Processando",
          credited: "Creditado",
          failed: "Em verificação",
          cancelled: "Cancelada",
          reversed: "Estornada",
          withReversal: "{{label}} (estornado {{value}})",
        },
        title: "Créditos de IA",
        monthUsage: "{{calls}} interações da IA neste mês · {{value}} consumidos",
        consumptionInfo: "O saldo é consumido conforme o uso do agente de IA.",
        stale: "(saldo da última sincronização)",
        blockedTitle: "IA pausada por falta de saldo.",
        blockedHint: "Recarregue para o agente voltar a responder.",
        lowBalance: "Saldo baixo. Ao zerar, o agente de IA para de responder.",
        otherCreditValue: "Outro valor de crédito",
        generating: "Gerando...",
        buy: "Comprar créditos",
        showUsage: "Ver consumo",
        hideUsage: "Ocultar consumo",
        usageByDay: "Consumo por dia",
        table: {
          day: "Dia",
          interactions: "Interações",
          consumption: "Consumo",
          status: "Situação",
          credit: "Crédito",
          paid: "Pago",
        },
        noUsage: "Nenhum consumo no período.",
        topups: "Recargas",
        noTopups: "Nenhuma recarga registrada.",
      },
      attendanceMonitor: {
        title: "Monitoramento de Atendimentos",
        subtitle: "Medianas de espera e atendimento: mês atual até hoje",
        alarmsOn: "Alarmes: ON ({{minutes}} min)",
        alarmsOff: "Alarmes: OFF",
        autoRefreshOn: "Auto-atualização: ON",
        autoRefreshOff: "Auto-atualização: OFF",
        toasts: {
          loadError: "Erro ao carregar dados de monitoramento",
          alarmsEnabled: "Alarmes ativados",
          alarmsDisabled: "Alarmes desativados",
          alarmsUpdateError: "Erro ao atualizar status dos alarmes",
          openTicketError: "Erro ao abrir conversa",
        },
        summary: {
          queues: "Filas",
          waiting: "Aguardando",
          attendants: "Atendentes",
          online: "Online",
          offline: "Offline",
          inService: "Em Atendimento",
          medianWait: "Mediana de Espera",
          medianService: "Mediana de Atendimento",
        },
        tabs: {
          inService: "Em atendimento",
          waiting: "Aguardando",
          all: "Todos",
          online: "Online",
          offline: "Offline",
        },
        search: {
          attendantOrQueue: "Buscar atendente ou fila",
          queue: "Buscar fila",
          attendant: "Buscar atendente",
        },
        alarmTickets: "Tickets em alarme ({{total}})",
        sections: {
          queues: "Filas",
          attendants: "Atendentes",
        },
        queueBadge: "Fila",
        emptyQueue: "Nenhum chamado aberto para esta fila.",
        emptyAttendant: "Nenhum chamado aberto para este atendente.",
        waitingTooltip: "Tempo aguardando resposta",
        queueTotal: "Total de chamados na fila:",
        attendantTotal: "Total de chamados abertos:",
        noQueues: "Nenhuma fila encontrada",
        noAttendants: "Nenhum atendente encontrado",
        status: {
          online: "Online",
          offline: "Offline",
        },
      },
      usageReport: {
        title: "Relatório de Utilização do Sistema",
        tabs: {
          general: "Geral",
          forwarding: "Encaminhamentos",
        },
        filters: {
          profile: "Perfil",
          user: "Usuário",
          senderUser: "Usuário Origem",
          receiverUser: "Usuário Destino",
          historyType: "Tipo de Histórico",
        },
        profiles: {
          admin: "Administrador",
        },
        buttons: {
          printGeneral: "Imprimir Geral",
          printDetailed: "Imprimir Detalhado",
          printForwarding: "Imprimir Encaminhamento",
        },
        periodLabel: "Período: {{period}}",
        periodRange: "{{from}} até {{to}}",
        invalidPeriod: "Período inválido",
        generatedAt: "Gerado em: {{date}}",
        toasts: {
          invalidDates: "Informe datas válidas no formato correto",
          dateRange: "A Data Inicial não pode ser maior que a Data Final",
          detailsError: "Erro ao carregar detalhes dos relacionamentos",
          usersError: "Erro ao carregar lista de usuários",
          reportError: "Erro ao carregar relatório de utilização do sistema",
          forwardingError: "Erro ao carregar relatório de encaminhamentos",
          detailedPrintError: "Erro ao gerar impressão detalhada",
        },
        columns: {
          user: "Usuário",
          registrations: "Cadastros",
          totalContacts: "Total de Contatos",
          orders: "Pedidos",
        },
        clickForDetails: "Clique para ver detalhes de {{type}}",
        chart: {
          contactsByUserType: "Contatos por Usuário — {{type}}",
          totalContactsByUser: "Total de Contatos por Usuário",
        },
        emptyGeneral: "Selecione um período e clique em Filtrar para gerar o relatório",
        emptyForwarding: "Selecione um período e clique em Filtrar para gerar o relatório de encaminhamentos",
        files: {
          generalExcel: "relatorio-uso-geral-{{from}}-{{to}}",
          generalSheet: "Relatório Geral",
          forwardingExcel: "relatorio-encaminhamentos-{{from}}-{{to}}",
          generalPrint: "Relatorio_Utilizacao_Geral_{{from}}_{{to}}",
          detailedPrint: "Relatorio_Utilizacao_Detalhado_{{from}}_{{to}}",
          forwardingPrint: "Relatorio_Encaminhamentos_{{from}}_{{to}}",
        },
        forwarding: {
          reportTitle: "Relatório de Encaminhamentos",
          types: {
            move: "Movimentação",
            copy: "Cópia",
            create: "Criação",
          },
          createdTitle: "Criação de Cards",
          createdEmpty: "Nenhum card criado no período.",
          cardsCreated: "Cards Criados",
          forwardedTitle: "Cards Encaminhados a Outros Usuários",
          forwardedEmpty: "Nenhum card encaminhado a outro usuário no período.",
          origin: "Origem",
          destination: "Destino",
          quantity: "Quantidade",
          totalAllDestinations: "Total (todos os destinos)",
          rowsPerPage: "Destinos por página",
          displayedRows: "{{from}}-{{to}} de {{total}} destinos",
        },
        print: {
          noData: "Nenhum dado disponível para impressão.",
          generalTitle: "Relatório de Utilização - Geral",
          detailedTitle: "Relatório de Utilização - Detalhado por Usuário",
          totalRecords: "Total de registros: {{total}}",
          noRecordsForFilters: "Nenhum registro encontrado para os filtros selecionados.",
          noTypeSummary: "Sem atendimentos por tipo",
          unknownUser: "Usuário não identificado",
        },
        details: {
          contactDate: "Data Contato",
          client: "Cliente",
          contactMethod: "Meio Contato",
          contactMethodFull: "Meio de Contato",
          result: "Resultado",
          nextAction: "Próxima Ação",
          nextActionDate: "Data Próx. Ação",
          reasons: "Motivos",
        },
        reasons: {
          followUp: "Follow Up",
          meetings: "Reuniões",
          calls: "Ligações",
          visits: "Visitas",
          emails: "E-mails",
          quotes: "Orçamentos",
          negotiations: "Negociações",
          closings: "Fechamentos",
          afterSales: "Pós Venda",
          complaints: "Reclamações",
          referrals: "Indicações",
          others: "Outros",
        },
        modal: {
          title: "Detalhamento - {{user}} - {{type}}",
          totalRecords: "Total de registros:",
          emptyText: "Não há dados disponíveis para o período selecionado.",
          printSubtitle: "Período: {{period}} | Total: {{total}} | Impresso em: {{date}}",
        },
      },
    },
  },
};

export { messages };
